/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(44);
	module.exports = __webpack_require__(133);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(10))(484);

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ComponentRegistery = function () {
	    function ComponentRegistery() {
	        _classCallCheck(this, ComponentRegistery);
	
	        this.components = {};
	        this.stores = {};
	        this.storeGenerators = {};
	    }
	
	    ComponentRegistery.prototype.register = function register(component) {
	        this.components = Object.assign(this.components, component);
	    };
	
	    ComponentRegistery.prototype.registerStore = function registerStore(store) {
	        this.storeGenerators = Object.assign(this.storeGenerators, store);
	    };
	
	    ComponentRegistery.prototype.initializeStore = function initializeStore(name, initialValue) {
	        this.stores[name] = this.storeGenerators[name](initialValue);
	    };
	
	    ComponentRegistery.prototype.get = function get(name) {
	        return this.components[name];
	    };
	
	    ComponentRegistery.prototype.getStore = function getStore(name) {
	        return this.stores[name];
	    };
	
	    return ComponentRegistery;
	}();
	
	var instance = new ComponentRegistery();
	
	exports.default = instance;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(10))(177);

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) {/**/}
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[0],
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		} else if ((typeof target !== 'object' && typeof target !== 'function') || target == null) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = extend(deep, clone, copy);
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							target[name] = copy;
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(10))(419);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(7);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _reflux = __webpack_require__(249);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AbstractStore = function () {
	    function AbstractStore(actions) {
	        _classCallCheck(this, AbstractStore);
	
	        this.store = _reflux2.default.createStore({});
	        this.actions = _reflux2.default.createActions(actions);
	
	        this.listenToMany(this.actions);
	    }
	
	    AbstractStore.prototype.listenTo = function listenTo(action, handler) {
	        this.store.listenTo(action, handler);
	    };
	
	    AbstractStore.prototype.listenToMany = function listenToMany(actions) {
	        var _this = this;
	
	        for (var action in actions) {
	            if (actions.hasOwnProperty(action)) {
	                (function () {
	                    var actionName = '' + action;
	                    var handlerName = 'on' + actionName.substring(0, 1).toUpperCase() + actionName.substring(1);
	                    _this.store.listenTo(actions[action], function () {
	                        var handler = _this[handlerName].bind(_this);
	                        if (handler) {
	                            handler.apply(undefined, arguments);
	                        }
	                    });
	                })();
	            }
	        }
	    };
	
	    AbstractStore.prototype.listen = function listen(handler) {
	        return this.store.listen(handler);
	    };
	
	    AbstractStore.prototype.trigger = function trigger() {
	        var _store;
	
	        (_store = this.store).trigger.apply(_store, arguments);
	    };
	
	    return AbstractStore;
	}();
	
	exports.default = AbstractStore;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(7);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(6);
	
	var _Actions = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = vendor;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _propertyUtils = __webpack_require__(88);
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	var getComputedStyleX = void 0;
	
	function force(x, y) {
	  return x + y;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box = void 0;
	  var x = void 0;
	  var y = void 0;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = elem.ownerDocument;
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = (0, _propertyUtils.getTransitionProperty)(elem) || '';
	    (0, _propertyUtils.setTransitionProperty)(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = presetH + 'px';
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = presetV + 'px';
	  }
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  force(elem.offsetTop, elem.offsetLeft);
	  if ('left' in offset || 'top' in offset) {
	    (0, _propertyUtils.setTransitionProperty)(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	
	function setTransform(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = (0, _propertyUtils.getTransformXY)(elem);
	  var resultXY = { x: originalXY.x, y: originalXY.y };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  (0, _propertyUtils.setTransformXY)(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && (0, _propertyUtils.getTransformName)() in document.body.style) {
	    setTransform(elem, offset, option);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = void 0;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = void 0;
	  var j = void 0;
	  var i = void 0;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = '' + prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val = void 0;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i = void 0;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      utils.mix(ret, args[i]);
	    }
	    return ret;
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);
	
	exports["default"] = utils;
	module.exports = exports['default'];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.hasTouch = hasTouch;
	exports.getItem = getItem;
	exports.getItems = getItems;
	exports.replaceItem = replaceItem;
	exports.updateItem = updateItem;
	exports.removeItem = removeItem;
	exports.getPosition = getPosition;
	exports.getObject = getObject;
	exports.uuid = uuid;
	exports.queryStringToObject = queryStringToObject;
	exports.objectToQueryString = objectToQueryString;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if the device is touch only
	 */
	function hasTouch() {
	    // works on most browsers           // works on ie10;
	    var hasTouch = !!('ontouchstart' in window) || !!('onmsgesturechange' in window);
	    if (hasTouch) {
	        var ua = navigator.userAgent;
	        hasTouch = ua.match(/Android/i) || ua.match(/webOS/i) || ua.match(/iPhone/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/BlackBerry/i) || ua.match(/Windows Phone/i) ? true : false;
	    }
	    return hasTouch;
	}
	/**
	 * Get an item from the given array
	 */
	function getItem(item, arr, prop) {
	    var i = 0,
	        iL = arr.length;
	    for (; i < iL; i++) {
	        if (prop) {
	            if (item === arr[i][prop]) return arr[i];
	        } else {
	            if (item === arr[i]) return arr[i];
	        }
	    }
	    return null;
	}
	/**
	 * Get items from the given array
	 */
	function getItems(item, arr, prop) {
	    var i = 0,
	        iL = arr.length,
	        results = [];
	
	    for (; i < iL; i++) {
	        if (prop) {
	            if (item === arr[i][prop]) results.push(arr[i]);
	        } else {
	            if (item === arr[i]) results.push(arr[i]);
	        }
	    }
	    return results;
	}
	/**
	 * Replace an item in a given array
	 */
	function replaceItem(item, arr, prop) {
	    var i = 0,
	        iL = arr.length;
	
	    for (; i < iL; i++) {
	        if (prop) {
	            if (item[prop] === arr[i][prop]) arr[i] = item;
	        } else {
	            if (item === arr[i]) arr[i] = item;
	        }
	    }
	    return arr;
	}
	/**
	 * Update an item in a given array
	 */
	function updateItem(item, arr, prop) {
	    var i = 0,
	        iL = arr.length;
	
	    for (; i < iL; i++) {
	        if (prop) {
	            if (item[prop] === arr[i][prop]) {
	                arr[i] = _jquery2.default.extend({}, arr[i], item);
	                delete arr[i].__new__;
	            }
	        } else {
	            if (item === arr[i]) {
	                arr[i] = item;
	                delete arr[i].__new__;
	            }
	        }
	    }
	    return arr;
	}
	/**
	 * Remove an item from a given array
	 */
	function removeItem(item, arr, prop) {
	    var i = 0,
	        iL = arr.length,
	        result = [];
	
	    for (; i < iL; i++) {
	        if (prop) {
	            if (item !== arr[i][prop]) result.push(arr[i]);
	        } else {
	            if (item !== arr[i]) result.push(arr[i]);
	        }
	    }
	    return result;
	}
	/**
	 * Get the x and y position based on the given event object
	 * @param {Object} e
	 */
	function getPosition(e) {
	    var event = e.originalEvent ? e.originalEvent : e,
	        pageX,
	        pageY;
	    if (event && event.targetTouches) {
	        var tt = event.targetTouches[0];
	        pageX = tt.clientX;
	        pageY = tt.clientY;
	    } else {
	        pageX = e.pageX;
	        pageY = e.pageY;
	    }
	    return { x: pageX, y: pageY };
	}
	
	/**
	 * Method which searches for a property in the given object
	 */
	function getObject(object, property) {
	    if (null === property || typeof property === 'undefined') {
	        return null;
	    }
	    var prop,
	        aP = property.split(".");
	    if (aP.length > 0) {
	        for (prop in object) {
	            if (prop.toUpperCase() === aP[0].toUpperCase()) {
	                aP.shift();
	                if (aP.length == 0) {
	                    return object[prop];
	                } else {
	                    return getObject(object[prop], aP.join("."));
	                }
	                break;
	            }
	        }
	    }
	    return null;
	}
	
	function uuid() {
	    var d = new Date().getTime();
	    if (window.performance && typeof window.performance.now === "function") {
	        d += performance.now(); //use high-precision timer if available
	    }
	    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        var r = (d + Math.random() * 16) % 16 | 0;
	        d = Math.floor(d / 16);
	        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	    });
	    return uuid;
	}
	
	function queryStringToObject(queryString) {
	    if (queryString[0] == '?') {
	        queryString = queryString.slice(1);
	    }
	    var result = {};
	    queryString.split('&').forEach(function (pair) {
	        pair = pair.split('=');
	        result[pair[0]] = decodeURIComponent(pair[1] || '');
	    });
	
	    return JSON.parse(JSON.stringify(result));
	}
	
	function objectToQueryString(obj) {
	    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    var query = Object.keys(obj).map(function (key) {
	        var value = obj[key];
	        key = null !== prefix ? prefix + '[' + key + ']' : key;
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object' || typeof value == 'array') {
	            return objectToQueryString(value, key);
	        }
	        return key + '=' + value;
	    }.bind(this));
	
	    return query.filter(function (value) {
	        return value.length > 0;
	    }).join('&');
	}

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = addEventListener;
	
	var _EventObject = __webpack_require__(46);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function addEventListener(target, eventType, callback) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2["default"](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    target.addEventListener(eventType, wrapCallback, false);
	    return {
	      remove: function remove() {
	        target.removeEventListener(eventType, wrapCallback, false);
	      }
	    };
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(47);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(21)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function calculateValue(value, step, min) {
	    if (value - min < 0) {
	        return min;
	    }
	    if (value % step === 0) {
	        return value;
	    }
	    return (Math.floor(value / step) + 1) * step;
	}
	
	var StepperController = function (_React$Component) {
	    _inherits(StepperController, _React$Component);
	
	    function StepperController(props) {
	        _classCallCheck(this, StepperController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = { value: _this.props.value };
	        return _this;
	    }
	
	    StepperController.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	        if (nextProps.value !== this.state.value) {
	            this.setState({ value: nextProps.value });
	        }
	    };
	
	    StepperController.prototype.onInputChange = function onInputChange(event) {
	        event.preventDefault();
	        if (event.target.value !== "") {
	            var value = parseInt(event.target.value, 10);
	            this.setState({ value: value });
	            this.props.onChange(value || this.props.min);
	        }
	    };
	
	    StepperController.prototype.onInputBlur = function onInputBlur(event) {
	        event.preventDefault();
	        if (event.target.value !== "") {
	            var value = parseInt(event.target.value, 10);
	            if (value !== this.props.min && value % this.props.step !== 0) {
	                this.props.onChange(calculateValue(value, this.props.step, this.props.min));
	            }
	        }
	    };
	
	    StepperController.prototype.onDecrease = function onDecrease(event) {
	        event.preventDefault();
	        var value = parseInt(this.state.value, 10);
	        if (value - this.props.step <= this.props.min) {
	            this.props.onChange(this.props.min);
	        } else {
	            this.props.onChange(calculateValue(value - this.props.step, this.props.step, this.props.min));
	        }
	    };
	
	    StepperController.prototype.onIncrease = function onIncrease(event) {
	        event.preventDefault();
	        var value = parseInt(this.state.value, 10);
	        if (this.props.min % this.props.step !== 0 && this.props.min === value) {
	            this.props.onChange(this.props.step);
	        } else {
	            this.props.onChange(calculateValue(value + this.props.step, this.props.step, this.props.min));
	        }
	    };
	
	    StepperController.prototype.render = function render() {
	        var _this2 = this;
	
	        var StepperView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(StepperView, {
	            value: parseInt(this.state.value, 10),
	            onInputChange: function onInputChange(event) {
	                return _this2.onInputChange(event);
	            },
	            onInputBlur: function onInputBlur(event) {
	                return _this2.onInputBlur(event);
	            },
	            onDecrease: function onDecrease(event) {
	                return _this2.onDecrease(event);
	            },
	            onIncrease: function onIncrease(event) {
	                return _this2.onIncrease(event);
	            },
	            label: this.props.value > 1 ? this.props.labels.multiple : this.props.labels.single
	        });
	    };
	
	    return StepperController;
	}(_react2.default.Component);
	
	exports.default = StepperController;
	
	
	StepperController.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    value: _react.PropTypes.number.isRequired,
	    labels: _react.PropTypes.shape({
	        single: _react.PropTypes.string,
	        multiple: _react.PropTypes.string
	    }).isRequired,
	    step: _react.PropTypes.number.isRequired,
	    min: _react.PropTypes.number.isRequired,
	    onChange: _react.PropTypes.func.isRequired
	};
	
	StepperController.defaultProps = {
	    value: 1,
	    view: "CommonStepperView",
	    step: 1,
	    min: 1,
	    labels: {
	        single: "Item",
	        multiple: "Items"
	    }
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(9);
	
	var _DOMUtils = __webpack_require__(13);
	
	var _DOMStateStorage = __webpack_require__(39);
	
	var _PathUtils = __webpack_require__(6);
	
	var _ExecutionEnvironment = __webpack_require__(16);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(207);
	
	var _PathUtils = __webpack_require__(6);
	
	var _runTransitionHook = __webpack_require__(27);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(15);
	
	var _LocationUtils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(7);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 28 */
/***/ function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 31 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(56);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(32)
	  , defined = __webpack_require__(31);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(11);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	function getOffsetParent(element) {
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = element.ownerDocument;
	  var body = doc.body;
	  var parent = void 0;
	  var positionStyle = _utils2["default"].css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
	  }
	
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    positionStyle = _utils2["default"].css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	exports["default"] = getOffsetParent;
	module.exports = exports['default'];

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	
		if (root === null) {
			throw new Error('Google-maps package can be used only in browser');
		}
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.GoogleMapsLoader = factory();
		}
	
	})(typeof window !== 'undefined' ? window : null, function() {
	
	
		'use strict';
	
	
		var googleVersion = '3.18';
	
		var script = null;
	
		var google = null;
	
		var loading = false;
	
		var callbacks = [];
	
		var onLoadEvents = [];
	
		var originalCreateLoaderMethod = null;
	
	
		var GoogleMapsLoader = {};
	
	
		GoogleMapsLoader.URL = 'https://maps.googleapis.com/maps/api/js';
	
		GoogleMapsLoader.KEY = null;
	
		GoogleMapsLoader.LIBRARIES = [];
	
		GoogleMapsLoader.CLIENT = null;
	
		GoogleMapsLoader.CHANNEL = null;
	
		GoogleMapsLoader.LANGUAGE = null;
	
		GoogleMapsLoader.REGION = null;
	
		GoogleMapsLoader.VERSION = googleVersion;
	
		GoogleMapsLoader.WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';
	
	
		GoogleMapsLoader._googleMockApiObject = {};
	
	
		GoogleMapsLoader.load = function(fn) {
			if (google === null) {
				if (loading === true) {
					if (fn) {
						callbacks.push(fn);
					}
				} else {
					loading = true;
	
					window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] = function() {
						ready(fn);
					};
	
					GoogleMapsLoader.createLoader();
				}
			} else if (fn) {
				fn(google);
			}
		};
	
	
		GoogleMapsLoader.createLoader = function() {
			script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = GoogleMapsLoader.createUrl();
	
			document.body.appendChild(script);
		};
	
	
		GoogleMapsLoader.isLoaded = function() {
			return google !== null;
		};
	
	
		GoogleMapsLoader.createUrl = function() {
			var url = GoogleMapsLoader.URL;
	
			url += '?callback=' + GoogleMapsLoader.WINDOW_CALLBACK_NAME;
	
			if (GoogleMapsLoader.KEY) {
				url += '&key=' + GoogleMapsLoader.KEY;
			}
	
			if (GoogleMapsLoader.LIBRARIES.length > 0) {
				url += '&libraries=' + GoogleMapsLoader.LIBRARIES.join(',');
			}
	
			if (GoogleMapsLoader.CLIENT) {
				url += '&client=' + GoogleMapsLoader.CLIENT + '&v=' + GoogleMapsLoader.VERSION;
			}
	
			if (GoogleMapsLoader.CHANNEL) {
				url += '&channel=' + GoogleMapsLoader.CHANNEL;
			}
	
			if (GoogleMapsLoader.LANGUAGE) {
				url += '&language=' + GoogleMapsLoader.LANGUAGE;
			}
	
			if (GoogleMapsLoader.REGION) {
				url += '&region=' + GoogleMapsLoader.REGION;
			}
	
			return url;
		};
	
	
		GoogleMapsLoader.release = function(fn) {
			var release = function() {
				GoogleMapsLoader.KEY = null;
				GoogleMapsLoader.LIBRARIES = [];
				GoogleMapsLoader.CLIENT = null;
				GoogleMapsLoader.CHANNEL = null;
				GoogleMapsLoader.LANGUAGE = null;
				GoogleMapsLoader.REGION = null;
				GoogleMapsLoader.VERSION = googleVersion;
	
				google = null;
				loading = false;
				callbacks = [];
				onLoadEvents = [];
	
				if (typeof window.google !== 'undefined') {
					delete window.google;
				}
	
				if (typeof window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
					delete window[GoogleMapsLoader.WINDOW_CALLBACK_NAME];
				}
	
				if (originalCreateLoaderMethod !== null) {
					GoogleMapsLoader.createLoader = originalCreateLoaderMethod;
					originalCreateLoaderMethod = null;
				}
	
				if (script !== null) {
					script.parentElement.removeChild(script);
					script = null;
				}
	
				if (fn) {
					fn();
				}
			};
	
			if (loading) {
				GoogleMapsLoader.load(function() {
					release();
				});
			} else {
				release();
			}
		};
	
	
		GoogleMapsLoader.onLoad = function(fn) {
			onLoadEvents.push(fn);
		};
	
	
		GoogleMapsLoader.makeMock = function() {
			originalCreateLoaderMethod = GoogleMapsLoader.createLoader;
	
			GoogleMapsLoader.createLoader = function() {
				window.google = GoogleMapsLoader._googleMockApiObject;
				window[GoogleMapsLoader.WINDOW_CALLBACK_NAME]();
			};
		};
	
	
		var ready = function(fn) {
			var i;
	
			loading = false;
	
			if (google === null) {
				google = window.google;
			}
	
			for (i = 0; i < onLoadEvents.length; i++) {
				onLoadEvents[i](google);
			}
	
			if (fn) {
				fn(google);
			}
	
			for (i = 0; i < callbacks.length; i++) {
				callbacks[i](google);
			}
	
			callbacks = [];
		};
	
	
		return GoogleMapsLoader;
	
	});


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(GoogleMapsLoader) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _markerClustererPlusEs = __webpack_require__(218);
	
	var _markerClustererPlusEs2 = _interopRequireDefault(_markerClustererPlusEs);
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _MarkerStore = __webpack_require__(166);
	
	var _MarkerStore2 = _interopRequireDefault(_MarkerStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global GoogleMapsLoader*/
	
	function extractAddress(results) {
	    var addresObj = { postal_code: null, street_number: null, route: null, country_code: null, city: null, lat: null, lng: null };
	
	    Object.values(results[0].address_components).forEach(function (address) {
	        switch (true) {
	            case address.types.indexOf('street_number') >= 0:
	                addresObj['street_number'] = address.long_name;
	                break;
	            case address.types.indexOf('route') >= 0:
	                addresObj['route'] = address.long_name;
	                break;
	            case address.types.indexOf('locality') >= 0:
	                addresObj['city'] = address.short_name;
	                break;
	            case address.types.indexOf('postal_code') >= 0:
	                addresObj['postal_code'] = address.long_name;
	                break;
	            case address.types.indexOf('country') >= 0:
	                addresObj['country_code'] = address.short_name;
	                break;
	        }
	    });
	
	    addresObj['lat'] = results[0].geometry.location.lat;
	    addresObj['lng'] = results[0].geometry.location.lng;
	
	    return addresObj;
	}
	
	var GoogleMapController = function (_React$Component) {
	    _inherits(GoogleMapController, _React$Component);
	
	    function GoogleMapController(props) {
	        _classCallCheck(this, GoogleMapController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = new _MarkerStore2.default();
	        _this.panned = true;
	        return _this;
	    }
	
	    GoogleMapController.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        if (typeof GoogleMapsLoader !== "undefined") {
	            GoogleMapsLoader.KEY = this.props.apiKey;
	            GoogleMapsLoader.LIBRARIES = this.props.libraries;
	            GoogleMapsLoader.LANGUAGE = this.props.language;
	            GoogleMapsLoader.REGION = this.props.region;
	            GoogleMapsLoader.load(function (google) {
	                _this2.google = google;
	                _this2.geocoder = new google.maps.Geocoder();
	
	                _this2.map = new google.maps.Map(_this2.mapNode, (0, _extend2.default)({}, _this2.props.options, {
	                    center: new google.maps.LatLng(_this2.props.options.center.latitude, _this2.props.options.center.longitude)
	                }));
	
	                if (navigator.geolocation) {
	                    navigator.geolocation.getCurrentPosition(function (position) {
	                        _this2.map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
	                    });
	                }
	
	                _this2.defaultIcon = {
	                    url: _this2.props.defaultIcon.url,
	                    size: new google.maps.Size(_this2.props.defaultIcon.height, _this2.props.defaultIcon.width),
	                    // The origin for this image is 0,0
	                    origin: new google.maps.Point(0, 0),
	                    // The anchor for this image is half the width of the icon
	                    anchor: new google.maps.Point(0, _this2.props.defaultIcon.width / 2)
	                };
	                _this2.activeIcon = {
	                    url: _this2.props.activeIcon.url,
	                    size: new google.maps.Size(_this2.props.activeIcon.height, _this2.props.activeIcon.width),
	                    // The origin for this image is 0,0
	                    origin: new google.maps.Point(0, 0),
	                    // The anchor for this image is half the width of the icon
	                    anchor: new google.maps.Point(0, _this2.props.activeIcon.width / 2)
	                };
	
	                if (_this2.props.clusterOptions !== false) {
	                    _this2.cluster = new _markerClustererPlusEs2.default(_this2.map, _this2.store.markers, _this2.props.clusterOptions);
	                }
	
	                _this2.map.addListener("center_changed", function () {
	                    _this2.panned = true;
	                });
	
	                _this2.map.addListener("idle", function () {
	                    if (_this2.panned) {
	                        _this2.panned = false;
	                        _this2.geocoder.geocode({ latLng: _this2.map.getCenter() }, function (results, status) {
	                            if (status === _this2.google.maps.GeocoderStatus.OK) {
	                                _this2.onLocationChange(extractAddress(results), results[0].geometry.location);
	                            }
	                        });
	                    }
	                });
	
	                var address = _this2.props.address;
	                if (typeof address !== "undefined" && address !== null) {
	                    if (typeof address !== "string") {
	                        address = address.postalCode + " " + address.city;
	                    }
	                    _this2.setLocation(address);
	                }
	
	                if (_this2.props.markers) {
	                    Object.values(_this2.props.markers).forEach(function (marker) {
	                        return _this2.addMarker(marker);
	                    });
	                }
	            });
	        }
	    };
	
	    GoogleMapController.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	        if (nextProps.address !== this.props.address) {
	            this.setLocation(nextProps.address);
	        }
	    };
	
	    GoogleMapController.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	        var _this3 = this;
	
	        if (this.props.markers !== prevProps.markers) {
	            this.store.clear();
	            if (typeof this.cluster !== "undefined") {
	                this.cluster.clearMarkers();
	            }
	            Object.values(this.props.markers).forEach(function (marker) {
	                return _this3.addMarker(marker);
	            });
	        }
	    };
	
	    GoogleMapController.prototype.onLocationChange = function onLocationChange(address, location) {
	        if (typeof this.props.onLocationChange !== "undefined") {
	            this.props.onLocationChange(address, location);
	        }
	    };
	
	    GoogleMapController.prototype.setLocation = function setLocation(address) {
	        var _this4 = this;
	
	        if (typeof this.geocoder === "undefined") {
	            return;
	        }
	        this.geocoder.geocode({ address: address }, function (results, status) {
	            if (status === _this4.google.maps.GeocoderStatus.OK) {
	                _this4.map.setCenter(results[0].geometry.location);
	            }
	        });
	    };
	
	    GoogleMapController.prototype.addMarker = function addMarker(data, active) {
	        var _this5 = this;
	
	        if (typeof this.geocoder === "undefined") {
	            return;
	        }
	        if (typeof data.coordinates === "undefined" && typeof data.address !== "undefined") {
	            this.geocoder.geocode({ address: data.address }, function (results, status) {
	                if (status === _this5.google.maps.GeocoderStatus.OK) {
	                    _this5.addMarker((0, _extend2.default)(data, { coordinates: {
	                            latitude: results[0].geometry.location.lat(),
	                            longitude: results[0].geometry.location.lng()
	                        } }), active);
	                }
	            });
	
	            return;
	        }
	
	        var latLng = new this.google.maps.LatLng(data.coordinates.latitude, data.coordinates.longitude);
	
	        var marker = new this.google.maps.Marker({
	            position: latLng,
	            map: this.map,
	            title: data.name,
	            icon: data.active ? this.activeIcon : this.defaultIcon,
	            id: data.id
	        });
	
	        if (typeof this.cluster !== "undefined") {
	            this.cluster.addMarker(marker);
	        }
	        this.google.maps.event.addListener(marker, "click", function () {
	            _this5.selectMarker(marker, data);
	        });
	        this.store.add(marker);
	    };
	
	    GoogleMapController.prototype.selectMarker = function selectMarker(selectedMarker, data) {
	        var _this6 = this;
	
	        Object.values(this.store.markers).forEach(function (marker) {
	            return marker.setIcon(_this6.defaultIcon);
	        });
	        selectedMarker.setIcon(this.activeIcon);
	        if (typeof this.props.onChange !== "undefined") {
	            this.props.onChange(data);
	        }
	    };
	
	    GoogleMapController.prototype.render = function render() {
	        var _this7 = this;
	
	        var GoogleMapView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(
	            GoogleMapView,
	            this.props,
	            _react2.default.createElement("div", { className: "map", style: { width: "100%", height: "400px" }, ref: function ref(node) {
	                    _this7.mapNode = node;
	                } })
	        );
	    };
	
	    return GoogleMapController;
	}(_react2.default.Component);
	
	exports.default = GoogleMapController;
	
	
	GoogleMapController.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    onLocationChange: _react.PropTypes.func,
	    onChange: _react.PropTypes.func,
	    defaultIcon: _react.PropTypes.shape({
	        url: _react.PropTypes.string,
	        height: _react.PropTypes.number,
	        width: _react.PropTypes.number
	    }),
	    activeIcon: _react.PropTypes.shape({
	        url: _react.PropTypes.string,
	        height: _react.PropTypes.number,
	        width: _react.PropTypes.number
	    }),
	    clusterOptions: _react.PropTypes.shape({
	        imagePath: _react.PropTypes.string
	    }),
	    options: _react.PropTypes.shape({
	        zoom: _react.PropTypes.number,
	        center: _react.PropTypes.shape({
	            latitude: _react.PropTypes.number,
	            longitude: _react.PropTypes.number
	        })
	    }),
	    markers: _react.PropTypes.arrayOf(_react.PropTypes.shape({})),
	    address: _react.PropTypes.string,
	    libraries: _react.PropTypes.arrayOf(_react.PropTypes.string),
	    apiKey: _react.PropTypes.string.isRequired,
	    language: _react.PropTypes.string,
	    region: _react.PropTypes.string
	};
	
	GoogleMapController.defaultProps = {
	    view: "MapViewsGoogleMapView",
	    defaultIcon: {
	        url: "/assets/default/img/marker.png",
	        height: 32,
	        width: 42
	    },
	    activeIcon: {
	        url: "/assets/default/img/marker-selected.png",
	        height: 32,
	        width: 42
	    },
	    clusterOptions: {
	        imagePath: "/assets/default/img/cluster/"
	    },
	    options: {
	        zoom: 13,
	        center: {
	            latitude: 0,
	            longitude: 0
	        }
	    },
	    language: "en",
	    libraries: [],
	    apiKey: "AIzaSyAVk4jl4KI45oHtGbiG2snSOkcrPWIM82c",
	    store: null
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductController = function (_React$Component) {
	    _inherits(ProductController, _React$Component);
	
	    function ProductController(props) {
	        _classCallCheck(this, ProductController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = { isCompared: false, products: [] };
	        _this.store = _ComponentRegistry2.default.getStore("ProductCompareStore");
	        _this.store.listen(function (_ref) {
	            var products = _ref.products;
	            return _this.setState({
	                products: products,
	                isCompared: products.filter(function (product) {
	                    return _this.props.product.id === product.id;
	                }).length > 0
	            });
	        });
	        return _this;
	    }
	
	    ProductController.prototype.addProduct = function addProduct() {
	        var _this2 = this;
	
	        if (this.state.products.length < this.props.maxItems) {
	            this.setState({ message: null });
	            _jquery2.default.ajax({
	                url: this.props.url,
	                data: { products: this.state.products.map(function (value) {
	                        return value.slug;
	                    }) },
	                async: false,
	                method: 'POST',
	                dataType: "json",
	                success: function success(_ref2) {
	                    var matrix = _ref2.matrix,
	                        message = _ref2.message;
	
	                    if (matrix) {
	                        _this2.store.add(_this2.props.product, matrix);
	                    } else {
	                        _this2.store.error(message);
	                        _this2.setState({ error: message });
	                    }
	                }
	            });
	        } else {
	            this.store.error(this.props.labels.max_compare_reached);
	            this.setState({ error: this.props.labels.max_compare_reached });
	        }
	    };
	
	    ProductController.prototype.render = function render() {
	        var _this3 = this;
	
	        var ProductView = _ComponentRegistry2.default.get("ProductCompareViewsProductView");
	
	        return _react2.default.createElement(ProductView, _extends({}, this.props, this.state, { onChange: function onChange() {
	                _this3.state.isCompared ? _this3.store.remove(_this3.props.product) : _this3.addProduct();
	            } }));
	    };
	
	    return ProductController;
	}(_react2.default.Component);
	
	exports.default = ProductController;
	
	
	ProductController.defaultProps = {
	    maxItems: 3
	};
	
	ProductController.propTypes = {
	    product: _react.PropTypes.shape({
	        id: _react.PropTypes.string.isRequired
	    }).isRequired,
	    labels: _react.PropTypes.shape({
	        max_compare_reached: _react.PropTypes.string.isRequired
	    }).isRequired,
	    maxItems: _react.PropTypes.number.isRequired
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(7);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;
	
	var _LocationUtils = __webpack_require__(9);
	
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _createBrowserHistory = __webpack_require__(210);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createHashHistory2 = __webpack_require__(211);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(212);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	var _useBasename2 = __webpack_require__(213);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	var _useBeforeUnload2 = __webpack_require__(214);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	var _useQueries2 = __webpack_require__(215);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	var _Actions2 = __webpack_require__(15);
	
	var _Actions = _interopRequireWildcard(_Actions2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createHistory = _createBrowserHistory2.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;
	exports.useBasename = _useBasename3.default;
	exports.useBeforeUnload = _useBeforeUnload3.default;
	exports.useQueries = _useQueries3.default;
	exports.Actions = _Actions;

/***/ },
/* 41 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(48);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var LazyRenderBox = _react2["default"].createClass({
	  displayName: 'LazyRenderBox',
	
	  propTypes: {
	    children: _react.PropTypes.any,
	    className: _react.PropTypes.string,
	    visible: _react.PropTypes.bool,
	    hiddenClassName: _react.PropTypes.string
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  },
	  render: function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3["default"])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2["default"].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2["default"].createElement('div', props);
	    }
	
	    return _react2["default"].Children.only(props.children);
	  }
	});
	
	exports["default"] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(10))(10);

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(10))(208);

/***/ },
/* 45 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports['default'];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventBaseObject = __webpack_require__(45);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(43);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = void 0;
	    var deltaY = void 0;
	    var delta = void 0;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = void 0;
	    var doc = void 0;
	    var body = void 0;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2["default"].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = void 0;
	  var l = void 0;
	  var prop = void 0;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2["default"].prototype;
	
	(0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports["default"] = DomEventObject;
	module.exports = exports['default'];

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(52), __esModule: true };

/***/ },
/* 48 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 49 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(49)
	var ieee754 = __webpack_require__(216)
	var isArray = __webpack_require__(217)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(29);
	} catch (err) {
	  var index = __webpack_require__(29);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(78);
	module.exports = __webpack_require__(30).Object.assign;

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(34)
	  , toLength  = __webpack_require__(74)
	  , toIndex   = __webpack_require__(73);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 56 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(53);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23)
	  , document = __webpack_require__(22).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 59 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(22)
	  , core      = __webpack_require__(30)
	  , ctx       = __webpack_require__(57)
	  , hide      = __webpack_require__(62)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 61 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(65)
	  , createDesc = __webpack_require__(70);
	module.exports = __webpack_require__(20) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(20) && !__webpack_require__(21)(function(){
	  return Object.defineProperty(__webpack_require__(58)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(68)
	  , gOPS     = __webpack_require__(66)
	  , pIE      = __webpack_require__(69)
	  , toObject = __webpack_require__(75)
	  , IObject  = __webpack_require__(32)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(21)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(54)
	  , IE8_DOM_DEFINE = __webpack_require__(63)
	  , toPrimitive    = __webpack_require__(76)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(20) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 66 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(61)
	  , toIObject    = __webpack_require__(34)
	  , arrayIndexOf = __webpack_require__(55)(false)
	  , IE_PROTO     = __webpack_require__(71)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(67)
	  , enumBugKeys = __webpack_require__(59);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 69 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(72)('keys')
	  , uid    = __webpack_require__(77);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(22)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(33)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(33)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(31);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(23);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 77 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(60);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(64)});

/***/ },
/* 79 */
/***/ function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ },
/* 80 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	      var baseEvents = EVENT_NAME_MAP[baseEventName];
	      for (var styleName in baseEvents) {
	        if (styleName in style) {
	          endEvents.push(baseEvents[styleName]);
	          break;
	        }
	      }
	    }
	  }
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	
	  endEvents: endEvents,
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports["default"] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Event = __webpack_require__(80);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(51);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var isCssAnimationSupported = _Event2["default"].endEvents.length !== 0;
	
	
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2["default"])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2["default"].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2["default"].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2["default"].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2["default"].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports["default"] = cssAnimation;
	module.exports = exports['default'];

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(11);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = _utils2["default"].clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return _utils2["default"].mix(pos, size);
	}
	
	exports["default"] = adjustForViewport;
	module.exports = exports['default'];

/***/ },
/* 83 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = void 0;
	  var y = void 0;
	
	  x = region.left;
	  y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	exports["default"] = getAlignOffset;
	module.exports = exports['default'];

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAlignOffset = __webpack_require__(83);
	
	var _getAlignOffset2 = _interopRequireDefault(_getAlignOffset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var xy = void 0;
	  var diff = void 0;
	  var p1 = void 0;
	  var p2 = void 0;
	
	  xy = {
	    left: elRegion.left,
	    top: elRegion.top
	  };
	
	  p1 = (0, _getAlignOffset2["default"])(refNodeRegion, points[1]);
	  p2 = (0, _getAlignOffset2["default"])(elRegion, points[0]);
	
	  diff = [p2.left - p1.left, p2.top - p1.top];
	
	  return {
	    left: xy.left - diff[0] + offset[0] - targetOffset[0],
	    top: xy.top - diff[1] + offset[1] - targetOffset[1]
	  };
	}
	
	exports["default"] = getElFuturePos;
	module.exports = exports['default'];

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(11);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getRegion(node) {
	  var offset = void 0;
	  var w = void 0;
	  var h = void 0;
	  if (!_utils2["default"].isWindow(node) && node.nodeType !== 9) {
	    offset = _utils2["default"].offset(node);
	    w = _utils2["default"].outerWidth(node);
	    h = _utils2["default"].outerHeight(node);
	  } else {
	    var win = _utils2["default"].getWindow(node);
	    offset = {
	      left: _utils2["default"].getWindowScrollLeft(win),
	      top: _utils2["default"].getWindowScrollTop(win)
	    };
	    w = _utils2["default"].viewportWidth(win);
	    h = _utils2["default"].viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	exports["default"] = getRegion;
	module.exports = exports['default'];

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(11);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(35);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = (0, _getOffsetParent2["default"])(element);
	  var scrollX = void 0;
	  var scrollY = void 0;
	  var winSize = void 0;
	  var doc = element.ownerDocument;
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && _utils2["default"].css(el, 'overflow') !== 'visible') {
	      var pos = _utils2["default"].offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = (0, _getOffsetParent2["default"])(el);
	  }
	
	  // Clip by window's viewport.
	  scrollX = _utils2["default"].getWindowScrollLeft(win);
	  scrollY = _utils2["default"].getWindowScrollTop(win);
	  visibleRect.left = Math.max(visibleRect.left, scrollX);
	  visibleRect.top = Math.max(visibleRect.top, scrollY);
	  winSize = {
	    width: _utils2["default"].viewportWidth(win),
	    height: _utils2["default"].viewportHeight(win)
	  };
	  visibleRect.right = Math.min(visibleRect.right, scrollX + winSize.width);
	  visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + winSize.height);
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	exports["default"] = getVisibleRectForElement;
	module.exports = exports['default'];

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(11);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(35);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _getVisibleRectForElement = __webpack_require__(86);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _adjustForViewport = __webpack_require__(82);
	
	var _adjustForViewport2 = _interopRequireDefault(_adjustForViewport);
	
	var _getRegion = __webpack_require__(85);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	var _getElFuturePos = __webpack_require__(84);
	
	var _getElFuturePos2 = _interopRequireDefault(_getElFuturePos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// http://yiminghe.iteye.com/blog/1124720
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  _utils2["default"].each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n = void 0;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	function domAlign(el, refNode, align) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var target = align.target || refNode;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	
	  var fail = 0;
	  // 当前节点可以被放置的显示区域
	  var visibleRect = (0, _getVisibleRectForElement2["default"])(source);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = (0, _getRegion2["default"])(source);
	  // 参照节点所占的区域, left/top/width/height
	  var refNodeRegion = (0, _getRegion2["default"])(target);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, refNodeRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = _utils2["default"].merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY)) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/ig, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, newPoints, newOffset, newTargetOffset);
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/ig, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, _newPoints, _newOffset, _newTargetOffset);
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = (0, _getElFuturePos2["default"])(elRegion, refNodeRegion, points, offset, targetOffset);
	      _utils2["default"].mix(newElRegion, elFuturePos);
	    }
	
	    // 检查反下后的位置是否可以放下了
	    // 如果仍然放不下只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isFailX(elFuturePos, elRegion, visibleRect);
	
	    newOverflowCfg.adjustY = overflow.adjustY && isFailY(elFuturePos, elRegion, visibleRect);
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = (0, _adjustForViewport2["default"])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    _utils2["default"].css(source, 'width', _utils2["default"].width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    _utils2["default"].css(source, 'height', _utils2["default"].height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  _utils2["default"].offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform
	  });
	
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	
	domAlign.__getOffsetParent = _getOffsetParent2["default"];
	
	domAlign.__getVisibleRectForElement = _getVisibleRectForElement2["default"];
	
	exports["default"] = domAlign;
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	module.exports = exports['default'];

/***/ },
/* 88 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransformName = getTransformName;
	exports.setTransitionProperty = setTransitionProperty;
	exports.getTransitionProperty = getTransitionProperty;
	exports.getTransformXY = getTransformXY;
	exports.setTransformXY = setTransformXY;
	var vendorPrefix = void 0;
	
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
	}
	
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr = void 0;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, 'matrix(' + arr.join(',') + ')');
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
	    }
	  } else {
	    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
	  }
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Choice;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Choice(props) {
	    if (!props.forceRender && Object.keys(props.choices).length == 1 && typeof props.placeholder === 'undefined') {
	        return _react2.default.createElement(
	            'div',
	            null,
	            Object.keys(props.choices).map(function (value) {
	                return _react2.default.createElement(
	                    'label',
	                    { key: value },
	                    _react2.default.createElement('input', { type: 'hidden', name: props.name, value: value }),
	                    ' ',
	                    props.choices[value]
	                );
	            })
	        );
	    }
	
	    var Component = _ComponentRegistry2.default.get(props.expanded ? 'MultiCheckbox' : 'Dropdown');
	    return _react2.default.createElement(Component, props);
	}
	
	Choice.defaultProps = {
	    expanded: false,
	    multiple: false,
	    forceRender: false,
	    choices: []
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Image;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Image(_ref) {
	    var src = _ref.src,
	        name = _ref.name,
	        url = _ref.url,
	        className = _ref.className,
	        onClick = _ref.onClick;
	
	    var ImagePlaceholder = _ComponentRegistry2.default.get("ImagePlaceholder");
	    var image = _react2.default.createElement(ImagePlaceholder, null);
	
	    if (typeof src !== "undefined" && src !== null) {
	        image = _react2.default.createElement("img", { src: src, alt: name, className: "img-fluid" });
	    }
	
	    if ((typeof url === "undefined" || url === null) && (typeof onClick === "undefined" || onClick === null)) {
	        return image;
	    }
	
	    return _react2.default.createElement(
	        "a",
	        { href: url, onClick: onClick, className: className },
	        image
	    );
	}
	
	Image.propTypes = {
	    src: _react2.default.PropTypes.string,
	    url: _react2.default.PropTypes.string,
	    onClick: _react2.default.PropTypes.func,
	    name: _react2.default.PropTypes.string,
	    className: _react2.default.PropTypes.string
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ImagePlaceholder;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImagePlaceholder() {
	  return _react2.default.createElement(
	    "span",
	    { className: "item-placeholder" },
	    _react2.default.createElement("i", { className: "icon icon-placeholder" })
	  );
	}

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MultiCheckbox = __webpack_require__(137);
	
	var _MultiCheckbox2 = _interopRequireDefault(_MultiCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiCheckbox = function (_BaseMultiCheckbox) {
	    _inherits(MultiCheckbox, _BaseMultiCheckbox);
	
	    function MultiCheckbox(props) {
	        _classCallCheck(this, MultiCheckbox);
	
	        var _this = _possibleConstructorReturn(this, _BaseMultiCheckbox.call(this, props));
	
	        _this.state = { open: false };
	        return _this;
	    }
	
	    MultiCheckbox.prototype.render = function render() {
	        var _this2 = this;
	
	        // TO DO: Improvement: There are no unique name/id for the input elements
	        // Now, I will use the "value". But if there are 2 equal values, the checkbox/radio element will not work correctly
	
	        var options = this.state.open ? Object.keys(this.props.choices) : Object.keys(this.props.choices).slice(0, 3);
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'read-more-wrap' },
	                options.map(function (value) {
	                    var checked = _this2.props.value === value;
	                    if (_this2.props.multiple && typeof _this2.props.value !== 'undefined' && null !== _this2.props.value) {
	                        checked = _this2.props.value.indexOf(value) >= 0;
	                    }
	                    return _react2.default.createElement(
	                        'div',
	                        { key: value, className: _this2.props.multiple ? 'checkbox' : 'radio' },
	                        _react2.default.createElement('input', {
	                            type: _this2.props.multiple ? 'checkbox' : 'radio',
	                            name: _this2.props.name,
	                            id: _this2.props.name + '-' + value,
	                            defaultChecked: checked,
	                            value: value,
	                            disabled: _this2.props.disabled || typeof _this2.props.availableChoices !== 'undefined' && null !== _this2.props.availableChoices && typeof _this2.props.availableChoices[value] === 'undefined' ? true : false,
	                            readOnly: _this2.props.readonly,
	                            onChange: _this2.onChange.bind(_this2)
	                        }),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: _this2.props.name + '-' + value, className: checked ? ' checked' : '' },
	                            _this2.props.choices[value]
	                        )
	                    );
	                })
	            ),
	            Object.keys(this.props.choices).length > 3 ? _react2.default.createElement(
	                'label',
	                { htmlFor: '', className: 'btn btn-link', onClick: function onClick(event) {
	                        event.preventDefault();
	                        _this2.setState({ open: !_this2.state.open });
	                    } },
	                _react2.default.createElement('i', { className: 'icon icon-readmore ' + (this.state.open ? "up" : "down") }),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    this.state.open ? this.props.labels.less : this.props.labels.more
	                )
	            ) : ''
	        );
	    };
	
	    return MultiCheckbox;
	}(_MultiCheckbox2.default);
	
	exports.default = MultiCheckbox;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Summary;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Summary(_ref) {
	    var title = _ref.title,
	        value = _ref.value,
	        requiresVat = _ref.requiresVat,
	        labels = _ref.labels;
	
	    var Price = _ComponentRegistry2.default.get("Price");
	
	    return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	            "div",
	            { className: "col-xs-12 col-sm-6 col-sm-offset-6 box-total" },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-xs-6 column text-right" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "price-lg" },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-xs-6 column text-right" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "column price-lg" },
	                        value
	                    )
	                )
	            )
	        )
	    );
	}
	Summary.propTypes = {
	    title: _react.PropTypes.string,
	    value: _react.PropTypes.string,
	    requiresVat: _react.PropTypes.bool,
	    labels: _react.PropTypes.shape({
	        vat_incl: _react.PropTypes.string.isRequired,
	        vat_excl: _react.PropTypes.string.isRequired
	    })
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Vats;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Vats(_ref) {
	    var title = _ref.title,
	        value = _ref.value;
	
	    var Price = _ComponentRegistry2.default.get("Price");
	
	    var rates = Object.keys(value).map(function (rate) {
	        return _react2.default.createElement(
	            "div",
	            { key: rate },
	            _react2.default.createElement(
	                "div",
	                { className: "clearfix" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "pull-left" },
	                    rate,
	                    " %"
	                ),
	                _react2.default.createElement(Price, { className: "pull-right", value: value[rate] })
	            )
	        );
	    });
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 col-sm-6 col-sm-offset-6" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-xs-6 column text-right" },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-xs-6 column text-right" },
	                        rates
	                    )
	                )
	            )
	        )
	    );
	}
	
	Vats.propTypes = {
	    title: _react.PropTypes.string.isRequired,
	    value: _react.PropTypes.objectOf(_react.PropTypes.string).isRequired
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = BasketItemView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _StepperController = __webpack_require__(24);
	
	var _StepperController2 = _interopRequireDefault(_StepperController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BasketItemView(_ref) {
	    var item = _ref.item,
	        labels = _ref.labels,
	        onUpdate = _ref.onUpdate,
	        onRemove = _ref.onRemove;
	
	    var Image = _ComponentRegistry2.default.get("Image");
	    var DeleteButton = _ComponentRegistry2.default.get("DeleteButton");
	    var Price = _ComponentRegistry2.default.get("Price");
	
	    var product = item.product;
	    var features = item.personalisedProperties.concat(Object.values(product.data.distinguishing_properties)).slice(0, 3).map(function (property) {
	        return _react2.default.createElement(
	            "div",
	            { className: "col-xs-6", key: "property-" + property.name },
	            _react2.default.createElement(
	                "h3",
	                { className: "item-subtitle" },
	                property.name
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "item-property" },
	                property.value
	            )
	        );
	    });
	
	    return _react2.default.createElement(
	        "div",
	        { className: "basket-item list-item" },
	        _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-lg-1 column" },
	                _react2.default.createElement(
	                    "a",
	                    { href: true, onClick: function onClick() {
	                            return onRemove();
	                        }, className: "item-action" },
	                    _react2.default.createElement("i", { className: "icon icon-remove" }),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "sr-only" },
	                        labels.remove
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-lg-1 column item-visual text-left" },
	                typeof product.image === 'undefined' || null === product.image ? _react2.default.createElement(
	                    "span",
	                    { className: "item-placeholder" },
	                    _react2.default.createElement("i", { className: "icon icon-basket icon-xl" })
	                ) : _react2.default.createElement(Image, { src: product.image, url: product.url, name: product.name })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-lg-2 column" },
	                product.sku
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-lg-3 column" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "text-wrapper" },
	                    _react2.default.createElement(
	                        "a",
	                        { href: product.url },
	                        product.name
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-lg-1 column" },
	                item.pricingPerUnit.excl
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-lg-2 column" },
	                _react2.default.createElement(_StepperController2.default, {
	                    value: item.quantity,
	                    onChange: function onChange(value) {
	                        return onUpdate({ quantity: value });
	                    },
	                    min: item.product.minimumPurchaseAmount,
	                    step: item.product.multipleFactor
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-lg-1 column" },
	                _react2.default.createElement(Price, { value: item.pricing.excl })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-lg-1 column text-right" },
	                _react2.default.createElement(
	                    "span",
	                    { className: product.data.stock_type === 'onorder' ? 'incentive incentive-danger' : 'incentive incentive-success' },
	                    product.data.stock_type
	                )
	            )
	        )
	    );
	}
	
	BasketItemView.propTypes = {
	    item: _react.PropTypes.shape({
	        quantity: _react.PropTypes.number,
	        product: _react.PropTypes.shape({
	            url: _react.PropTypes.string,
	            name: _react.PropTypes.string,
	            minimumPurchaseAmount: _react.PropTypes.number,
	            multipleFactor: _react.PropTypes.number,
	            pricing: _react.PropTypes.shape({
	                price: _react.PropTypes.string
	            })
	        }),
	        pricing: _react.PropTypes.shape({
	            excl: _react.PropTypes.string
	        })
	    }),
	    labels: _react.PropTypes.shape({
	        sku: _react.PropTypes.string,
	        price_per: _react.PropTypes.string.isRequired,
	        remove: _react.PropTypes.string
	    }),
	    onRemove: _react.PropTypes.func,
	    onUpdate: _react.PropTypes.func
	};
	
	BasketItemView.defaultProps = {
	    labels: {}
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = BasketListView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BasketListView(_ref) {
	    var children = _ref.children;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "basket-content basket-items" },
	        children
	    );
	}
	BasketListView.propTypes = {
	    children: _react.PropTypes.arrayOf(_react.PropTypes.node).isRequired
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = BasketView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _FeedbackController = __webpack_require__(144);
	
	var _FeedbackController2 = _interopRequireDefault(_FeedbackController);
	
	var _BasketListController = __webpack_require__(141);
	
	var _BasketListController2 = _interopRequireDefault(_BasketListController);
	
	var _DiscountsController = __webpack_require__(143);
	
	var _DiscountsController2 = _interopRequireDefault(_DiscountsController);
	
	var _CouponController = __webpack_require__(142);
	
	var _CouponController2 = _interopRequireDefault(_CouponController);
	
	var _ShippingController = __webpack_require__(146);
	
	var _ShippingController2 = _interopRequireDefault(_ShippingController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BasketView(_ref) {
	    var store = _ref.store,
	        value = _ref.value,
	        basketItems = _ref.basketItems,
	        subtotal = _ref.subtotal,
	        shipping = _ref.shipping,
	        discounts = _ref.discounts,
	        coupon = _ref.coupon,
	        vats = _ref.vats,
	        grandtotal = _ref.grandtotal,
	        labels = _ref.labels;
	
	    var Summary = _ComponentRegistry2.default.get("BasketAtomsSummary");
	    var Vats = _ComponentRegistry2.default.get("BasketAtomsVats");
	
	    return _react2.default.createElement(
	        "div",
	        { className: "basket clearfix" },
	        _react2.default.createElement(_FeedbackController2.default, _extends({}, value.feedback, { view: "BasketViewsFeedbackView" })),
	        _react2.default.createElement(
	            "div",
	            { className: "basket-header hidden-md-down" },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement("div", { className: "col-lg-2" }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-2" },
	                    labels.ref
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-3" },
	                    labels.article_name
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-1" },
	                    labels.price_unit
	                ),
	                _react2.default.createElement("div", { className: "col-lg-2" }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-1" },
	                    labels.subtotal
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-1 text-right" },
	                    labels.stock
	                )
	            )
	        ),
	        _react2.default.createElement(_BasketListController2.default, _extends({}, basketItems, {
	            items: value.items,
	            store: store,
	            view: "BasketViewsBasketListView",
	            itemView: "BasketViewsBasketItemView"
	        })),
	        _react2.default.createElement(_DiscountsController2.default, _extends({}, discounts, {
	            items: value.discounts,
	            store: store,
	            view: "BasketViewsDiscountListView",
	            itemView: "BasketViewsDiscountView"
	        })),
	        _react2.default.createElement(Summary, _extends({}, grandtotal, { value: value.pricing.grandTotal, requiresVat: true }))
	    );
	}
	
	BasketView.propTypes = {
	    labels: _react.PropTypes.shape({}),
	    store: _react.PropTypes.string,
	    basketItems: _react.PropTypes.shape({}),
	    shipping: _react.PropTypes.shape({}),
	    coupon: _react.PropTypes.shape({}),
	    discounts: _react.PropTypes.shape({}),
	    subtotal: _react.PropTypes.shape({}),
	    grandtotal: _react.PropTypes.shape({}),
	    vats: _react.PropTypes.shape({}),
	    value: _react.PropTypes.shape({
	        items: _react.PropTypes.arrayOf(_react.PropTypes.shape({})),
	        discounts: _react.PropTypes.arrayOf(_react.PropTypes.shape({})),
	        feedback: _react.PropTypes.shape({}),
	        shipping: _react.PropTypes.shape({}),
	        pricing: _react.PropTypes.shape({
	            basketTotal: _react.PropTypes.string,
	            shippingTotal: _react.PropTypes.string,
	            vatTotals: _react.PropTypes.shape({}),
	            grandTotal: _react.PropTypes.string
	        })
	    })
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = EmptyBasketView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmptyBasketView(_ref) {
	    var labels = _ref.labels;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "basket-content basket-items" },
	        labels.empty
	    );
	}
	
	EmptyBasketView.propTypes = {
	    labels: _react.PropTypes.shape({
	        empty: _react.PropTypes.string
	    }).isRequired
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = FeedbackView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeedbackView(_ref) {
	    var type = _ref.type,
	        message = _ref.message,
	        onClose = _ref.onClose;
	
	    if (type === null) {
	        return null;
	    }
	
	    var DeleteButton = _ComponentRegistry2.default.get("DeleteButton");
	    var className = type === "error" ? "danger" : type;
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "alert alert-" + className + " has-icon clearfix", role: "alert", onClick: onClose },
	            message
	        )
	    );
	}
	
	FeedbackView.propTypes = {
	    type: _react.PropTypes.string,
	    message: _react.PropTypes.string,
	    onClose: _react.PropTypes.func
	};
	
	FeedbackView.defaultProps = {
	    type: null,
	    message: null
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = HeaderView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HeaderView(_ref) {
	    var title = _ref.title,
	        url = _ref.url,
	        count = _ref.count,
	        labels = _ref.labels;
	
	    return _react2.default.createElement(
	        "a",
	        { className: "btn btn-link negative", href: url },
	        count,
	        " ",
	        count === 1 ? labels.single : labels.multiple,
	        " ",
	        _react2.default.createElement("i", { className: "icon icon-basket  pull-right" })
	    );
	}
	
	HeaderView.propTypes = {
	    url: _react.PropTypes.string,
	    title: _react.PropTypes.string,
	    count: _react.PropTypes.number,
	    labels: _react.PropTypes.shape({
	        open: _react.PropTypes.string,
	        single: _react.PropTypes.string,
	        multiple: _react.PropTypes.string
	    })
	};
	
	HeaderView.defaultProps = {
	    count: 0
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollectionPointView = function (_React$Component) {
	  _inherits(CollectionPointView, _React$Component);
	
	  function CollectionPointView(props) {
	    _classCallCheck(this, CollectionPointView);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { showOpeningsHours: false };
	    return _this;
	  }
	
	  CollectionPointView.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "shop-info row clearfix" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-xs-9" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          this.props.name
	        ),
	        this.props.address != undefined && _react2.default.createElement(
	          "div",
	          { className: "address" },
	          this.props.address.street,
	          " ",
	          this.props.address.number,
	          " ",
	          this.props.address.box,
	          _react2.default.createElement("br", null),
	          this.props.address.postalCode,
	          " ",
	          this.props.address.city
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-xs-3 text-right" },
	        !this.props.active ? _react2.default.createElement(
	          "button",
	          { className: "btn btn-default", onClick: this.props.onChange },
	          "Select"
	        ) : _react2.default.createElement(
	          "span",
	          { className: "alert alert-success" },
	          "Selected"
	        )
	      ),
	      this.props.openingHours && this.state.showOpeningsHours ? _react2.default.createElement(
	        "div",
	        { className: "col-xs-7 col-md-8" },
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Openingsuren"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "openinghours" },
	          _react2.default.createElement(
	            "table",
	            null,
	            _react2.default.createElement(
	              "tbody",
	              null,
	              this.props.openingHours.map(function (openingHour, index) {
	                return _react2.default.createElement(
	                  "tr",
	                  { key: index },
	                  _react2.default.createElement(
	                    "td",
	                    { className: "day" },
	                    openingHour.weekday
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { className: "time" },
	                    openingHour.openMorning,
	                    " - ",
	                    openingHour.closeMorning
	                  ),
	                  _react2.default.createElement(
	                    "td",
	                    { className: "time" },
	                    openingHour.openAfternoon,
	                    " - ",
	                    openingHour.closeAfternoon
	                  )
	                );
	              })
	            )
	          )
	        )
	      ) : null
	    );
	  };
	
	  return CollectionPointView;
	}(_react2.default.Component);
	
	exports.default = CollectionPointView;
	
	
	CollectionPointView.propTypes = {
	  name: _react.PropTypes.string,
	  address: _react.PropTypes.shape({
	    street: _react.PropTypes.string,
	    number: _react.PropTypes.string,
	    box: _react.PropTypes.string,
	    postalCode: _react.PropTypes.string,
	    city: _react.PropTypes.string
	  }).isRequired,
	  openingHours: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    weekday: _react.PropTypes.string,
	    openMorning: _react.PropTypes.string,
	    closeMorning: _react.PropTypes.string,
	    openAfternoon: _react.PropTypes.string,
	    closeAfternoon: _react.PropTypes.string
	  })),
	  active: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = CollectionPointsView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var search = null;
	
	function CollectionPointsView(_ref) {
	    var view = _ref.view,
	        views = _ref.views,
	        labels = _ref.labels,
	        address = _ref.address,
	        error = _ref.error,
	        value = _ref.value,
	        markers = _ref.markers,
	        options = _ref.options,
	        children = _ref.children,
	        onSearch = _ref.onSearch,
	        onSwitchView = _ref.onSwitchView,
	        onChange = _ref.onChange,
	        onLocationChange = _ref.onLocationChange;
	
	    var View = _ComponentRegistry2.default.get(views[view]);
	
	    return _react2.default.createElement(
	        "fieldset",
	        { className: "group-collectionpoints" },
	        _react2.default.createElement(
	            "div",
	            { className: "clearfix addressbar" },
	            _react2.default.createElement(
	                "div",
	                { className: "clearfix" },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    labels.label
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "search clearfix" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-search b-1" },
	                    _react2.default.createElement("input", {
	                        type: "text",
	                        ref: function ref(node) {
	                            search = node;
	                        },
	                        className: "form-control",
	                        defaultValue: address,
	                        onKeyPress: function onKeyPress(event) {
	                            if (event.charCode === 13 || event.keyCode === 13) {
	                                event.preventDefault();
	                                onSearch(event.target.value);
	                            }
	                        },
	                        onFocus: function onFocus(event) {
	                            event.preventDefault();
	                            event.target.select();
	                        }
	                    }),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button", className: "btn btn-default", onClick: function onClick(event) {
	                                event.preventDefault();
	                                onSearch(search.value);
	                            }
	                        },
	                        labels.search
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "clearfix mt-10" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "btn-group text-right", role: "group" },
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button", className: "btn btn-" + (view === "map" ? "primary" : "default"), onClick: function onClick(event) {
	                                event.preventDefault();
	                                onSwitchView("map");
	                            }
	                        },
	                        labels.map
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            type: "button", className: "btn btn-" + (view === "list" ? "primary" : "default"), onClick: function onClick(event) {
	                                event.preventDefault();
	                                onSwitchView("list");
	                            }
	                        },
	                        labels.list
	                    )
	                )
	            )
	        ),
	        error ? _react2.default.createElement(
	            "div",
	            { className: "error-msg" },
	            error
	        ) : null,
	        _react2.default.createElement(View, {
	            address: address,
	            options: options,
	            markers: markers.map(function (marker) {
	                return (0, _extend2.default)(marker, { active: value && value.id === marker.id });
	            }),
	            value: value,
	            onLocationChange: onLocationChange,
	            onChange: onChange
	        }),
	        children
	    );
	}
	
	CollectionPointsView.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    views: _react.PropTypes.shape({}),
	    address: _react.PropTypes.string,
	    error: _react.PropTypes.string,
	    markers: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        id: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired
	    })),
	    children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	    options: _react.PropTypes.shape({}),
	    value: _react.PropTypes.shape({
	        id: _react.PropTypes.string.isRequired
	    }),
	    labels: _react.PropTypes.shape({
	        list: _react.PropTypes.string,
	        map: _react.PropTypes.string,
	        search: _react.PropTypes.string,
	        label: _react.PropTypes.string
	    }).isRequired,
	    onSwitchView: _react.PropTypes.func.isRequired,
	    onLocationChange: _react.PropTypes.func.isRequired,
	    onChange: _react.PropTypes.func.isRequired,
	    onSearch: _react.PropTypes.func.isRequired
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ListView(_ref) {
	    var view = _ref.view,
	        markers = _ref.markers,
	        _onChange = _ref.onChange;
	
	    var CollectionPointView = _ComponentRegistry2.default.get(view);
	
	    return _react2.default.createElement(
	        "div",
	        { className: "list-group" },
	        markers.map(function (marker, index) {
	            return _react2.default.createElement(
	                "div",
	                { key: index, className: "list-group-item py-20 border-bottom" + (marker.active ? " active" : "") },
	                _react2.default.createElement(CollectionPointView, _extends({}, marker, { onChange: function onChange(event) {
	                        event.preventDefault();
	                        _onChange(marker);
	                    }
	                }))
	            );
	        })
	    );
	}
	
	exports.default = ListView;
	ListView.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    onChange: _react.PropTypes.func.isRequired,
	    markers: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        active: _react.PropTypes.bool.isRequired
	    }))
	};
	ListView.defaultProps = {
	    view: "CheckoutViewsCollectionPointView"
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MapView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _GoogleMapController = __webpack_require__(37);
	
	var _GoogleMapController2 = _interopRequireDefault(_GoogleMapController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MapView(props) {
	  var CollectionPointView = _ComponentRegistry2.default.get("CheckoutViewsCollectionPointView");
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_GoogleMapController2.default, props),
	    props.value ? _react2.default.createElement(CollectionPointView, props.value) : null
	  );
	}
	
	MapView.propTypes = {
	  value: _react.PropTypes.shape({})
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PagingView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PagingView(_ref) {
	    var pages = _ref.pages,
	        current = _ref.current,
	        onChangePage = _ref.onChangePage,
	        labels = _ref.labels;
	
	    var children = pages.map(function (page) {
	        return _react2.default.createElement(
	            "li",
	            { key: page, className: "list-item" + (page === current ? " active" : "") },
	            _react2.default.createElement(
	                "a",
	                {
	                    href: "#" + page,
	                    className: "" + (parseInt(page, 10) !== page ? " " + page : ""),
	                    onClick: function onClick(event) {
	                        event.preventDefault();
	                        onChangePage(page);
	                    }
	                },
	                makeLabel(labels, page)
	            )
	        );
	    });
	
	    function makeLabel(labels, page) {
	        if (labels[page] === undefined) {
	            return page;
	        } else if (labels[page] === 'Next') {
	            return _react2.default.createElement("i", { className: "icon icon-next" });
	        } else if (labels[page] === 'Previous') {
	            return _react2.default.createElement("i", { className: "icon icon-previous" });
	        } else if (labels[page] === 'Next 5') {
	            return '...';
	        } else if (labels[page] === 'Previous 5') {
	            return '...';
	        }
	    }
	
	    return _react2.default.createElement(
	        "div",
	        { className: "pages" },
	        _react2.default.createElement(
	            "ul",
	            { className: "pagination pagination-sm list-paging" },
	            children
	        )
	    );
	}
	PagingView.propTypes = {
	    current: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	    pages: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])),
	    onChangePage: _react.PropTypes.func.isRequired,
	    labels: _react.PropTypes.shape({}).isRequired
	};
	PagingView.defaultProps = {
	    current: 1
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = StepperView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StepperView(_ref) {
	    var value = _ref.value,
	        step = _ref.step,
	        min = _ref.min,
	        label = _ref.label,
	        onInputChange = _ref.onInputChange,
	        onInputBlur = _ref.onInputBlur,
	        onDecrease = _ref.onDecrease,
	        onIncrease = _ref.onIncrease;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "input-group stepper" },
	        _react2.default.createElement(
	            "span",
	            { className: "stepper-field field-label" },
	            _react2.default.createElement(
	                "span",
	                { className: "meta-label" },
	                label
	            ),
	            _react2.default.createElement("input", {
	                type: "text",
	                className: "form-control",
	                value: value,
	                onChange: onInputChange,
	                onBlur: onInputBlur
	            })
	        )
	    );
	}
	
	StepperView.propTypes = {
	    value: _react.PropTypes.number.isRequired,
	    /*label: PropTypes.string.isRequired,*/
	    step: _react2.default.PropTypes.number,
	    min: _react2.default.PropTypes.number,
	    onInputChange: _react2.default.PropTypes.func.isRequired,
	    onInputBlur: _react2.default.PropTypes.func.isRequired,
	    onDecrease: _react2.default.PropTypes.func.isRequired,
	    onIncrease: _react2.default.PropTypes.func.isRequired
	};
	
	StepperView.defaultProps = {
	    step: 1,
	    min: 1
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _Choice = __webpack_require__(134);
	
	var _Choice2 = _interopRequireDefault(_Choice);
	
	var _Dropdown = __webpack_require__(136);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _MultiCheckbox = __webpack_require__(92);
	
	var _MultiCheckbox2 = _interopRequireDefault(_MultiCheckbox);
	
	var _Image = __webpack_require__(90);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ImagePlaceholder = __webpack_require__(91);
	
	var _ImagePlaceholder2 = _interopRequireDefault(_ImagePlaceholder);
	
	var _DeleteButton = __webpack_require__(135);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _Price = __webpack_require__(138);
	
	var _Price2 = _interopRequireDefault(_Price);
	
	var _Slider = __webpack_require__(139);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Atoms
	
	
	// Atoms
	_ComponentRegistry2.default.register({ Choice: _Choice2.default });
	//import Price from "../Atoms/Price";
	
	_ComponentRegistry2.default.register({ Dropdown: _Dropdown2.default });
	_ComponentRegistry2.default.register({ MultiCheckbox: _MultiCheckbox2.default });
	_ComponentRegistry2.default.register({ Image: _Image2.default });
	_ComponentRegistry2.default.register({ ImagePlaceholder: _ImagePlaceholder2.default });
	_ComponentRegistry2.default.register({ DeleteButton: _DeleteButton2.default });
	_ComponentRegistry2.default.register({ Price: _Price2.default });
	_ComponentRegistry2.default.register({ Slider: _Slider2.default });

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _BasketWidget = __webpack_require__(154);
	
	var _BasketWidget2 = _interopRequireDefault(_BasketWidget);
	
	var _BasketHeaderWidget = __webpack_require__(153);
	
	var _BasketHeaderWidget2 = _interopRequireDefault(_BasketHeaderWidget);
	
	var _BasketView = __webpack_require__(97);
	
	var _BasketView2 = _interopRequireDefault(_BasketView);
	
	var _EmptyBasketView = __webpack_require__(98);
	
	var _EmptyBasketView2 = _interopRequireDefault(_EmptyBasketView);
	
	var _BasketItemView = __webpack_require__(95);
	
	var _BasketItemView2 = _interopRequireDefault(_BasketItemView);
	
	var _BasketListView = __webpack_require__(96);
	
	var _BasketListView2 = _interopRequireDefault(_BasketListView);
	
	var _FeedbackView = __webpack_require__(99);
	
	var _FeedbackView2 = _interopRequireDefault(_FeedbackView);
	
	var _DiscountView = __webpack_require__(150);
	
	var _DiscountView2 = _interopRequireDefault(_DiscountView);
	
	var _DiscountListView = __webpack_require__(149);
	
	var _DiscountListView2 = _interopRequireDefault(_DiscountListView);
	
	var _CouponView = __webpack_require__(148);
	
	var _CouponView2 = _interopRequireDefault(_CouponView);
	
	var _ShippingView = __webpack_require__(152);
	
	var _ShippingView2 = _interopRequireDefault(_ShippingView);
	
	var _ShippingTypeView = __webpack_require__(151);
	
	var _ShippingTypeView2 = _interopRequireDefault(_ShippingTypeView);
	
	var _HeaderView = __webpack_require__(100);
	
	var _HeaderView2 = _interopRequireDefault(_HeaderView);
	
	var _Summary = __webpack_require__(93);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _Vats = __webpack_require__(94);
	
	var _Vats2 = _interopRequireDefault(_Vats);
	
	var _BasketStore = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Basket Widgets
	
	
	// Views
	
	
	// Basket
	_ComponentRegistry2.default.register({
	    BasketWidget: _BasketWidget2.default,
	    BasketHeaderWidget: _BasketHeaderWidget2.default,
	    BasketAtomsSummary: _Summary2.default,
	    BasketAtomsVats: _Vats2.default,
	    BasketViewsBasketView: _BasketView2.default,
	    BasketViewsEmptyBasketView: _EmptyBasketView2.default,
	    BasketViewsBasketItemView: _BasketItemView2.default,
	    BasketViewsBasketListView: _BasketListView2.default,
	    BasketViewsDiscountListView: _DiscountListView2.default,
	    BasketViewsDiscountView: _DiscountView2.default,
	    BasketViewsCouponView: _CouponView2.default,
	    BasketViewsFeedbackView: _FeedbackView2.default,
	    BasketViewsShippingView: _ShippingView2.default,
	    BasketViewsShippingTypeView: _ShippingTypeView2.default,
	    BasketViewsHeaderView: _HeaderView2.default
	});
	
	// Basket Store
	
	
	// Store
	
	
	// Atoms
	_ComponentRegistry2.default.registerStore({
	    BasketStore: _BasketStore.createBasketStore,
	    ProductDraftStore: _BasketStore.createBasketStore
	});

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _CollectionPointsWidget = __webpack_require__(156);
	
	var _CollectionPointsWidget2 = _interopRequireDefault(_CollectionPointsWidget);
	
	var _CollectionPointsView = __webpack_require__(102);
	
	var _CollectionPointsView2 = _interopRequireDefault(_CollectionPointsView);
	
	var _MapView = __webpack_require__(104);
	
	var _MapView2 = _interopRequireDefault(_MapView);
	
	var _ListView = __webpack_require__(103);
	
	var _ListView2 = _interopRequireDefault(_ListView);
	
	var _CollectionPointView = __webpack_require__(101);
	
	var _CollectionPointView2 = _interopRequireDefault(_CollectionPointView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_ComponentRegistry2.default.register({
	    CheckoutCollectionPointsWidget: _CollectionPointsWidget2.default,
	    CheckoutViewsCollectionPointsView: _CollectionPointsView2.default,
	    CheckoutViewsCollectionPointView: _CollectionPointView2.default,
	    CheckoutViewsMapView: _MapView2.default,
	    CheckoutViewsListView: _ListView2.default
	});

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _PagingView = __webpack_require__(105);
	
	var _PagingView2 = _interopRequireDefault(_PagingView);
	
	var _StepperView = __webpack_require__(106);
	
	var _StepperView2 = _interopRequireDefault(_StepperView);
	
	var _LocalStorageWidget = __webpack_require__(160);
	
	var _LocalStorageWidget2 = _interopRequireDefault(_LocalStorageWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_ComponentRegistry2.default.register({
	    CommonPagingView: _PagingView2.default,
	    CommonStepperView: _StepperView2.default,
	    CommonLocalStorageWidget: _LocalStorageWidget2.default
	});
	
	// Common

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _ImageGalleryWidget = __webpack_require__(165);
	
	var _ImageGalleryWidget2 = _interopRequireDefault(_ImageGalleryWidget);
	
	var _ImageGalleryView = __webpack_require__(163);
	
	var _ImageGalleryView2 = _interopRequireDefault(_ImageGalleryView);
	
	var _ThumbView = __webpack_require__(164);
	
	var _ThumbView2 = _interopRequireDefault(_ThumbView);
	
	var _DetailView = __webpack_require__(162);
	
	var _DetailView2 = _interopRequireDefault(_DetailView);
	
	var _VisualView = __webpack_require__(118);
	
	var _VisualView2 = _interopRequireDefault(_VisualView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Widgets
	_ComponentRegistry2.default.register({ ImageGalleryWidget: _ImageGalleryWidget2.default });
	
	// Views
	
	
	// Image Gallery
	_ComponentRegistry2.default.register({ ImageGalleryViewsImageGalleryView: _ImageGalleryView2.default });
	_ComponentRegistry2.default.register({ ImageGalleryViewsThumbView: _ThumbView2.default });
	_ComponentRegistry2.default.register({ ImageGalleryViewsDetailView: _DetailView2.default });
	_ComponentRegistry2.default.register({ ImageGalleryViewsVisualView: _VisualView2.default });

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _GoogleMapView = __webpack_require__(167);
	
	var _GoogleMapView2 = _interopRequireDefault(_GoogleMapView);
	
	var _GoogleMapWidget = __webpack_require__(168);
	
	var _GoogleMapWidget2 = _interopRequireDefault(_GoogleMapWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_ComponentRegistry2.default.register({ GoogleMapWidget: _GoogleMapWidget2.default });
	
	_ComponentRegistry2.default.register({ MapViewsGoogleMapView: _GoogleMapView2.default });

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _ProductsWidget = __webpack_require__(177);
	
	var _ProductsWidget2 = _interopRequireDefault(_ProductsWidget);
	
	var _FacetsWidget = __webpack_require__(126);
	
	var _FacetsWidget2 = _interopRequireDefault(_FacetsWidget);
	
	var _HistoryWidget = __webpack_require__(176);
	
	var _HistoryWidget2 = _interopRequireDefault(_HistoryWidget);
	
	var _Footer = __webpack_require__(120);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(121);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _MultiCheckbox = __webpack_require__(119);
	
	var _MultiCheckbox2 = _interopRequireDefault(_MultiCheckbox);
	
	var _ProductsView = __webpack_require__(124);
	
	var _ProductsView2 = _interopRequireDefault(_ProductsView);
	
	var _FacetsView = __webpack_require__(123);
	
	var _FacetsView2 = _interopRequireDefault(_FacetsView);
	
	var _FacetView = __webpack_require__(122);
	
	var _FacetView2 = _interopRequireDefault(_FacetView);
	
	var _ThumbView = __webpack_require__(125);
	
	var _ThumbView2 = _interopRequireDefault(_ThumbView);
	
	var _ListView = __webpack_require__(174);
	
	var _ListView2 = _interopRequireDefault(_ListView);
	
	var _PresentationView = __webpack_require__(175);
	
	var _PresentationView2 = _interopRequireDefault(_PresentationView);
	
	var _ProductBrowserStore = __webpack_require__(173);
	
	var _FacetStore = __webpack_require__(172);
	
	var _FacetStore2 = _interopRequireDefault(_FacetStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Product Browser Store
	
	
	// Product Browser
	_ComponentRegistry2.default.registerStore({ ProductBrowserStore: _ProductBrowserStore.createProductBrowserStore });
	_ComponentRegistry2.default.registerStore({ ProductBrowserFacetStore: _FacetStore2.default });
	
	_ComponentRegistry2.default.register({ ProductBrowserProductsWidget: _ProductsWidget2.default });
	_ComponentRegistry2.default.register({ ProductBrowserFacetsWidget: _FacetsWidget2.default });
	_ComponentRegistry2.default.register({ ProductBrowserHistoryWidget: _HistoryWidget2.default });
	
	_ComponentRegistry2.default.register({ ProductBrowserAtomsFooter: _Footer2.default });
	_ComponentRegistry2.default.register({ ProductBrowserAtomsHeader: _Header2.default });
	_ComponentRegistry2.default.register({ ProductBrowserAtomsFacetMultiCheckbox: _MultiCheckbox2.default });
	
	_ComponentRegistry2.default.register({ ProductBrowserViewsProductsView: _ProductsView2.default });
	_ComponentRegistry2.default.register({ ProductBrowserViewsFacetsView: _FacetsView2.default });
	_ComponentRegistry2.default.register({ ProductBrowserViewsFacetView: _FacetView2.default });
	_ComponentRegistry2.default.register({ ProductBrowserViewsPresentationView: _PresentationView2.default });
	
	_ComponentRegistry2.default.register({ ProductBrowserViewsThumbView: _ThumbView2.default });
	_ComponentRegistry2.default.register({ ProductBrowserViewsListView: _ListView2.default });

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _PanelWidget = __webpack_require__(184);
	
	var _PanelWidget2 = _interopRequireDefault(_PanelWidget);
	
	var _ProductWidget = __webpack_require__(185);
	
	var _ProductWidget2 = _interopRequireDefault(_ProductWidget);
	
	var _MatrixWidget = __webpack_require__(183);
	
	var _MatrixWidget2 = _interopRequireDefault(_MatrixWidget);
	
	var _MatrixView = __webpack_require__(127);
	
	var _MatrixView2 = _interopRequireDefault(_MatrixView);
	
	var _HistoryWidget = __webpack_require__(181);
	
	var _HistoryWidget2 = _interopRequireDefault(_HistoryWidget);
	
	var _LocalStorageWidget = __webpack_require__(182);
	
	var _LocalStorageWidget2 = _interopRequireDefault(_LocalStorageWidget);
	
	var _CompareStore = __webpack_require__(180);
	
	var _CompareStore2 = _interopRequireDefault(_CompareStore);
	
	var _PanelView = __webpack_require__(129);
	
	var _PanelView2 = _interopRequireDefault(_PanelView);
	
	var _ProductView = __webpack_require__(130);
	
	var _ProductView2 = _interopRequireDefault(_ProductView);
	
	var _PanelProductView = __webpack_require__(128);
	
	var _PanelProductView2 = _interopRequireDefault(_PanelProductView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_ComponentRegistry2.default.register({
	    ProductComparePanelWidget: _PanelWidget2.default,
	    ProductCompareViewsPanelView: _PanelView2.default,
	    ProductCompareProductWidget: _ProductWidget2.default,
	    ProductCompareViewsProductView: _ProductView2.default,
	    ProductCompareViewsPanelProductView: _PanelProductView2.default,
	    ProductCompareMatrixWidget: _MatrixWidget2.default,
	    ProductCompareViewsMatrixView: _MatrixView2.default,
	    ProductCompareHistoryWidget: _HistoryWidget2.default,
	    ProductCompareLocalStorageWidget: _LocalStorageWidget2.default
	}); // Product Compare
	
	_ComponentRegistry2.default.registerStore({ ProductCompareStore: _CompareStore2.default });

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _ProductsWidget = __webpack_require__(188);
	
	var _ProductsWidget2 = _interopRequireDefault(_ProductsWidget);
	
	var _ProductsView = __webpack_require__(187);
	
	var _ProductsView2 = _interopRequireDefault(_ProductsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Product List
	_ComponentRegistry2.default.register({ ProductListProductsWidget: _ProductsWidget2.default });
	_ComponentRegistry2.default.register({ ProductListViewsProductsView: _ProductsView2.default });

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _ProductPurchaseWidget = __webpack_require__(201);
	
	var _ProductPurchaseWidget2 = _interopRequireDefault(_ProductPurchaseWidget);
	
	var _ProductStore = __webpack_require__(196);
	
	var _Price = __webpack_require__(189);
	
	var _Price2 = _interopRequireDefault(_Price);
	
	var _Property = __webpack_require__(190);
	
	var _Property2 = _interopRequireDefault(_Property);
	
	var _PurchaseView = __webpack_require__(131);
	
	var _PurchaseView2 = _interopRequireDefault(_PurchaseView);
	
	var _VariationView = __webpack_require__(199);
	
	var _VariationView2 = _interopRequireDefault(_VariationView);
	
	var _WishlistView = __webpack_require__(200);
	
	var _WishlistView2 = _interopRequireDefault(_WishlistView);
	
	var _PricingView = __webpack_require__(198);
	
	var _PricingView2 = _interopRequireDefault(_PricingView);
	
	var _PersonalisationFormView = __webpack_require__(197);
	
	var _PersonalisationFormView2 = _interopRequireDefault(_PersonalisationFormView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_ComponentRegistry2.default.registerStore({ ProductStore: _ProductStore.createProductStore });
	
	// Product Purchase
	
	
	_ComponentRegistry2.default.register({ ProductPurchaseWidget: _ProductPurchaseWidget2.default });
	_ComponentRegistry2.default.register({ ProductPurchasAtomsPrice: _Price2.default });
	_ComponentRegistry2.default.register({ ProductPurchaseAtomsProperty: _Property2.default });
	_ComponentRegistry2.default.register({ ProductPurchaseViewsPricingView: _PricingView2.default });
	_ComponentRegistry2.default.register({ ProductPurchaseViewsPersonalisationFormView: _PersonalisationFormView2.default });
	_ComponentRegistry2.default.register({ ProductPurchaseViewsPurchaseView: _PurchaseView2.default });
	_ComponentRegistry2.default.register({ ProductPurchaseViewsVariationView: _VariationView2.default });
	_ComponentRegistry2.default.register({ ProductPurchaseViewsWishlistView: _WishlistView2.default });

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _WishlistWidget = __webpack_require__(206);
	
	var _WishlistWidget2 = _interopRequireDefault(_WishlistWidget);
	
	var _WishlistStore = __webpack_require__(203);
	
	var _WishlistStore2 = _interopRequireDefault(_WishlistStore);
	
	var _WishlistView = __webpack_require__(205);
	
	var _WishlistView2 = _interopRequireDefault(_WishlistView);
	
	var _ItemView = __webpack_require__(204);
	
	var _ItemView2 = _interopRequireDefault(_ItemView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Wishlist
	_ComponentRegistry2.default.registerStore({ WishlistStore: _WishlistStore2.default });
	
	_ComponentRegistry2.default.register({ WishlistWidget: _WishlistWidget2.default });
	_ComponentRegistry2.default.register({ WishlistViewsWishlistView: _WishlistView2.default });
	_ComponentRegistry2.default.register({ WishlistViewsItemView: _ItemView2.default });

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = VisualView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VisualView(_ref) {
	    var current = _ref.current,
	        labels = _ref.labels,
	        onPrev = _ref.onPrev,
	        onNext = _ref.onNext;
	
	    var Image = _ComponentRegistry2.default.get("Image");
	    return _react2.default.createElement(
	        "section",
	        { className: "carousel" },
	        _react2.default.createElement(
	            "a",
	            { href: current.url, className: "carousel-detail-image-wrapper" },
	            _react2.default.createElement(Image, { className: "carousel-detail-image", src: current.src, name: current.label }),
	            _react2.default.createElement(
	                "div",
	                { className: "carousel-box" },
	                _react2.default.createElement(
	                    "h2",
	                    { className: "carousel-title" },
	                    current.label
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: "carousel-more" },
	                    labels.read_more
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "a",
	            { href: "#next-visual", className: "btn-next", onClick: onNext },
	            _react2.default.createElement(
	                "span",
	                { className: "sr-only" },
	                labels.next
	            ),
	            _react2.default.createElement("i", { className: "icon icon-arrow-right" })
	        ),
	        _react2.default.createElement(
	            "a",
	            { href: "#prev-visual", className: "btn-prev", onClick: onPrev },
	            _react2.default.createElement(
	                "span",
	                { className: "sr-only" },
	                labels.previous
	            ),
	            _react2.default.createElement("i", { className: "icon icon-arrow-left" })
	        )
	    );
	}
	VisualView.propTypes = {
	    current: _react.PropTypes.shape({
	        label: _react.PropTypes.string,
	        url: _react.PropTypes.string,
	        src: _react.PropTypes.string.isRequired
	    }),
	    labels: _react.PropTypes.shape({
	        previous: _react.PropTypes.string,
	        next: _react.PropTypes.string,
	        read_more: _react.PropTypes.string
	    }),
	    onPrev: _react.PropTypes.func,
	    onNext: _react.PropTypes.func
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = MultiCheckbox;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Choice = __webpack_require__(89);
	
	var _Choice2 = _interopRequireDefault(_Choice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MultiCheckbox(_ref) {
	    var label = _ref.label,
	        choices = _ref.choices,
	        value = _ref.value,
	        onChange = _ref.onChange,
	        labels = _ref.labels;
	
	    var formattedChoices = {};
	
	    Object.keys(choices).forEach(function (key) {
	        return formattedChoices[key] = choices[key].label + " (" + choices[key].count + ")";
	    });
	
	    return _react2.default.createElement(_Choice2.default, {
	        name: label,
	        choices: formattedChoices,
	        multiple: true,
	        expanded: true,
	        forceRender: true,
	        value: value,
	        onChange: onChange,
	        labels: labels
	    });
	}
	
	MultiCheckbox.propTypes = {
	    choices: _react.PropTypes.objectOf(_react2.default.PropTypes.shape({
	        label: _react.PropTypes.string.isRequired,
	        count: _react.PropTypes.number.isRequired
	    })).isRequired,
	    value: _react.PropTypes.string,
	    onChange: _react.PropTypes.func,
	    class: _react.PropTypes.string,
	    labels: _react.PropTypes.string
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Footer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _PagingController = __webpack_require__(157);
	
	var _PagingController2 = _interopRequireDefault(_PagingController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer(_ref) {
	  var sorting = _ref.sorting,
	      sort = _ref.sort,
	      paging = _ref.paging,
	      labels = _ref.labels,
	      onSort = _ref.onSort,
	      onChangePage = _ref.onChangePage;
	
	  var Choice = _ComponentRegistry2.default.get("Choice");
	
	  return _react2.default.createElement(
	    "footer",
	    { className: "row-paging" },
	    _react2.default.createElement(
	      "div",
	      { className: "row clearfix" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-xs-12 col-sm-6 paging" },
	        _react2.default.createElement(_PagingController2.default, _extends({}, paging, { labels: labels, onChange: onChangePage }))
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-sm-6 hidden-xs-down" },
	        _react2.default.createElement(
	          "div",
	          { className: "pagination text-muted text-upper text-right" },
	          labels.total_results.replace("{items}", typeof paging.items !== "undefined" ? paging.items.total : null)
	        )
	      )
	    )
	  );
	}
	
	Footer.propTypes = {
	  sorting: _react.PropTypes.shape({}),
	  sort: _react.PropTypes.string,
	  paging: _react.PropTypes.shape({}),
	  labels: _react.PropTypes.shape({
	    total_results: _react.PropTypes.string.isRequired
	  }),
	  onSort: _react.PropTypes.func.isRequired,
	  onChangePage: _react.PropTypes.func.isRequired
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Header;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _PresentationController = __webpack_require__(170);
	
	var _PresentationController2 = _interopRequireDefault(_PresentationController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header(_ref) {
	    var sorting = _ref.sorting,
	        sort = _ref.sort,
	        perPageOptions = _ref.perPageOptions,
	        paging = _ref.paging,
	        presentation = _ref.presentation,
	        productView = _ref.productView,
	        onSort = _ref.onSort,
	        onChangePage = _ref.onChangePage,
	        onChangeView = _ref.onChangeView,
	        onChangeItemsPerPage = _ref.onChangeItemsPerPage,
	        labels = _ref.labels,
	        state = _ref.state,
	        filters = _ref.filters;
	
	    var Choice = _ComponentRegistry2.default.get("Choice");
	
	    return _react2.default.createElement("header", { className: "row-paging clearfix" });
	}
	
	// import PagingControler from "../../Common/Controllers/PagingController";
	
	
	Header.propTypes = {
	    sorting: _react.PropTypes.shape({}),
	    sort: _react.PropTypes.string,
	    paging: _react.PropTypes.shape({}),
	    perPageOptions: _react.PropTypes.shape({}),
	    presentation: _react.PropTypes.shape({}),
	    productView: _react.PropTypes.string,
	    onSort: _react.PropTypes.func.isRequired,
	    onChangePage: _react.PropTypes.func.isRequired,
	    onChangeView: _react.PropTypes.func.isRequired,
	    onChangeItemsPerPage: _react.PropTypes.func.isRequired,
	    labels: _react.PropTypes.shape({})
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = FacetView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FacetView(_ref) {
	    var label = _ref.label,
	        children = _ref.children;
	
	    return _react2.default.createElement(
	        "fieldset",
	        { className: "filter filter-block col-lg-3 col-sm-4" },
	        _react2.default.createElement(
	            "h2",
	            { className: "filter-title" },
	            label
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "contents filter-list" },
	            children
	        )
	    );
	}
	FacetView.propTypes = {
	    label: _react.PropTypes.string.isRequired,
	    children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.symbol])
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = FacetsView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FacetsView(_ref) {
	    var children = _ref.children;
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        children
	    );
	}
	
	FacetsView.propTypes = {
	    children: _react.PropTypes.arrayOf(_react.PropTypes.node)
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ProductsView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Products(_ref) {
	    var productView = _ref.productView,
	        products = _ref.products,
	        compare = _ref.compare;
	
	    var ProductView = _ComponentRegistry2.default.get(productView);
	
	    return _react2.default.createElement(
	        "section",
	        { className: "widget widget-products clearfix" },
	        Object.values(products).map(function (product, index) {
	            return _react2.default.createElement(ProductView, _extends({ key: index }, product, { compare: compare }));
	        })
	    );
	}
	
	Products.propTypes = {
	    productView: _react.PropTypes.string.isRequired,
	    products: _react.PropTypes.arrayOf(_react.PropTypes.shape({})).isRequired
	};
	
	function ProductsView(props) {
	    var Header = _ComponentRegistry2.default.get("ProductBrowserAtomsHeader");
	    var Footer = _ComponentRegistry2.default.get("ProductBrowserAtomsFooter");
	    if (props.status === 'loading') {
	        return _react2.default.createElement(
	            "section",
	            { className: "panel panel-preload" },
	            _react2.default.createElement(
	                "div",
	                { className: "inner" },
	                _react2.default.createElement("i", { className: "icon icon-loader" }),
	                _react2.default.createElement(
	                    "span",
	                    { className: "text" },
	                    "Ogenblikje..."
	                )
	            )
	        );
	    }
	    return _react2.default.createElement(
	        "div",
	        { className: "product-browser" },
	        _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(Products, props)
	        ),
	        _react2.default.createElement(Footer, props)
	    );
	}
	
	ProductsView.propsTypes = {};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ProductView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _ProductController = __webpack_require__(38);
	
	var _ProductController2 = _interopRequireDefault(_ProductController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProductView(props) {
	    var title = props.title,
	        url = props.url,
	        thumb = props.thumb,
	        price = props.price,
	        originalPrice = props.originalPrice,
	        properties = props.properties,
	        compare = props.compare,
	        compareUrl = props.compareUrl;
	
	    var Price = _ComponentRegistry2.default.get("Price");
	    var Image = _ComponentRegistry2.default.get("Image");
	
	    // const incentives = Object.values(properties.incentives.value)
	    //     .map(incentive => <span className="item-incentive" key={incentive.id}>{incentive.title}</span>);
	
	    return _react2.default.createElement(
	        "article",
	        { className: "product-item list-item col-lg-3 col-md-4 col-sm-6 col-xs-12", itemType: "http://schema.org/Product" },
	        _react2.default.createElement(
	            "a",
	            { className: "clearfix", href: url },
	            _react2.default.createElement(
	                "div",
	                { className: "item-visual" },
	                _react2.default.createElement(Image, { className: "img-fluid", src: thumb, alt: title }),
	                _react2.default.createElement(_ProductController2.default, _extends({ id: title.replace(/\s/g, ''), url: compareUrl }, compare, { product: props }))
	            ),
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "p",
	                    { className: "product-description", itemProp: "name" },
	                    title
	                )
	            )
	        )
	    );
	}
	
	ProductView.propTypes = {
	    title: _react.PropTypes.string.isRequired,
	    url: _react.PropTypes.string.isRequired,
	    thumb: _react.PropTypes.string,
	    price: _react.PropTypes.shape({
	        excl: _react.PropTypes.string.isRequired
	    }).isRequired,
	    originalPrice: _react.PropTypes.shape({
	        excl: _react.PropTypes.string.isRequired
	    }),
	    properties: _react.PropTypes.shape({}).isRequired
	};

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = FacetsWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FacetController = __webpack_require__(169);
	
	var _FacetController2 = _interopRequireDefault(_FacetController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FacetsWidget(props) {
	
	    return _react2.default.createElement(
	        "section",
	        { className: "filter-browser" },
	        _react2.default.createElement(
	            "header",
	            { className: "filter-header" },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 col-xs-6" },
	                    _react2.default.createElement(
	                        "h1",
	                        { className: "filter-header-title" },
	                        "Filters"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-xs-6 hidden-md-up", onClick: function onClick(event) {
	                            var self = $(event.currentTarget),
	                                parent = self.closest('.filter-browser');
	                            if (!parent.hasClass('active')) {
	                                parent.addClass('active');
	                            } else {
	                                parent.removeClass('active');
	                            }
	                        } },
	                    _react2.default.createElement(
	                        "a",
	                        { href: "#", className: "btn btn-link no-padding pull-right js-toggle-hidden-filters" },
	                        _react2.default.createElement("i", { className: "icon icon-arrow-down color-purple" })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "filter-content clearfix" },
	            _react2.default.createElement(_FacetController2.default, props)
	        )
	    );
	}

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = MatrixView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Product(_ref) {
	    var product = _ref.product,
	        labels = _ref.labels,
	        onPurchase = _ref.onPurchase,
	        onRemove = _ref.onRemove;
	
	
	    var Image = _ComponentRegistry2.default.get("Image");
	    var ImagePlaceholder = _ComponentRegistry2.default.get("ImagePlaceholder");
	
	    return _react2.default.createElement(
	        "div",
	        { className: "compare-item" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "div",
	                { className: "product-image" },
	                _react2.default.createElement(
	                    "a",
	                    { className: "btn btn-close", href: "", onClick: function onClick(event) {
	                            event.preventDefault();
	                            onRemove();
	                        } },
	                    _react2.default.createElement("i", { className: "icon icon-close white" })
	                ),
	                product.properties.images.value.length > 0 ? _react2.default.createElement(Image, { className: "img-fluid", src: product.properties.images.value[0].thumb, alt: product.title }) : _react2.default.createElement(ImagePlaceholder, null)
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                product.title
	            )
	        )
	    );
	}
	
	function Header(_ref2) {
	    var products = _ref2.products,
	        labels = _ref2.labels,
	        differenceOnly = _ref2.differenceOnly,
	        onDifferenceOnly = _ref2.onDifferenceOnly,
	        _onPurchase = _ref2.onPurchase,
	        _onRemove = _ref2.onRemove;
	
	    return _react2.default.createElement(
	        "thead",
	        null,
	        _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: "radio" },
	                        _react2.default.createElement("input", { className: "radio-input", id: "allProperties", type: "radio", name: "differenceOnly", onChange: function onChange(event) {
	                                return onDifferenceOnly(false);
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { className: "radio-label", htmlFor: "allProperties" },
	                            " ",
	                            labels.all_properties
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: "radio" },
	                        _react2.default.createElement("input", { className: "radio-input", type: "radio", id: "differenceOnly", name: "differenceOnly", onChange: function onChange(event) {
	                                return onDifferenceOnly(true);
	                            } }),
	                        _react2.default.createElement(
	                            "label",
	                            { className: "radio-label", htmlFor: "differenceOnly" },
	                            " ",
	                            labels.difference_only
	                        )
	                    )
	                )
	            ),
	            products.map(function (product) {
	                return _react2.default.createElement(
	                    "td",
	                    { key: product.id },
	                    _react2.default.createElement(Product, { product: product,
	                        labels: labels,
	                        onRemove: function onRemove() {
	                            return _onRemove(product);
	                        },
	                        onPurchase: function onPurchase() {
	                            return _onPurchase(product);
	                        }
	                    })
	                );
	            })
	        )
	    );
	}
	
	function PriceRow(_ref3) {
	    var products = _ref3.products,
	        matrix = _ref3.matrix,
	        label = _ref3.label;
	
	
	    var base = products[0].id;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            label
	        ),
	        products.map(function (product) {
	            return _react2.default.createElement(
	                "td",
	                { key: product.id },
	                _react2.default.createElement(Price, { pricing: product.pricing, difference: typeof matrix[base][product.id] !== 'undefined' ? matrix[base][product.id].price : null, originalPricing: product.originalPricing })
	            );
	        })
	    );
	}
	
	function Price(_ref4) {
	    var pricing = _ref4.pricing,
	        difference = _ref4.difference,
	        orignalPricing = _ref4.orignalPricing;
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        difference !== null ? _react2.default.createElement(
	            "span",
	            { className: "label label-" + (difference.excl.indexOf("-") > 0 ? "success" : "danger") },
	            difference.excl
	        ) : null
	    );
	}
	
	function PropertyRow(_ref5) {
	    var property = _ref5.property,
	        products = _ref5.products;
	
	    if (products[0].properties[property] !== undefined) {
	        return _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	                "td",
	                { className: "text-upper" },
	                products[0].properties[property].name
	            ),
	            products.map(function (product) {
	                return _react2.default.createElement(
	                    "td",
	                    { key: product.id },
	                    _react2.default.createElement(Property, { property: product.properties[property] })
	                );
	            })
	        );
	    } else {
	        return null;
	    }
	}
	
	function Property(_ref6) {
	    var property = _ref6.property;
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        (typeof property === "undefined" ? "undefined" : _typeof(property)) === 'object' ? _typeof(property.value) === 'object' ? property.value.name : property.value : "-"
	    );
	}
	
	function MatrixView(_ref7) {
	    var properties = _ref7.properties,
	        products = _ref7.products,
	        matrix = _ref7.matrix,
	        labels = _ref7.labels,
	        differenceOnly = _ref7.differenceOnly,
	        onDifferenceOnly = _ref7.onDifferenceOnly,
	        onPurchase = _ref7.onPurchase,
	        onRemove = _ref7.onRemove;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "table-responsive" },
	        _react2.default.createElement(
	            "table",
	            { className: "table" },
	            _react2.default.createElement(Header, { products: products,
	                labels: labels,
	                differenceOnly: differenceOnly,
	                onDifferenceOnly: onDifferenceOnly,
	                onPurchase: onPurchase,
	                onRemove: onRemove
	            }),
	            _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(PriceRow, { products: products, matrix: matrix, label: labels.price_difference }),
	                properties.filter(function (property) {
	                    return !differenceOnly || products.some(function (product) {
	                        return _typeof(product.properties[property].value) === "object" ? product.properties[property].value.id !== products[0].properties[property].value.id : product.properties[property].value !== products[0].properties[property].value;
	                    });
	                }).map(function (property) {
	                    return _react2.default.createElement(PropertyRow, { key: property, property: property, products: products });
	                })
	            )
	        )
	    );
	}

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PanelProductView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PanelProductView(_ref) {
	    var title = _ref.title,
	        image = _ref.image,
	        pricing = _ref.pricing,
	        matrix = _ref.matrix,
	        onRemove = _ref.onRemove;
	
	    var Image = _ComponentRegistry2.default.get("Image");
	    return _react2.default.createElement(
	        "div",
	        { className: "compare-item list-item col-md-3 col-xs-12" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "div",
	                { className: "product-image" },
	                _react2.default.createElement(Image, { className: "img-fluid hidden-sm-down", src: image }),
	                _react2.default.createElement(
	                    "a",
	                    { className: "btn btn-close", href: "", onClick: function onClick(event) {
	                            event.preventDefault();
	                            onRemove();
	                        } },
	                    _react2.default.createElement("i", { className: "icon icon-close white" })
	                )
	            ),
	            _react2.default.createElement(
	                "p",
	                { className: "product-title text-xs-left text-center" },
	                title
	            )
	        )
	    );
	}

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _Utils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PanelView(_ref) {
	    var products = _ref.products,
	        matrix = _ref.matrix,
	        url = _ref.url,
	        error = _ref.error,
	        labels = _ref.labels,
	        _onRemove = _ref.onRemove;
	
	    if (products.length === 0) {
	        return null;
	    }
	
	    var ProductView = _ComponentRegistry2.default.get("ProductCompareViewsPanelProductView");
	
	    var base = products[0].id;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "panel-compare collapse" },
	        error != null && _react2.default.createElement(
	            "div",
	            { className: "error-message" },
	            _react2.default.createElement(
	                "div",
	                { className: "container inner" },
	                error
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-xs-6 col-xs-push-6 col-md-9 col-md-push-3" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "actions" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "btn-hide", onClick: function onClick(e) {
	                                    var compareBox = $('.panel-compare'),
	                                        textHide = e.target.dataset.hide,
	                                        textShow = e.target.dataset.show;
	                                    if (compareBox.hasClass('collapsed')) {
	                                        compareBox.removeClass('collapsed').addClass('collapse');
	                                        $(e.target).find('.text').html(textShow);
	                                    } else {
	                                        compareBox.removeClass('collapse').addClass('collapsed');
	                                        $(e.target).find('.text').html(textHide);
	                                    }
	                                }, "data-show": labels.show, "data-hide": labels.hide, href: "#" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text" },
	                                labels.show
	                            ),
	                            _react2.default.createElement("i", { className: "icon icon-arrow-down" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "compare-items row" },
	                        products.map(function (product) {
	                            return _react2.default.createElement(ProductView, _extends({ key: product.id }, product, { matrix: matrix[base][product.id], onRemove: function onRemove() {
	                                    return _onRemove(product);
	                                } }));
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-xs-6 col-xs-pull-6 col-md-3 col-md-pull-9" },
	                    _react2.default.createElement(
	                        "h2",
	                        null,
	                        labels.title
	                    ),
	                    _react2.default.createElement(
	                        "section",
	                        { className: "aside-content" },
	                        labels.description
	                    ),
	                    _react2.default.createElement(
	                        "a",
	                        { href: url + "?" + (0, _Utils.objectToQueryString)({ products: products.map(function (product) {
	                                    return product.sku;
	                                }) }), className: "btn btn-primary btn-sm" },
	                        labels.compare
	                    )
	                )
	            )
	        )
	    );
	}
	exports.default = PanelView;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ProductView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProductView(_ref) {
	    var id = _ref.id,
	        isCompared = _ref.isCompared,
	        error = _ref.error,
	        labels = _ref.labels,
	        onChange = _ref.onChange;
	
	    return _react2.default.createElement(
	        "div",
	        { className: error ? "product-compare has-error" : "product-compare" },
	        _react2.default.createElement(
	            "div",
	            { className: "checkbox" },
	            _react2.default.createElement("input", { id: id, type: "checkbox", checked: isCompared, onChange: onChange }),
	            _react2.default.createElement(
	                "label",
	                { htmlFor: id, className: "form-label" },
	                labels.label
	            )
	        ),
	        error ? _react2.default.createElement(
	            "div",
	            { className: "error-message" },
	            error
	        ) : null
	    );
	}

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _StepperController = __webpack_require__(24);
	
	var _StepperController2 = _interopRequireDefault(_StepperController);
	
	var _VariationController = __webpack_require__(194);
	
	var _VariationController2 = _interopRequireDefault(_VariationController);
	
	var _WishlistController = __webpack_require__(195);
	
	var _WishlistController2 = _interopRequireDefault(_WishlistController);
	
	var _PricingController = __webpack_require__(192);
	
	var _PricingController2 = _interopRequireDefault(_PricingController);
	
	var _PersonalisationController = __webpack_require__(191);
	
	var _PersonalisationController2 = _interopRequireDefault(_PersonalisationController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PackagingUnitsView(_ref) {
	    var packageUnits = _ref.packageUnits;
	
	    if (packageUnits.length === 0) {
	        return null;
	    }
	    return _react2.default.createElement(
	        "fieldset",
	        null,
	        _react2.default.createElement(
	            "ul",
	            { className: "box-text list-none" },
	            packageUnits.map(function (packageUnit, index) {
	                return _react2.default.createElement(
	                    "li",
	                    { key: index, className: "list-item" },
	                    packageUnit.label
	                );
	            })
	        )
	    );
	}
	PackagingUnitsView.propTypes = {
	    packageUnits: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        label: _react.PropTypes.string.isRequired
	    }).isRequired)
	};
	
	function VolumePricing(_ref2) {
	    var volumePricing = _ref2.volumePricing;
	
	    if (Object.values(volumePricing).length === 0) {
	        return null;
	    }
	    var volumePrices = Object.values(volumePricing).map(function (volumePrice, index) {
	        return _react2.default.createElement(
	            "li",
	            { key: index, className: "list-item" },
	            _react2.default.createElement(
	                "span",
	                null,
	                volumePrice.label
	            )
	        );
	    });
	    return _react2.default.createElement(
	        "fieldset",
	        null,
	        _react2.default.createElement(
	            "ul",
	            { className: "box-text list-none" },
	            volumePrices
	        )
	    );
	}
	VolumePricing.propTypes = {
	    volumePricing: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        label: _react.PropTypes.string.isRequired
	    }).isRequired)
	};
	
	function Feedback(_ref3) {
	    var feedback = _ref3.feedback;
	
	    if (!feedback) {
	        return null;
	    }
	    return _react2.default.createElement(
	        "div",
	        { className: 'alert alert-' + feedback.type },
	        feedback.message
	    );
	}
	
	Feedback.propTypes = {
	    feedback: _react.PropTypes.shape({
	        type: _react.PropTypes.string.isRequired,
	        message: _react.PropTypes.string.isRequired
	    })
	};
	
	function PurchaseView(_ref4) {
	    var product = _ref4.product,
	        variations = _ref4.variations,
	        quantity = _ref4.quantity,
	        priceInclVat = _ref4.priceInclVat,
	        labels = _ref4.labels,
	        pricing = _ref4.pricing,
	        feedback = _ref4.feedback,
	        wishlist = _ref4.wishlist,
	        personalisation = _ref4.personalisation,
	        customizedProperties = _ref4.customizedProperties,
	        onPurchase = _ref4.onPurchase,
	        _onChange = _ref4.onChange,
	        onUpdateProduct = _ref4.onUpdateProduct,
	        onCustomizedPropertiesChange = _ref4.onCustomizedPropertiesChange;
	
	    var Price = _ComponentRegistry2.default.get("ProductPurchasAtomsPrice");
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "field-group pull-right" },
	            _react2.default.createElement(
	                "div",
	                { className: "field-label" },
	                _react2.default.createElement(_StepperController2.default, {
	                    value: quantity,
	                    onChange: function onChange(value) {
	                        return _onChange({ quantity: value });
	                    },
	                    min: product.minimumPurchaseAmount,
	                    step: product.multipleFactor,
	                    labels: labels
	                })
	            ),
	            product.state !== "purchasable" ? _react2.default.createElement(
	                "span",
	                { className: "btn btn-primary disabled" },
	                labels.states[product.state]
	            ) : _react2.default.createElement(
	                "button",
	                { onClick: onPurchase, className: "btn btn-primary" },
	                labels.purchase
	            )
	        ),
	        _react2.default.createElement(Feedback, { feedback: feedback })
	    );
	}
	exports.default = PurchaseView;
	PurchaseView.propTypes = {
	    product: _react.PropTypes.shape({
	        state: _react.PropTypes.string.isRequired,
	        packageUnits: _react.PropTypes.array.isRequired,
	        volumePricing: _react.PropTypes.array.isRequired,
	        distinguishingProperties: _react.PropTypes.shape.isRequired,
	        minimumPurchaseAmount: _react.PropTypes.number.isRequired,
	        multipleFactor: _react.PropTypes.number.isRequired
	    }).isRequired,
	    customizedProperties: _react.PropTypes.shape({}).isRequired,
	    labels: _react.PropTypes.shape({
	        states: _react.PropTypes.shape({}).isRequired,
	        purchase: _react.PropTypes.string.isRequired
	    }).isRequired,
	    priceInclVat: _react.PropTypes.bool.isRequired,
	    quantity: _react.PropTypes.number.isRequired,
	    feedback: _react.PropTypes.shape({
	        type: _react.PropTypes.string.isRequired,
	        message: _react.PropTypes.string.isRequired
	    }),
	    pricing: _react.PropTypes.shape({}),
	    wishlist: _react.PropTypes.shape({}),
	    variations: _react.PropTypes.shape({}),
	    personalisation: _react.PropTypes.shape({}),
	    onUpdateProduct: _react.PropTypes.func.isRequired,
	    onPurchase: _react.PropTypes.func.isRequired,
	    onChange: _react.PropTypes.func.isRequired,
	    onCustomizedPropertiesChange: _react.PropTypes.func.isRequired
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(107);
	
	__webpack_require__(108);
	
	__webpack_require__(110);
	
	__webpack_require__(109);
	
	__webpack_require__(111);
	
	__webpack_require__(112);
	
	__webpack_require__(116);
	
	__webpack_require__(113);
	
	__webpack_require__(117);
	
	__webpack_require__(115);
	
	__webpack_require__(114);

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*jslint node: true */
	/*jshint browserify: true */
	"use strict";
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(5);
	
	__webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!global._babelPolyfill) {
	    __webpack_require__(44);
	}
	
	if (!global.$) {
	    global.$ = _jquery2.default;
	}
	
	window.initializeComponent = function (name, props, id) {
	    return (0, _reactDom.render)((0, _react.createFactory)(_ComponentRegistry2.default.get(name))(props), document.getElementById(id));
	};
	window.initializeStore = function (name, initialValue) {
	    _ComponentRegistry2.default.initializeStore(name, initialValue);
	};
	
	// toggle
	(0, _jquery2.default)('.toggle').on('change', function () {
	    var toggle = (0, _jquery2.default)(this);
	    toggle.is(':checked') ? (0, _jquery2.default)(toggle.data('target')).show() : (0, _jquery2.default)(toggle.data('target')).hide();
	});
	
	// toggle-inverse
	(0, _jquery2.default)('.toggle-inverse').on('change', function () {
	    var toggleInverse = (0, _jquery2.default)(this);
	    toggleInverse.is(':checked') ? (0, _jquery2.default)(toggleInverse.data('target')).hide() : (0, _jquery2.default)(toggleInverse.data('target')).show();
	});
	
	(0, _jquery2.default)('.toggle, .toggle-inverse').trigger('change');
	
	/**
	 * ------------------------------------------------------------------------
	 * Product detail gallery
	 * ------------------------------------------------------------------------
	 */
	
	(0, _jquery2.default)(window).ready(function () {
	    var gallery = (0, _jquery2.default)('section.product-gallery');
	    var limitN = 0;
	    var limitP = 0;
	
	    if (gallery.length) {
	        var items = gallery.find('.gallery-item'),
	            detail = gallery.find('.gallery-detail'),
	            videoDetail = gallery.find('.gallery-modal .modal-body'),
	            videoTitle = gallery.find('.gallery-modal .modal-title'),
	            zoom = gallery.find('.gallery-modal'),
	            zoomImg = zoom.find('img.modal-image'),
	            zoomToggle = gallery.find('.gallery-toggle'),
	            activeImage = detail.find('img').attr('src'),
	            galleryItems = gallery.find('.gallery-items'),
	            pagination = gallery.find('.gallery-paging .list-item>a'),
	            itemWidth = (0, _jquery2.default)(items[0]).width() + 30.5,
	            // itemWidth + padding 
	        widthContainer = itemWidth * items.length,
	            // itemWidth * total items 
	        counter = 0,
	            currentStatus = gallery.find('.js-current-status'),
	            btnClose = zoom.find('.btn-close');
	
	        setVisibleItems(0, 3, items);
	
	        btnClose.on('click', function (e) {
	            e.preventDefault();
	            zoom.toggle();
	            videoDetail.html('');
	        });
	
	        items.each(function (i) {
	            var self = (0, _jquery2.default)(this);
	
	            self.find('a').on('click', function (e) {
	                e.preventDefault();
	                activeImage = (0, _jquery2.default)(this).data('path');
	
	                removeActiveClass(items);
	                var parent = (0, _jquery2.default)(this).closest('.gallery-item');
	                if (!parent.hasClass('active')) parent.addClass('active');
	
	                var videoWidget = detail.find('.widget-video');
	
	                if (videoWidget) {
	                    videoWidget.remove();
	                }
	
	                if ((0, _jquery2.default)(this).data('type') == 'video') {
	                    /*video
	                        .find('img')
	                        .hide();*/
	                    videoDetail.html('<div class="widget-video"><iframe width="560" height="315" src="' + (0, _jquery2.default)(this).data('path') + '" frameborder="0" allowfullscreen></iframe></div>');
	                    videoTitle.html((0, _jquery2.default)(this).attr('data-title'));
	                    //zoomToggle.hide();
	                    zoom.toggle();
	                } else {
	                    detail.attr('href', activeImage).find('img').show().attr('src', activeImage);
	
	                    zoomToggle.show();
	                }
	
	                // check if pagination is active
	                if (pagination.length >= 1) {
	                    // check if center-item, and reset to correct value
	                    var currentItem = (0, _jquery2.default)(items[self.index()]),
	                        visibleItem = currentItem.attr('data-order');
	                    if (visibleItem == 1) {
	                        limitN = 1;
	                        limitP = 1;
	                    } else if (visibleItem == 2) {
	                        limitN = 2;
	                        limitP = 2;
	                    } else {
	                        limitN = 0;
	                        limitP = 0;
	                    }
	                    currentStatus.html(self.index() + 1);
	
	                    //
	                    var tempActiveItem = (0, _jquery2.default)(items[getPositionActiveItem(items)]).find('a').attr('data-path');
	                    activeImage = tempActiveItem;
	
	                    zoom.on('show.bs.modal', function (e) {
	                        zoomImg.attr('src', tempActiveItem);
	                    });
	                }
	            });
	        });
	
	        zoom.on('show.bs.modal', function (e) {
	            zoomImg.attr('src', activeImage);
	        });
	
	        detail.on('click', function (e) {
	            e.preventDefault();
	            zoomToggle.trigger('click');
	        });
	
	        // Set width container
	        if (pagination.length >= 1) {
	            galleryItems.css('width', widthContainer + 'px');
	        }
	
	        pagination.each(function () {
	            (0, _jquery2.default)(this).on('click', function (e) {
	                e.preventDefault();
	                var self = (0, _jquery2.default)(e.currentTarget),
	                    action = self.attr('data-action'),
	                    posActiveItem = getPositionActiveItem(items);
	                switch (action) {
	                    case 'next':
	                        if (posActiveItem + 1 >= items.length) {
	                            posActiveItem = 0;
	                        } else {
	                            posActiveItem++;
	                        }
	                        updateActiveItem(action, posActiveItem, items, itemWidth, pagination);
	                        break;
	                    case 'prev':
	                        if (posActiveItem == 0) {
	                            posActiveItem = items.length - 1;
	                        } else {
	                            posActiveItem--;
	                        }
	                        updateActiveItem(action, posActiveItem, items, itemWidth, pagination);
	                        break;
	                }
	            });
	        });
	    }
	
	    function updateActiveItem(action, current, items, itemWidth, pagination) {
	        var self = (0, _jquery2.default)(items[current]),
	            type = self.attr('data-type'),
	            path = self.find('a').attr('data-path'),
	            detail = gallery.find('.gallery-detail'),
	            videoDetail = gallery.find('.gallery-modal .modal-body'),
	            detailImage = detail.find('img').attr('src'),
	            zoom = gallery.find('.gallery-modal'),
	            zoomImg = zoom.find('img.modal-image'),
	            zoomToggle = gallery.find('.gallery-toggle'),
	            currentStatus = gallery.find('.js-current-status'),
	            container = gallery.find('.gallery-items'),
	            containerOffset = container.position();
	        //
	        // remove old active class
	        removeActiveClass(items);
	        // set new active class
	        if (!(0, _jquery2.default)(items[current]).hasClass('active')) (0, _jquery2.default)(items[current]).addClass('active');
	
	        // update active image/video
	        var videoWidget = detail.find('.widget-video');
	
	        if (videoWidget) {
	            videoWidget.remove();
	        }
	
	        if (type == 'video') {
	            detail.find('img').hide();
	
	            videoDetail.hide('<div class="widget-video"><iframe width="560" height="315" src="' + path + '" frameborder="0" allowfullscreen></iframe></div>');
	            zoomToggle.hide();
	        } else {
	            detail.attr('href', path).find('img').show().attr('src', path);
	
	            zoom.on('show.bs.modal', function (e) {
	                zoomImg.attr('src', path);
	            });
	
	            zoomToggle.show();
	        }
	        // update current status
	        currentStatus.html(current + 1);
	
	        //
	        var orderItem = self.attr('data-order');
	        if (action == 'next') {
	            // next
	            limitN = 0;
	            limitP++;
	            if (limitP > 2) container.css('left', containerOffset.left - itemWidth + 'px');
	            if (current == 0) {
	                container.css('left', 0 + 'px');
	                limitP = 0;
	                setVisibleItems(current, 3, items);
	            }
	            if (orderItem == undefined && current < items.length && current > 0) {
	                current = current - 2;
	                setVisibleItems(current, 3, items);
	            }
	        } else {
	            // previous
	            limitP = 0;
	            limitN++;
	            if (limitN > 2) container.css('left', containerOffset.left + itemWidth + 'px');
	            if (current == items.length - 1) {
	                var maxLength = itemWidth * (items.length - 3);
	                container.css('left', '-' + maxLength + 'px');
	                limitN = 0;
	                setVisibleItems(current - 2, 3, items);
	            }
	            if (orderItem == undefined && current < items.length - 1) {
	                setVisibleItems(current, 3, items);
	            }
	        }
	    }
	
	    function getPositionActiveItem(list) {
	        var activeItem = 0;
	        for (var i = 0; i < list.length; i++) {
	            if ((0, _jquery2.default)(list[i]).hasClass('active')) {
	                activeItem = (0, _jquery2.default)(list[i]).index();
	            }
	        }
	        return activeItem;
	    }
	
	    function removeActiveClass(list) {
	        list.each(function () {
	            if ((0, _jquery2.default)(this).hasClass('active')) (0, _jquery2.default)(this).removeClass('active');
	        });
	    }
	
	    // set visible columns
	    function setVisibleItems(currentPos, numberOfColumns, items) {
	        // remove all dataAttributes
	        for (var i = 0; i < items.length; i++) {
	            (0, _jquery2.default)(items[i]).removeAttr('data-order');
	        }
	        // set visible items
	        var counter = 0;
	        for (var _i = currentPos; _i < items.length; _i++) {
	            if (counter < numberOfColumns) {
	                var item = (0, _jquery2.default)(items[_i]);
	                item.attr('data-order', counter);
	                counter++;
	            }
	        }
	    }
	});
	
	//
	// Toggle fields customer forms checkboxes (registration)
	//
	
	var toggleCustomerNr = (0, _jquery2.default)('.js-customer-number'),
	    toggleCustomerType = (0, _jquery2.default)('.js-customer-type'),
	    toggleVatLiable = (0, _jquery2.default)('.js-vatLiable');
	
	if (toggleCustomerNr.length) {
	    var customerfield = (0, _jquery2.default)('.js-customerNr-toggle');
	    toggleCustomerNr.each(function () {
	        var toggle = (0, _jquery2.default)(this);
	        if (toggle.is(':checked') && toggle.val() == 1) {
	            // if checked
	            if (!customerfield.hasClass('active')) customerfield.slideDown(function () {
	                customerfield.addClass('active');
	            });
	        }
	    });
	    toggleFields(toggleCustomerNr, customerfield, 1);
	}
	
	if (toggleCustomerType.length) {
	    var cfield = (0, _jquery2.default)('.js-customerType-toggle');
	    toggleCustomerType.each(function () {
	        var toggle = (0, _jquery2.default)(this);
	        if (toggle.is(':checked') && toggle.val() == 'b2b') {
	            // if checked
	            if (!cfield.hasClass('active')) cfield.slideDown(function () {
	                cfield.addClass('active');
	            });
	        }
	    });
	    toggleFields(toggleCustomerType, cfield, 'b2b');
	}
	
	if (toggleVatLiable.length) {
	    var _cfield = (0, _jquery2.default)('.js-vatLiable-toggle');
	    toggleVatLiable.each(function () {
	        var toggle = (0, _jquery2.default)(this);
	        if (toggle.is(':checked') && toggle.val() == 1) {
	            // if checked
	            if (!_cfield.hasClass('active')) _cfield.slideDown(function () {
	                _cfield.addClass('active');
	            });
	        }
	    });
	    toggleFields(toggleVatLiable, _cfield, 1);
	}
	
	function toggleFields(field, toggleField, activeVal) {
	    field.on('change', function (e) {
	        var input = (0, _jquery2.default)(e.currentTarget);
	        if (input.is(':checked') && input.val() == activeVal) {
	            // show
	            if (!toggleField.hasClass('active')) toggleField.slideDown(function () {
	                toggleField.addClass('active');
	            });
	        } else {
	            // hide
	            if (toggleField.hasClass('active')) toggleField.slideUp(function () {
	                toggleField.removeClass('active');
	            });
	        }
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Choice;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Choice(props) {
	    if (!props.forceRender && Object.keys(props.choices).length == 1 && typeof props.placeholder === 'undefined') {
	        return _react2.default.createElement(
	            'div',
	            null,
	            Object.keys(props.choices).map(function (value) {
	                return _react2.default.createElement(
	                    'label',
	                    { key: value },
	                    _react2.default.createElement('input', { type: 'hidden', name: props.name, value: value }),
	                    ' ',
	                    props.choices[value]
	                );
	            })
	        );
	    }
	
	    var Component = _ComponentRegistry2.default.get(props.expanded ? 'MultiCheckbox' : 'Dropdown');
	    return _react2.default.createElement(Component, props);
	}
	
	Choice.defaultProps = {
	    expanded: false,
	    multiple: false,
	    forceRender: false,
	    choices: []
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DeleteButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DeleteButton(_ref) {
	    var url = _ref.url,
	        onClick = _ref.onClick,
	        className = _ref.className,
	        children = _ref.children;
	
	    var onClickHandle = function onClickHandle(e) {
	        if (onClick) {
	            e.preventDefault();
	            onClick();
	        }
	    };
	
	    return _react2.default.createElement(
	        "button",
	        { href: url, className: className, onClick: onClickHandle },
	        children
	    );
	}
	
	DeleteButton.propTypes = {
	    className: _react2.default.PropTypes.string,
	    onClick: _react2.default.PropTypes.func,
	    url: _react2.default.PropTypes.string,
	    children: _react2.default.PropTypes.node
	};
	
	DeleteButton.defaultProps = {
	    className: "icon remove"
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Dropdown;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Dropdown(_ref) {
	  var choices = _ref.choices,
	      value = _ref.value,
	      placeholder = _ref.placeholder,
	      availableChoices = _ref.availableChoices,
	      onChange = _ref.onChange;
	
	  var currentValue = value && choices[value] ? choices[value] : placeholder;
	  var placeholderNode = _react2.default.createElement(
	    "a",
	    {
	      href: "#placeholder", className: "dropdown-item", key: "-placeholder-", onClick: function onClick(event) {
	        event.preventDefault();
	        onChange(null);
	      }
	    },
	    placeholder
	  );
	  var options = Object.keys(choices).map(function (key) {
	    return _react2.default.createElement(
	      "a",
	      {
	        key: key,
	        href: "#" + key,
	        className: "dropdown-item" + (availableChoices && !availableChoices[key] ? " disabled" : ""),
	        onClick: function onClick(event) {
	          event.preventDefault();
	          onChange(key);
	        }
	      },
	      choices[key]
	    );
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: "btn-group btn-dropdown-group btn-block" },
	    _react2.default.createElement(
	      "button",
	      { type: "button", className: "btn btn-dropdown btn-dropdown-label", "data-toggle": "dropdown" },
	      currentValue
	    ),
	    _react2.default.createElement(
	      "button",
	      { className: "btn btn-dropdown dropdown-toggle", type: "button", "data-toggle": "dropdown" },
	      _react2.default.createElement(
	        "span",
	        { className: "sr-only" },
	        "Toggle Dropdown"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "dropdown-menu" },
	      placeholder ? placeholderNode : null,
	      options
	    )
	  );
	}
	
	Dropdown.propTypes = {
	  availableChoices: _react.PropTypes.shape({}),
	  choices: _react.PropTypes.shape({}).isRequired,
	  placeholder: _react.PropTypes.string,
	  onChange: _react.PropTypes.func,
	  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(5);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiCheckbox = function (_React$Component) {
	    _inherits(MultiCheckbox, _React$Component);
	
	    function MultiCheckbox(props) {
	        _classCallCheck(this, MultiCheckbox);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    MultiCheckbox.prototype.onChange = function onChange(event) {
	        if (this.props.onChange) {
	            if (this.props.multiple) {
	                var value = [];
	                (0, _jquery2.default)(_reactDom2.default.findDOMNode(this)).find('input:checked').each(function (index, element) {
	                    value.push(element.value);
	                });
	                this.props.onChange(value);
	            } else {
	                this.props.onChange((0, _jquery2.default)(event.target).val());
	            }
	        }
	    };
	
	    MultiCheckbox.prototype.componentDidMount = function componentDidMount() {
	        if (!this.props.expanded && Object.keys(this.props.choices).length == 1 && typeof this.props.placeholder === 'undefined' && this.props.onChange) {
	            if (this.props.multiple && this.props.value.indexOf(Object.keys(this.props.choices)[0]) < 0) {
	                this.props.onChange(Object.keys(this.props.choices));
	            } else if (this.props.value !== Object.keys(this.props.choices)[0]) {
	                this.props.onChange(Object.keys(this.props.choices)[0]);
	            }
	        }
	    };
	
	    MultiCheckbox.prototype.componentDidUpdate = function componentDidUpdate(oldProps, oldState) {
	        var root = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
	        var attribute = this.props.expanded ? 'checked' : 'selected';
	
	        // Unset all selected states
	        root.find('option, input').each(function (index, node) {
	            node[attribute] = false;
	        });
	
	        if (!this.props.multiple) {
	            if (!this.props.expanded || typeof this.props.value !== 'undefined') {
	                var nodes = root.find('[value="' + (typeof this.props.value !== 'undefined' ? this.props.value : '') + '"]');
	                if (nodes.length > 0) {
	                    nodes[0][attribute] = true;
	                }
	            }
	        } else if (typeof this.props.value !== 'undefined' && null !== this.props.value) {
	            this.props.value.forEach(function (value) {
	                var nodes = root.find('[value="' + value + '"]');
	                if (nodes.length > 0) {
	                    nodes[0][attribute] = true;
	                }
	            });
	        }
	    };
	
	    MultiCheckbox.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            Object.keys(this.props.choices).map(function (value) {
	                var checked = _this2.props.value == value;
	                if (_this2.props.multiple && typeof _this2.props.value !== 'undefined' && null !== _this2.props.value) {
	                    checked = _this2.props.value.indexOf(value) >= 0;
	                }
	                return _react2.default.createElement(
	                    'label',
	                    { key: value, className: _this2.props.multiple ? 'checkbox' : 'radio' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'input' + (checked ? ' checked' : '') },
	                        _react2.default.createElement('input', {
	                            type: _this2.props.multiple ? 'checkbox' : 'radio',
	                            name: _this2.props.name,
	                            defaultChecked: checked,
	                            value: value,
	                            disabled: _this2.props.disabled || typeof _this2.props.availableChoices !== 'undefined' && null !== _this2.props.availableChoices && typeof _this2.props.availableChoices[value] === 'undefined' ? true : false,
	                            readOnly: _this2.props.readonly,
	                            onChange: _this2.onChange.bind(_this2)
	                        })
	                    ),
	                    ' ',
	                    _this2.props.choices[value]
	                );
	            })
	        );
	    };
	
	    return MultiCheckbox;
	}(_react2.default.Component);
	
	exports.default = MultiCheckbox;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Price;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Price(_ref) {
	    var value = _ref.value,
	        originalValue = _ref.originalValue,
	        vat = _ref.vat;
	
	    var showOriginalValue = originalValue && originalValue !== value;
	    if (showOriginalValue) {
	        showOriginalValue = parseInt(value.replace(/[^\d]/g, '')) < parseInt(originalValue.replace(/[^\d]/g, ''));
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { itemProp: 'offers', itemType: 'http://schema.org/Offer', className: 'item-pricing pricing' },
	        showOriginalValue ? _react2.default.createElement(
	            's',
	            { className: 'text-danger' },
	            originalValue
	        ) : null,
	        _react2.default.createElement(
	            'span',
	            { itemProp: 'price', className: 'item-price price' },
	            value
	        ),
	        vat ? _react2.default.createElement(
	            'span',
	            { className: 'item-vat price-vat' },
	            vat
	        ) : null
	    );
	}
	
	Price.propTypes = {
	    value: _react2.default.PropTypes.string.isRequired,
	    originalValue: _react2.default.PropTypes.string,
	    vat: _react2.default.PropTypes.string
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rcSlider = __webpack_require__(233);
	
	var _rcSlider2 = _interopRequireDefault(_rcSlider);
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slider = function (_React$Component) {
	    _inherits(Slider, _React$Component);
	
	    function Slider(props) {
	        _classCallCheck(this, Slider);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.timeout = null;
	        return _this;
	    }
	
	    Slider.prototype.onChange = function onChange(value) {
	        var _this2 = this;
	
	        if (this.timeout !== null) clearTimeout(this.timeout);
	        this.timeout = setTimeout(function () {
	            _this2.props.onChange({ min: value[0], max: value[1] });
	        }, 100);
	    };
	
	    Slider.prototype.render = function render() {
	        var _this3 = this;
	
	        var defaultValue = this.props.value && this.props.value.min && this.props.value.max ? [parseInt(this.props.value.min, 10), parseInt(this.props.value.max, 10)] : [this.props.min, this.props.max];
	
	        var props = (0, _extend2.default)(true, { range: true, allowCross: false }, this.props);
	        delete props.value;
	
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: "form-control" },
	                _react2.default.createElement(_rcSlider2.default, _extends({}, props, {
	                    defaultValue: defaultValue,
	                    onChange: function onChange(value) {
	                        return _this3.onChange(value);
	                    },
	                    tipFormatter: function tipFormatter(value) {
	                        return value / 100;
	                    }
	                }))
	            )
	        );
	    };
	
	    return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;
	
	
	Slider.propTypes = {
	    value: _react.PropTypes.shape({
	        min: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	        max: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
	    }),
	    min: _react.PropTypes.number,
	    max: _react.PropTypes.number,
	    onChange: _react.PropTypes.func
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasketController = function (_React$Component) {
	    _inherits(BasketController, _React$Component);
	
	    function BasketController(props) {
	        _classCallCheck(this, BasketController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore(_this.props.store);
	        _this.store.listen(function (data) {
	            return _this.setState(data);
	        });
	
	        _this.state = _this.store.state;
	        return _this;
	    }
	
	    BasketController.prototype.render = function render() {
	        var BasketView = _ComponentRegistry2.default.get(this.props.view);
	        var BasketEmptyView = _ComponentRegistry2.default.get(this.props.emptyView);
	
	        if (this.state.items.length === 0) {
	            return _react2.default.createElement(BasketEmptyView, this.props);
	        }
	
	        return _react2.default.createElement(BasketView, _extends({}, this.props, { value: this.state }));
	    };
	
	    return BasketController;
	}(_react2.default.Component);
	
	exports.default = BasketController;
	
	
	BasketController.propTypes = {
	    store: _react2.default.PropTypes.string,
	    view: _react2.default.PropTypes.string,
	    emptyView: _react2.default.PropTypes.string
	
	};
	
	BasketController.defaultProps = {
	    store: "BasketStore",
	    view: "BasketViewsBasketView",
	    emptyView: "BasketViewsEmptyBasketView"
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasketListController = function (_React$Component) {
	    _inherits(BasketListController, _React$Component);
	
	    function BasketListController(props) {
	        _classCallCheck(this, BasketListController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.xhr = {};
	        _this.store = _ComponentRegistry2.default.getStore(_this.props.store);
	        return _this;
	    }
	
	    BasketListController.prototype.onUpdate = function onUpdate(basketItem, changes) {
	        var _this2 = this;
	
	        this.xhr[basketItem.id] = (0, _jquery.ajax)({
	            url: this.props.updateUrl,
	            data: (0, _extend2.default)(true, { id: basketItem.id }, changes),
	            method: "post",
	            dataType: "json",
	            beforeSend: function beforeSend() {
	                if (typeof this.xhr[basketItem.id] !== "undefined") {
	                    this.xhr[basketItem.id].abort();
	                }
	            },
	
	            success: function success(data) {
	                _this2.store.load((0, _extend2.default)({
	                    feedback: {
	                        message: data.message,
	                        type: data.type
	                    }
	                }, data.basket));
	            }
	        });
	    };
	
	    BasketListController.prototype.onRemove = function onRemove(basketItem) {
	        var _this3 = this;
	
	        this.xhr[basketItem.id] = (0, _jquery.ajax)({
	            url: this.props.removeUrl,
	            data: { id: basketItem.id },
	            method: "post",
	            dataType: "json",
	            beforeSend: function beforeSend() {
	                if (typeof this.xhr[basketItem.id] !== "undefined") {
	                    this.xhr[basketItem.id].abort();
	                }
	            },
	
	            success: function success(result) {
	                _this3.store.load(result.basket);
	            }
	        });
	    };
	
	    BasketListController.prototype.render = function render() {
	        var _this4 = this;
	
	        var BasketItemView = _ComponentRegistry2.default.get(this.props.itemView);
	        var BasketListView = _ComponentRegistry2.default.get(this.props.view);
	
	        var items = Object.values(this.props.items).map(function (basketItem) {
	            return _react2.default.createElement(BasketItemView, {
	                key: basketItem.id,
	                item: basketItem,
	                onUpdate: function onUpdate(changes) {
	                    return _this4.onUpdate(basketItem, changes);
	                },
	                onRemove: function onRemove() {
	                    return _this4.onRemove(basketItem);
	                },
	                labels: _this4.props.labels
	            });
	        });
	
	        return _react2.default.createElement(
	            BasketListView,
	            null,
	            items
	        );
	    };
	
	    return BasketListController;
	}(_react2.default.Component);
	
	exports.default = BasketListController;
	
	BasketListController.propTypes = {
	    store: _react2.default.PropTypes.string,
	    items: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        id: _react.PropTypes.string.isRequired
	    })).isRequired,
	    updateUrl: _react.PropTypes.string.isRequired,
	    removeUrl: _react.PropTypes.string.isRequired,
	    view: _react.PropTypes.string.isRequired,
	    itemView: _react.PropTypes.string.isRequired,
	    labels: _react.PropTypes.shape({}).isRequired
	};
	BasketListController.defaultProps = {
	    view: "BasketViewsBasketListView",
	    itemView: "BasketViewsBasketItemView"
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CouponController = function (_React$Component) {
	    _inherits(CouponController, _React$Component);
	
	    function CouponController(props) {
	        _classCallCheck(this, CouponController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore(_this.props.store);
	        _this.state = { code: null, _token: _this.props.token };
	        return _this;
	    }
	
	    CouponController.prototype.onAdd = function onAdd() {
	        var _this2 = this;
	
	        (0, _jquery.ajax)(this.props.url, {
	            data: this.state,
	            method: "POST",
	            dataType: "json",
	            success: function success(data) {
	                _this2.store.load((0, _extend2.default)({
	                    feedback: {
	                        message: data.message,
	                        type: data.type
	                    }
	                }, data.basket));
	
	                if (data.type === "success") {
	                    _this2.setState({ code: "", _token: data.token });
	                } else {
	                    _this2.setState({ _token: data.token });
	                }
	            }
	        });
	    };
	
	    CouponController.prototype.render = function render() {
	        var _this3 = this;
	
	        var CouponView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(CouponView, _extends({}, this.props, {
	            value: this.state.code,
	            onAdd: function onAdd() {
	                return _this3.onAdd();
	            },
	            onChange: function onChange(code) {
	                return _this3.setState({ code: code });
	            }
	        }));
	    };
	
	    return CouponController;
	}(_react2.default.Component);
	
	exports.default = CouponController;
	
	
	CouponController.propTypes = {
	    store: _react2.default.PropTypes.string,
	    url: _react2.default.PropTypes.string.isRequired,
	    token: _react2.default.PropTypes.string.isRequired,
	    view: _react2.default.PropTypes.string.isRequired
	};
	
	CouponController.defaultProps = {
	    view: "BasketViewsCouponView"
	};

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscountsController = function (_React$Component) {
	    _inherits(DiscountsController, _React$Component);
	
	    function DiscountsController(props) {
	        _classCallCheck(this, DiscountsController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore(_this.props.store);
	        return _this;
	    }
	
	    DiscountsController.prototype.onRemove = function onRemove(discount) {
	        var _this2 = this;
	
	        (0, _jquery.ajax)(this.props.removeUrl, {
	            data: { id: discount.id },
	            method: "POST",
	            dataType: "json",
	            success: function success(data) {
	                _this2.store.load((0, _extend2.default)({
	                    feedback: {
	                        message: data.message,
	                        type: data.type
	                    }
	                }, data.basket));
	            }
	        });
	    };
	
	    DiscountsController.prototype.render = function render() {
	        var _this3 = this;
	
	        var DiscountView = _ComponentRegistry2.default.get(this.props.itemView);
	        var DiscountListView = _ComponentRegistry2.default.get(this.props.view);
	
	        var items = Object.values(this.props.items).map(function (discount) {
	            return _react2.default.createElement(DiscountView, {
	                key: discount.id,
	                item: discount,
	                labels: _this3.props.labels,
	                onRemove: function onRemove() {
	                    return _this3.onRemove(discount);
	                }
	            });
	        });
	
	        return _react2.default.createElement(
	            DiscountListView,
	            null,
	            items
	        );
	    };
	
	    return DiscountsController;
	}(_react2.default.Component);
	
	exports.default = DiscountsController;
	
	
	DiscountsController.propTypes = {
	    store: _react2.default.PropTypes.string,
	    view: _react.PropTypes.string.isRequired,
	    itemView: _react.PropTypes.string.isRequired,
	    items: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        id: _react.PropTypes.string.isRequired
	    })).isRequired,
	    labels: _react.PropTypes.shape({}).isRequired,
	    removeUrl: _react.PropTypes.string.isRequired
	};
	
	DiscountsController.defaultProps = {
	    view: "BasketViewsDiscountListView",
	    itemView: "BasketViewsDiscountView"
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeedbackController = function (_React$Component) {
	    _inherits(FeedbackController, _React$Component);
	
	    function FeedbackController(props) {
	        _classCallCheck(this, FeedbackController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.timeout = null;
	        _this.state = { hidden: false };
	        return _this;
	    }
	
	    FeedbackController.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.state.hidden) {
	            this.setState({ hidden: false });
	        }
	    };
	
	    FeedbackController.prototype.componentDidUpdate = function componentDidUpdate() {
	        var _this2 = this;
	
	        if (!this.state.hidden && this.props.autoHide) {
	            if (this.timeout) clearTimeout(this.timeout);
	            this.timeout = setTimeout(function () {
	                _this2.setState({ hidden: true });
	            }, this.props.messageTimeout);
	        }
	    };
	
	    FeedbackController.prototype.render = function render() {
	        var _this3 = this;
	
	        if (typeof this.props.message === "undefined" || this.state.hidden) {
	            return null;
	        }
	
	        var FeedbackView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(FeedbackView, _extends({}, this.props, { onClose: function onClose() {
	                return _this3.setState({ hidden: true });
	            } }));
	    };
	
	    return FeedbackController;
	}(_react2.default.Component);
	
	exports.default = FeedbackController;
	
	
	FeedbackController.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    autoHide: _react.PropTypes.bool,
	    messageTimeout: _react.PropTypes.number,
	    message: _react.PropTypes.string
	};
	
	FeedbackController.defaultProps = {
	    view: "BasketViewsFeedbackView",
	    autoHide: false,
	    messageTimeout: 1000
	};

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderController = function (_React$Component) {
	    _inherits(HeaderController, _React$Component);
	
	    function HeaderController(props) {
	        _classCallCheck(this, HeaderController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore(_this.props.store);
	        _this.state = _this.store.state;
	        _this.store.listen(function (state) {
	            return _this.setState(state);
	        });
	        return _this;
	    }
	
	    HeaderController.prototype.render = function render() {
	        var HeaderView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(HeaderView, _extends({}, this.props, { value: this.state, count: this.state.items.length }));
	    };
	
	    return HeaderController;
	}(_react2.default.Component);
	
	exports.default = HeaderController;
	
	
	HeaderController.propTypes = {
	    store: _react2.default.PropTypes.string,
	    view: _react.PropTypes.string.isRequired
	};
	
	HeaderController.defaultProps = {
	    store: "BasketStore",
	    view: "BasketViewsHeaderView"
	};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShippingController = function (_React$Component) {
	    _inherits(ShippingController, _React$Component);
	
	    function ShippingController(props) {
	        _classCallCheck(this, ShippingController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore(_this.props.store);
	        return _this;
	    }
	
	    ShippingController.prototype.onChange = function onChange(type, country) {
	        var _this2 = this;
	
	        (0, _jquery.ajax)({
	            url: this.props.url,
	            data: {
	                type: type,
	                country: country,
	                _token: this.props.token
	            },
	            method: "post",
	            dataType: "json",
	            success: function success(result) {
	                if (result.type === "success") {
	                    _this2.store.load(result.basket);
	                }
	            }
	        });
	    };
	
	    ShippingController.prototype.render = function render() {
	        var _this3 = this;
	
	        var ShippingView = _ComponentRegistry2.default.get(this.props.view);
	        var ShippingTypeView = _ComponentRegistry2.default.get(this.props.itemView);
	
	        var types = Object.keys(this.props.types).map(function (type) {
	            return _react2.default.createElement(ShippingTypeView, _extends({}, _this3.props.types[type], {
	                type: type,
	                value: _this3.props.value,
	                price: _this3.props.pricing,
	                onChange: function onChange(country) {
	                    return _this3.onChange(type, country);
	                },
	                key: type
	            }));
	        });
	
	        return _react2.default.createElement(
	            ShippingView,
	            this.props,
	            types
	        );
	    };
	
	    return ShippingController;
	}(_react2.default.Component);
	
	exports.default = ShippingController;
	
	
	ShippingController.propTypes = {
	    store: _react2.default.PropTypes.string,
	    view: _react.PropTypes.string.isRequired,
	    itemView: _react.PropTypes.string.isRequired,
	    url: _react.PropTypes.string.isRequired,
	    token: _react.PropTypes.string.isRequired,
	    value: _react.PropTypes.shape({}),
	    pricing: _react.PropTypes.string,
	    types: _react.PropTypes.objectOf(_react.PropTypes.shape({}))
	};
	
	ShippingController.defaultProps = {
	    view: "BasketViewsShippingView",
	    itemView: "BasketViewsShippingTypeView"
	};

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	exports.createBasketStore = createBasketStore;
	
	var _AbstractStore2 = __webpack_require__(8);
	
	var _AbstractStore3 = _interopRequireDefault(_AbstractStore2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasketStore = function (_AbstractStore) {
	    _inherits(BasketStore, _AbstractStore);
	
	    function BasketStore() {
	        _classCallCheck(this, BasketStore);
	
	        var _this = _possibleConstructorReturn(this, _AbstractStore.call(this, ["load"]));
	
	        _this.state = null;
	        return _this;
	    }
	
	    BasketStore.prototype.load = function load(state) {
	        this.actions.load(state);
	    };
	
	    BasketStore.prototype.onLoad = function onLoad(state) {
	        this.state = state;
	        this.trigger(state);
	    };
	
	    return BasketStore;
	}(_AbstractStore3.default);
	
	exports.default = BasketStore;
	function createBasketStore(initialState) {
	    var store = new BasketStore();
	    store.onLoad(initialState);
	
	    return store;
	}

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CouponView(_ref) {
	  var value = _ref.value,
	      labels = _ref.labels,
	      _onChange = _ref.onChange,
	      onAdd = _ref.onAdd;
	
	  return _react2.default.createElement(
	    "tbody",
	    null,
	    _react2.default.createElement(
	      "tr",
	      null,
	      _react2.default.createElement(
	        "td",
	        null,
	        labels.title
	      ),
	      _react2.default.createElement(
	        "td",
	        { colSpan: "3" },
	        _react2.default.createElement("input", {
	          type: "text",
	          id: "couponCode",
	          className: "form-control",
	          value: value || "",
	          onChange: function onChange(event) {
	            return _onChange(event.target.value);
	          }
	        })
	      ),
	      _react2.default.createElement(
	        "td",
	        { colSpan: "3" },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "btn btn-outline-primary",
	            disabled: value === null || value.length === 0,
	            onClick: function onClick(event) {
	              event.preventDefault();
	              onAdd();
	            }
	          },
	          labels.add_coupon
	        )
	      )
	    )
	  );
	}
	
	exports.default = CouponView;
	CouponView.propTypes = {
	  value: _react.PropTypes.string,
	  labels: _react.PropTypes.shape({
	    add_coupon: _react.PropTypes.string
	  }).isRequired,
	  onAdd: _react.PropTypes.func.isRequired,
	  onChange: _react.PropTypes.func.isRequired
	};
	
	CouponView.defaultProps = {
	  value: ""
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DiscountListView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DiscountListView(_ref) {
	    var children = _ref.children;
	
	    return _react2.default.createElement(
	        "tbody",
	        null,
	        children
	    );
	}
	
	DiscountListView.propTypes = {
	    children: _react.PropTypes.arrayOf(_react.PropTypes.node).isRequired
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DiscountView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DiscountView(_ref) {
	    var item = _ref.item,
	        labels = _ref.labels,
	        onRemove = _ref.onRemove;
	
	    var DeleteButton = _ComponentRegistry2.default.get("DeleteButton");
	
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            item.code
	        ),
	        _react2.default.createElement(
	            "td",
	            { colSpan: "3" },
	            item.description
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            "- ",
	            item.value
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	                DeleteButton,
	                { onClick: onRemove },
	                labels.remove
	            )
	        )
	    );
	}
	
	DiscountView.propTypes = {
	    item: _react.PropTypes.shape({
	        code: _react.PropTypes.string,
	        description: _react.PropTypes.string,
	        value: _react.PropTypes.string
	    }).isRequired,
	    labels: _react.PropTypes.shape({
	        remove: _react.PropTypes.string
	    }).isRequired,
	    onRemove: _react.PropTypes.func.isRequired
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShippingTypeView(_ref) {
	  var title = _ref.title,
	      type = _ref.type,
	      countries = _ref.countries,
	      value = _ref.value,
	      _onChange = _ref.onChange,
	      price = _ref.price;
	
	  var Choice = _ComponentRegistry2.default.get("Choice");
	  var Price = _ComponentRegistry2.default.get("Price");
	
	  var active = type === value.type;
	  return _react2.default.createElement(
	    "tr",
	    null,
	    _react2.default.createElement(
	      "td",
	      { colSpan: "3" },
	      _react2.default.createElement("input", { type: "radio", checked: active, onChange: function onChange() {
	          return _onChange();
	        } }),
	      title
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      active && Object.keys(countries).length > 0 ? _react2.default.createElement(Choice, {
	        choices: countries,
	        placeholder: "-- select country --",
	        onChange: function onChange(country) {
	          return _onChange(country);
	        },
	        value: value.country
	      }) : null
	    ),
	    _react2.default.createElement(
	      "td",
	      null,
	      active ? _react2.default.createElement(Price, { value: price }) : null
	    ),
	    _react2.default.createElement("td", null)
	  );
	}
	
	exports.default = ShippingTypeView;
	ShippingTypeView.propTypes = {
	  title: _react.PropTypes.string,
	  type: _react.PropTypes.string,
	  value: _react.PropTypes.shape({
	    type: _react.PropTypes.string,
	    country: _react.PropTypes.string
	  }),
	  countries: _react.PropTypes.oneOfType([_react.PropTypes.objectOf(_react.PropTypes.string), _react.PropTypes.arrayOf(_react.PropTypes.string)]),
	  price: _react.PropTypes.string,
	  onChange: _react.PropTypes.func
	};

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShippingView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShippingView(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    "tbody",
	    null,
	    children
	  );
	}
	ShippingView.propTypes = {
	  children: _react.PropTypes.arrayOf(_react.PropTypes.node)
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BasketHeaderWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderController = __webpack_require__(145);
	
	var _HeaderController2 = _interopRequireDefault(_HeaderController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BasketHeaderWidget(props) {
	  return _react2.default.createElement(_HeaderController2.default, props);
	}

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = BasketWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BasketController = __webpack_require__(140);
	
	var _BasketController2 = _interopRequireDefault(_BasketController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BasketWidget(props) {
	    return _react2.default.createElement(_BasketController2.default, props);
	}

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(GoogleMapsLoader) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global GoogleMapsLoader*/
	
	function extractAddress(results) {
	    var addresObj = { postal_code: null, street_number: null, route: null };
	
	    Object.values(results[0].address_components).forEach(function (addressComponent) {
	        return Object.keys(addresObj).forEach(function (key) {
	            if (addressComponent.types.indexOf(key) >= 0) {
	                addresObj[key] = addressComponent.long_name;
	            }
	        });
	    });
	
	    return addresObj;
	}
	
	var CollectionPointsController = function (_React$Component) {
	    _inherits(CollectionPointsController, _React$Component);
	
	    function CollectionPointsController(props) {
	        _classCallCheck(this, CollectionPointsController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            address: _this.props.address,
	            value: _this.props.value,
	            view: "map",
	            markers: _this.props.markers
	        };
	        return _this;
	    }
	
	    CollectionPointsController.prototype.componentWillMount = function componentWillMount() {
	        (0, _jquery2.default)("#" + this.props.id).remove();
	    };
	
	    CollectionPointsController.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        if (typeof GoogleMapsLoader === "undefined") {
	            return;
	        }
	        GoogleMapsLoader.KEY = this.props.apiKey;
	        GoogleMapsLoader.LIBRARIES = this.props.libraries;
	        GoogleMapsLoader.LANGUAGE = this.props.language;
	        GoogleMapsLoader.REGION = this.props.region;
	        GoogleMapsLoader.load(function (google) {
	            _this2.google = google;
	            _this2.geocoder = new google.maps.Geocoder();
	        });
	    };
	
	    CollectionPointsController.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
	        var _this3 = this;
	
	        if (typeof this.geocoder !== "undefined" && this.state.view !== "map" && nextState.address !== this.state.address) {
	            this.geocoder.geocode({ address: nextState.address }, function (results, status) {
	                if (status === _this3.google.maps.GeocoderStatus.OK) {
	                    _this3.onChangeLocation(extractAddress(results), results[0].geometry.location);
	                }
	            });
	        }
	    };
	
	    CollectionPointsController.prototype.onChangeLocation = function onChangeLocation(address) {
	        var _this4 = this;
	
	        _jquery2.default.ajax({
	            url: this.props.url,
	            method: "GET",
	            data: address,
	            dataType: "json",
	            success: function success(result) {
	                if (typeof result.error === "undefined") {
	                    _this4.setState({ error: null, markers: result });
	                } else {
	                    _this4.setState({ error: result.error });
	                }
	            }
	        });
	    };
	
	    CollectionPointsController.prototype.render = function render() {
	        var _this5 = this;
	
	        var CollectionPointsView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(
	            CollectionPointsView,
	            _extends({}, this.props, this.state, {
	                onSwitchView: function onSwitchView(value) {
	                    return _this5.setState({ view: value });
	                },
	                onSearch: function onSearch(value) {
	                    return _this5.setState({ address: value, error: null });
	                },
	                onLocationChange: function onLocationChange(address) {
	                    return _this5.onChangeLocation(address);
	                },
	                onChange: function onChange(value) {
	                    return _this5.setState({ value: value });
	                }
	            }),
	            _react2.default.createElement("input", { type: "hidden", name: this.props.name, id: this.props.id, value: JSON.stringify(this.state.value) })
	        );
	    };
	
	    return CollectionPointsController;
	}(_react2.default.Component);
	
	exports.default = CollectionPointsController;
	
	
	CollectionPointsController.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    name: _react.PropTypes.string.isRequired,
	    id: _react.PropTypes.string.isRequired,
	    url: _react.PropTypes.string.isRequired,
	    markers: _react.PropTypes.arrayOf(_react.PropTypes.shape({})),
	    address: _react.PropTypes.string,
	    libraries: _react.PropTypes.arrayOf(_react.PropTypes.string),
	    apiKey: _react.PropTypes.string.isRequired,
	    language: _react.PropTypes.string,
	    region: _react.PropTypes.string
	};
	
	CollectionPointsController.defaultProps = {
	    view: "CheckoutViewsCollectionPointsView",
	    markers: []
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = CollectionPointsWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CollectionPointsController = __webpack_require__(155);
	
	var _CollectionPointsController2 = _interopRequireDefault(_CollectionPointsController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CollectionPointsWidget(props) {
	    return _react2.default.createElement(_CollectionPointsController2.default, props);
	}

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PagingController = function (_React$Component) {
	    _inherits(PagingController, _React$Component);
	
	    function PagingController() {
	        _classCallCheck(this, PagingController);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    PagingController.prototype.onChangePage = function onChangePage(page) {
	        var current = parseInt(this.props.pages.current, 10);
	
	        var actualPage = page;
	        if (page === "nextFive") {
	            actualPage = current + 5;
	        }
	        if (page === "previousFive") {
	            actualPage = current - 5;
	        }
	        if (page === "previous") {
	            actualPage = current - 1;
	        }
	        if (page === "next") {
	            actualPage = current + 1;
	        }
	        this.props.onChange(actualPage);
	    };
	
	    PagingController.prototype.render = function render() {
	        var _this2 = this;
	
	        if (typeof this.props.pages === "undefined") {
	            return null;
	        }
	        var PagingView = _ComponentRegistry2.default.get(this.props.view);
	
	        var pages = [];
	        var current = parseInt(this.props.pages.current, 10);
	        var total = parseInt(this.props.pages.total, 10);
	        if (current > 1) {
	            pages.push("previous");
	        }
	        var start = current - 2;
	        start = start > 1 ? start : 1;
	        var end = start + 4;
	        end = end < total ? end : total;
	        start = end - start < 5 ? end - 4 : start;
	        start = start > 1 ? start : 1;
	        if (current - 5 > 0) {
	            pages.push("previousFive");
	        }
	        for (var i = start; i <= end; i += 1) {
	            pages.push(i);
	        }
	        if (current + 5 <= total) {
	            pages.push("nextFive");
	        }
	        if (current < total) {
	            pages.push("next");
	        }
	
	        return _react2.default.createElement(PagingView, _extends({}, this.props, { pages: pages, current: current, onChangePage: function onChangePage(page) {
	                return _this2.onChangePage(page);
	            } }));
	    };
	
	    return PagingController;
	}(_react2.default.Component);
	
	exports.default = PagingController;
	
	PagingController.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    pages: _react.PropTypes.shape({
	        current: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired,
	        total: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired
	    }),
	    labels: _react.PropTypes.shape({}).isRequired,
	    onChange: _react.PropTypes.func.isRequired
	};
	
	PagingController.defaultProps = {
	    view: "CommonPagingView"
	};

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _AbstractStore2 = __webpack_require__(8);
	
	var _AbstractStore3 = _interopRequireDefault(_AbstractStore2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeyValueStore = function (_AbstractStore) {
	    _inherits(KeyValueStore, _AbstractStore);
	
	    function KeyValueStore() {
	        _classCallCheck(this, KeyValueStore);
	
	        var _this = _possibleConstructorReturn(this, _AbstractStore.call(this, ['load', 'set', 'unset', 'add', 'remove']));
	
	        _this.values = {};
	        return _this;
	    }
	
	    KeyValueStore.prototype.load = function load(values) {
	        this.actions.load(values);
	    };
	
	    KeyValueStore.prototype.set = function set(key, value) {
	        this.actions.set(key, value);
	    };
	
	    KeyValueStore.prototype.unset = function unset(key) {
	        this.actions.unset(key);
	    };
	
	    KeyValueStore.prototype.add = function add(key, value) {
	        this.actions.add(key, value);
	    };
	
	    KeyValueStore.prototype.remove = function remove(key, value) {
	        this.actions.remove(key, value);
	    };
	
	    KeyValueStore.prototype.onLoad = function onLoad(values) {
	        if ((typeof values === 'undefined' ? 'undefined' : _typeof(values)) !== 'object') {
	            values = {};
	        }
	        this.values = values;
	        this.trigger(this.values);
	    };
	
	    KeyValueStore.prototype.onSet = function onSet(key, value) {
	        this.values[key] = value;
	        this.trigger(this.values);
	    };
	
	    KeyValueStore.prototype.onAdd = function onAdd(key, value) {
	        if (typeof this.values[key] == 'undefined') this.values[key] = [];else this.onRemove(key, value);
	        this.values[key].push(value);
	        this.trigger(this.values);
	    };
	
	    KeyValueStore.prototype.onUnset = function onUnset(key) {
	        if (typeof this.values[key] !== 'undefined') {
	            delete this.values[key];
	            this.trigger(this.values);
	        }
	    };
	
	    KeyValueStore.prototype.onRemove = function onRemove(key, value) {
	        if (typeof this.values[key] !== 'undefined') {
	            this.values[key] = this.values[key].filter(function (val) {
	                return val !== value;
	            }, this);
	            this.trigger(this.values);
	        }
	    };
	
	    return KeyValueStore;
	}(_AbstractStore3.default);
	
	exports.default = KeyValueStore;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _AbstractStore2 = __webpack_require__(8);
	
	var _AbstractStore3 = _interopRequireDefault(_AbstractStore2);
	
	var _Utils = __webpack_require__(12);
	
	var _utils = _interopRequireWildcard(_Utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValueStore = function (_AbstractStore) {
	    _inherits(ValueStore, _AbstractStore);
	
	    function ValueStore() {
	        var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        _classCallCheck(this, ValueStore);
	
	        var _this = _possibleConstructorReturn(this, _AbstractStore.call(this, ['add', 'update', 'remove', 'load', 'clear'].concat(actions)));
	
	        _this.items = [];
	        return _this;
	    }
	
	    ValueStore.prototype.load = function load(items) {
	        this.actions.load(items);
	    };
	
	    ValueStore.prototype.add = function add(item) {
	        this.actions.add(item);
	    };
	
	    ValueStore.prototype.update = function update(item) {
	        this.actions.update(item);
	    };
	
	    ValueStore.prototype.remove = function remove(item) {
	        this.actions.remove(item);
	    };
	
	    ValueStore.prototype.clear = function clear() {
	        this.actions.clear();
	    };
	
	    ValueStore.prototype.onLoad = function onLoad(items) {
	        if (typeof items !== 'undefined' && null !== items) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var item = _step.value;
	
	                    if (null !== item) {
	                        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && typeof item.id === 'undefined') {
	                            item.id = _utils.uuid();
	                        }
	                        if (this.has(item)) {
	                            this.items = _utils.updateItem(item, this.items, 'id');
	                        } else {
	                            this.items.push(item);
	                        }
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	        this.trigger(this.items);
	    };
	
	    ValueStore.prototype.onClear = function onClear() {
	        this.items = [];
	        this.trigger(this.items);
	    };
	
	    ValueStore.prototype.onAdd = function onAdd(item) {
	        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && typeof item.id === 'undefined') {
	            item.id = _utils.uuid();
	        }
	        this.onUpdate(item);
	    };
	
	    ValueStore.prototype.onUpdate = function onUpdate(item) {
	        if (this.has(item)) {
	            this.items = _utils.updateItem(item, this.items, 'id');
	        } else {
	            this.items.push(item);
	        }
	        this.trigger(this.items);
	    };
	
	    ValueStore.prototype.onRemove = function onRemove(item) {
	        this.items = _utils.removeItem(item.id, this.items, 'id');
	        this.trigger(this.items);
	    };
	
	    ValueStore.prototype.has = function has(item) {
	        return null !== _utils.getItem(item.id, this.items, 'id');
	    };
	
	    ValueStore.prototype.get = function get(id) {
	        return _utils.getItem(id, this.items, 'id');
	    };
	
	    ValueStore.prototype.length = function length() {
	        return this.items.length;
	    };
	
	    ValueStore.prototype.all = function all() {
	        return this.items;
	    };
	
	    return ValueStore;
	}(_AbstractStore3.default);
	
	exports.default = ValueStore;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocalStorageWidget = function (_React$Component) {
	    _inherits(LocalStorageWidget, _React$Component);
	
	    function LocalStorageWidget(props) {
	        _classCallCheck(this, LocalStorageWidget);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore(_this.props.store);
	
	        _this.store.listen(function (value) {
	            return localStorage.setItem(_this.props.name, JSON.stringify(value));
	        });
	        return _this;
	    }
	
	    LocalStorageWidget.prototype.componentDidMount = function componentDidMount() {
	        var value = localStorage.getItem(this.props.name);
	        if (value !== null) {
	            this.store.load(JSON.parse(value));
	        }
	    };
	
	    LocalStorageWidget.prototype.render = function render() {
	        return null;
	    };
	
	    return LocalStorageWidget;
	}(_react2.default.Component);
	
	exports.default = LocalStorageWidget;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageGalleryController = function (_React$Component) {
	    _inherits(ImageGalleryController, _React$Component);
	
	    function ImageGalleryController(props) {
	        _classCallCheck(this, ImageGalleryController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = { current: 0, enlarged: false };
	        _this.timeout = null;
	        return _this;
	    }
	
	    ImageGalleryController.prototype.componentDidMount = function componentDidMount() {
	        this.autoRotate();
	    };
	
	    ImageGalleryController.prototype.onSelect = function onSelect(index) {
	        this.setState({ current: index });
	    };
	
	    ImageGalleryController.prototype.onNext = function onNext() {
	        this.setState({ current: this.state.current < this.props.images.length - 1 ? this.state.current + 1 : 0 });
	        this.autoRotate();
	    };
	
	    ImageGalleryController.prototype.onPrev = function onPrev() {
	        this.setState({ current: this.state.current > 0 ? this.state.current - 1 : this.props.images.length - 1 });
	        this.autoRotate();
	    };
	
	    ImageGalleryController.prototype.onToggleEnlarge = function onToggleEnlarge() {
	        this.setState({ enlarged: !this.state.enlarged });
	    };
	
	    ImageGalleryController.prototype.autoRotate = function autoRotate() {
	        var _this2 = this;
	
	        if (this.props.autoRotate) {
	            if (this.timeout !== null) clearTimeout(this.timeout);
	            this.timeout = setTimeout(function () {
	                _this2.onNext();
	            }, this.props.autoRotate * 1000);
	        }
	    };
	
	    ImageGalleryController.prototype.render = function render() {
	        var _this3 = this;
	
	        var ImageGalleryView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(
	            ImageGalleryView,
	            _extends({}, this.props, {
	                enlarged: this.state.enlarged,
	                current: this.props.images[this.state.current],
	                onNext: function onNext() {
	                    return _this3.onNext();
	                },
	                onPrev: function onPrev() {
	                    return _this3.onPrev();
	                },
	                onSelect: function onSelect(index) {
	                    return _this3.onSelect(index);
	                },
	                onToggleEnlarge: function onToggleEnlarge() {
	                    return _this3.onToggleEnlarge();
	                }
	            }),
	            this.props.images
	        );
	    };
	
	    return ImageGalleryController;
	}(_react2.default.Component);
	
	exports.default = ImageGalleryController;
	
	
	ImageGalleryController.propTypes = {
	    images: _react.PropTypes.arrayOf(_react.PropTypes.shape({})).isRequired,
	    view: _react.PropTypes.string.isRequired,
	    autoRotate: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.number])
	};
	
	ImageGalleryController.defaultProps = {
	    view: "ImageGalleryViewsImageGalleryView",
	    autoRotate: false
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DetailView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DetailView(_ref) {
	    var src = _ref.src,
	        onToggleEnlarge = _ref.onToggleEnlarge;
	
	    var Image = _ComponentRegistry2.default.get("Image");
	
	    return _react2.default.createElement(Image, { src: src, onClick: onToggleEnlarge });
	}
	DetailView.propTypes = {
	    src: _react.PropTypes.string,
	    onToggleEnlarge: _react.PropTypes.func
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageGalleryView(_ref) {
	  var thumbView = _ref.thumbView,
	      detailView = _ref.detailView,
	      current = _ref.current,
	      children = _ref.children,
	      enlarged = _ref.enlarged,
	      labels = _ref.labels,
	      onToggleEnlarge = _ref.onToggleEnlarge,
	      _onSelect = _ref.onSelect,
	      onPrev = _ref.onPrev,
	      onNext = _ref.onNext;
	
	  var ThumbView = _ComponentRegistry2.default.get(thumbView);
	  var DetailView = _ComponentRegistry2.default.get(detailView);
	
	  var controls = [];
	  controls.push(_react2.default.createElement(
	    "a",
	    {
	      key: "toggle-enlarge",
	      href: "#" + (enlarged ? "shrink" : "enlarge"),
	      className: "icon icon-" + (enlarged ? "close" : "open"),
	      onClick: onToggleEnlarge
	    },
	    enlarged ? labels.close : labels.open
	  ));
	
	  var thumbnails = Object.values(children).map(function (child, index) {
	    return _react2.default.createElement(ThumbView, _extends({ key: index }, child, { onSelect: function onSelect() {
	        return _onSelect(index);
	      } }));
	  });
	
	  if (thumbnails.length > 1) {
	    controls.push(_react2.default.createElement(
	      "a",
	      { key: "next", href: "#next", className: "icon icon-next", onClick: onNext },
	      labels.next
	    ));
	    controls.push(_react2.default.createElement(
	      "a",
	      { key: "prev", href: "#prev", className: "icon icon-prev", onClick: onPrev },
	      labels.previous
	    ));
	  }
	
	  return _react2.default.createElement(
	    "section",
	    { className: (enlarged ? "open " : "") + "gallery clearfix" },
	    _react2.default.createElement(DetailView, _extends({}, current, { onToggleEnlarge: onToggleEnlarge })),
	    thumbnails.length > 1 ? _react2.default.createElement(
	      "ul",
	      { className: "gallery-items clearfix" },
	      thumbnails
	    ) : null,
	    controls
	  );
	}
	
	exports.default = ImageGalleryView;
	ImageGalleryView.propTypes = {
	  detailView: _react.PropTypes.string.isRequired,
	  thumbView: _react.PropTypes.string.isRequired,
	  current: _react.PropTypes.shape({}),
	  children: _react.PropTypes.arrayOf(_react.PropTypes.shape({})),
	  enlarged: _react.PropTypes.bool.isRequired,
	  labels: _react.PropTypes.shape({
	    open: _react.PropTypes.string,
	    close: _react.PropTypes.string,
	    previous: _react.PropTypes.string,
	    next: _react.PropTypes.string
	  }),
	  onToggleEnlarge: _react.PropTypes.func,
	  onSelect: _react.PropTypes.func,
	  onPrev: _react.PropTypes.func,
	  onNext: _react.PropTypes.func
	};
	
	ImageGalleryView.defaultProps = {
	  detailView: "ImageGalleryViewsDetailView",
	  thumbView: "ImageGalleryViewsThumbView"
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ThumbView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ThumbView(_ref) {
	    var thumb = _ref.thumb,
	        onSelect = _ref.onSelect;
	
	    var Image = _ComponentRegistry2.default.get("Image");
	
	    return _react2.default.createElement(
	        "li",
	        { className: "gallery-item" },
	        _react2.default.createElement(Image, { src: thumb, onClick: onSelect })
	    );
	}
	
	ThumbView.propTypes = {
	    thumb: _react.PropTypes.string,
	    onSelect: _react.PropTypes.func
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ImageGalleryWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageGalleryController = __webpack_require__(161);
	
	var _ImageGalleryController2 = _interopRequireDefault(_ImageGalleryController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageGalleryWidget(props) {
	    return _react2.default.createElement(_ImageGalleryController2.default, props);
	}

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	exports.createMarkerStore = createMarkerStore;
	
	var _AbstractStore2 = __webpack_require__(8);
	
	var _AbstractStore3 = _interopRequireDefault(_AbstractStore2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarkerStore = function (_AbstractStore) {
	    _inherits(MarkerStore, _AbstractStore);
	
	    function MarkerStore() {
	        _classCallCheck(this, MarkerStore);
	
	        var _this = _possibleConstructorReturn(this, _AbstractStore.call(this, ["load", "clear", "add"]));
	
	        _this.markers = [];
	        return _this;
	    }
	
	    MarkerStore.prototype.load = function load(markers) {
	        this.actions.load(markers);
	    };
	
	    MarkerStore.prototype.clear = function clear() {
	        this.actions.clear();
	    };
	
	    MarkerStore.prototype.add = function add(marker) {
	        this.actions.add(marker);
	    };
	
	    MarkerStore.prototype.onLoad = function onLoad(markers) {
	        this.markers = markers;
	        this.trigger(this.markers);
	    };
	
	    MarkerStore.prototype.onAdd = function onAdd(marker) {
	        this.markers.push(marker);
	        this.trigger(this.markers);
	    };
	
	    MarkerStore.prototype.onClear = function onClear() {
	        Object.values(this.markers).forEach(function (marker) {
	            marker.setMap(null);
	        });
	        this.markers = [];
	        this.trigger(this.markers);
	    };
	
	    return MarkerStore;
	}(_AbstractStore3.default);
	
	exports.default = MarkerStore;
	function createMarkerStore(initialState) {
	    var store = new MarkerStore();
	    store.load(initialState);
	
	    return store;
	}

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = GoogleMapView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GoogleMapView(_ref) {
	    var children = _ref.children;
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        children
	    );
	}
	GoogleMapView.propTypes = {
	    children: _react.PropTypes.node
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = GoogleMapWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GoogleMapController = __webpack_require__(37);
	
	var _GoogleMapController2 = _interopRequireDefault(_GoogleMapController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GoogleMapWidget(props) {
	  return _react2.default.createElement(_GoogleMapController2.default, props);
	}

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacetController = function (_React$Component) {
	    _inherits(FacetController, _React$Component);
	
	    function FacetController(props) {
	        _classCallCheck(this, FacetController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore("ProductBrowserFacetStore");
	        _this.productsStore = _ComponentRegistry2.default.getStore("ProductBrowserStore");
	        _this.state = {
	            filters: _this.store.values,
	            values: _this.productsStore.filters
	        };
	
	        _this.store.listen(_this.onFacetsChange.bind(_this));
	        _this.productsStore.listen(_this.onFiltersChange.bind(_this));
	        return _this;
	    }
	
	    FacetController.prototype.onFacetsChange = function onFacetsChange(state) {
	        this.setState({ filters: state });
	    };
	
	    FacetController.prototype.onFiltersChange = function onFiltersChange(items, paging, sorting, filters) {
	        this.setState({ values: filters });
	    };
	
	    FacetController.prototype.onChange = function onChange(property, value) {
	        this.productsStore.filter(property, value);
	    };
	
	    FacetController.prototype.render = function render() {
	        var _this2 = this;
	
	        var FacetsView = _ComponentRegistry2.default.get(this.props.view);
	        var FacetView = _ComponentRegistry2.default.get(this.props.facetView);
	
	        var facets = Object.keys(this.state.filters).map(function (facet) {
	            var facetType = _this2.props.facetTypes[_this2.state.filters[facet].type];
	            if (typeof facetType !== "undefined") {
	                var Facet = _ComponentRegistry2.default.get(facetType);
	                return _react2.default.createElement(
	                    FacetView,
	                    _extends({ key: facet }, _this2.state.filters[facet]),
	                    _react2.default.createElement(Facet, _extends({}, _this2.state.filters[facet], {
	                        onChange: function onChange(value) {
	                            return _this2.onChange(facet, value);
	                        },
	                        value: _this2.state.values[facet],
	                        labels: _this2.props.labels
	                    }))
	                );
	            }
	            return null;
	        });
	
	        return _react2.default.createElement(
	            FacetsView,
	            null,
	            facets
	        );
	    };
	
	    return FacetController;
	}(_react2.default.Component);
	
	exports.default = FacetController;
	
	
	FacetController.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    facetView: _react.PropTypes.string.isRequired,
	    facetTypes: _react.PropTypes.objectOf(_react.PropTypes.string)
	};
	
	FacetController.defaultProps = {
	    view: "ProductBrowserViewsFacetsView",
	    facetView: "ProductBrowserViewsFacetView"
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _reactCookie = __webpack_require__(248);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PresentationController = function (_React$Component) {
	    _inherits(PresentationController, _React$Component);
	
	    function PresentationController(props) {
	        _classCallCheck(this, PresentationController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onChange = _this.onChange.bind(_this);
	        return _this;
	    }
	
	    PresentationController.prototype.componentWillMount = function componentWillMount() {
	        if (_reactCookie2.default.load("product-view") && _reactCookie2.default.load("product-view") !== this.props.value) {
	            this.onChange(_reactCookie2.default.load("product-view"));
	        }
	    };
	
	    PresentationController.prototype.onChange = function onChange(value) {
	        var val = value;
	        if (typeof this.props.options[val] === "undefined") {
	            val = this.props.default;
	        }
	        _reactCookie2.default.save("product-view", val, { path: "/", secure: this.props.useSecureCookie });
	
	        this.props.onChange(this.props.options[val].view);
	    };
	
	    PresentationController.prototype.render = function render() {
	        var _this2 = this;
	
	        var PresentationView = _ComponentRegistry2.default.get("ProductBrowserViewsPresentationView");
	
	        var choices = {};
	        var value = this.props.default;
	        Object.keys(this.props.options).forEach(function (key) {
	            choices[key] = _this2.props.options[key].label;
	            if (_this2.props.value === _this2.props.options[key].view) {
	                value = key;
	            }
	        });
	
	        return _react2.default.createElement(PresentationView, _extends({}, this.props, { choices: choices, value: value, onChange: this.onChange }));
	    };
	
	    return PresentationController;
	}(_react2.default.Component);
	
	exports.default = PresentationController;
	
	
	PresentationController.propTypes = {
	    options: _react.PropTypes.objectOf(_react.PropTypes.shape({
	        view: _react.PropTypes.string.isRequired,
	        label: _react.PropTypes.string.isRequired
	    })).isRequired,
	    useSecureCookie: _react.PropTypes.bool.isRequired,
	    default: _react.PropTypes.string.isRequired,
	    onChange: _react.PropTypes.func.isRequired,
	    value: _react.PropTypes.string
	};
	
	PresentationController.defaultProps = {
	    useSecureCookie: true
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductsController = function (_React$Component) {
	    _inherits(ProductsController, _React$Component);
	
	    function ProductsController(props) {
	        _classCallCheck(this, ProductsController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore(_this.props.store);
	        _this.state = {
	            products: _this.store.items,
	            paging: _this.store.paging,
	            sort: _this.store.sorting,
	            status: 'idle',
	            productView: "ProductBrowserViewsThumbView"
	        };
	
	        _this.store.listen(_this.onStoreChange.bind(_this));
	        return _this;
	    }
	
	    ProductsController.prototype.onStoreChange = function onStoreChange(products, paging, sorting, filters, status) {
	        this.setState({ products: products, paging: paging, sort: sorting, status: status });
	    };
	
	    ProductsController.prototype.render = function render() {
	        var _this2 = this;
	
	        var ProductsView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(ProductsView, _extends({}, this.props, this.state, {
	            onChangePage: function onChangePage(value) {
	                return _this2.store.switchToPage(value);
	            },
	            onSort: function onSort(value) {
	                return _this2.store.sort(value);
	            },
	            onChangeView: function onChangeView(value) {
	                return _this2.setState({ productView: value });
	            },
	            onChangeItemsPerPage: function onChangeItemsPerPage(value) {
	                return _this2.store.itemsPerPage(value);
	            }
	        }));
	    };
	
	    return ProductsController;
	}(_react2.default.Component);
	
	exports.default = ProductsController;
	
	
	ProductsController.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    store: _react.PropTypes.string.isRequired
	};
	
	ProductsController.defaultProps = {
	    view: "ProductBrowserViewsProductsView",
	    store: "ProductBrowserStore"
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = createFacetStore;
	
	var _KeyValueStore = __webpack_require__(158);
	
	var _KeyValueStore2 = _interopRequireDefault(_KeyValueStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createFacetStore(initialState) {
	    var store = new _KeyValueStore2.default();
	    store.onLoad(initialState);
	
	    return store;
	}

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	exports.createProductBrowserStore = createProductBrowserStore;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _AbstractStore2 = __webpack_require__(8);
	
	var _AbstractStore3 = _interopRequireDefault(_AbstractStore2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductBrowserStore = function (_AbstractStore) {
	    _inherits(ProductBrowserStore, _AbstractStore);
	
	    function ProductBrowserStore(url) {
	        _classCallCheck(this, ProductBrowserStore);
	
	        var _this = _possibleConstructorReturn(this, _AbstractStore.call(this, ["load", "switchToPage", "itemsPerPage", "sort", "filter"]));
	
	        _this.url = url;
	        _this.items = [];
	        _this.sorting = "A-Z";
	        _this.paging = {};
	        _this.filters = {};
	
	        _this.facetStore = _ComponentRegistry2.default.getStore("ProductBrowserFacetStore");
	        return _this;
	    }
	
	    ProductBrowserStore.prototype.load = function load(state) {
	        this.actions.load(state.items, state.paging, state.sorting, state.filters);
	    };
	
	    ProductBrowserStore.prototype.loadItems = function loadItems(items) {
	        this.items = items;
	        this.trigger();
	    };
	
	    ProductBrowserStore.prototype.loadPaging = function loadPaging(paging) {
	        this.paging = paging;
	        this.trigger();
	    };
	
	    ProductBrowserStore.prototype.loadSorting = function loadSorting(sorting) {
	        this.sorting = sorting;
	        this.trigger();
	    };
	
	    ProductBrowserStore.prototype.loadFilters = function loadFilters(filters) {
	        this.filters = filters;
	        this.trigger();
	    };
	
	    ProductBrowserStore.prototype.switchToPage = function switchToPage(page) {
	        this.actions.switchToPage(page);
	    };
	
	    ProductBrowserStore.prototype.itemsPerPage = function itemsPerPage(_itemsPerPage) {
	        this.actions.itemsPerPage(_itemsPerPage);
	    };
	
	    ProductBrowserStore.prototype.sort = function sort(sorting) {
	        this.actions.sort(sorting);
	    };
	
	    ProductBrowserStore.prototype.filter = function filter(property, values) {
	        this.actions.filter(property, values);
	    };
	
	    ProductBrowserStore.prototype.loadData = function loadData() {
	        var _this2 = this;
	
	        if (this.url === null) {
	            return;
	        }
	        this.trigger("loading");
	        _jquery2.default.ajax({
	            url: this.url,
	            method: "GET",
	            data: {
	                page: this.paging.pages.current,
	                perPage: this.paging.items.perPage,
	                sorting: this.sorting,
	                filters: this.filters
	            },
	            dataType: "json",
	            success: function success(result) {
	                _this2.facetStore.load(result.facets.config);
	                _this2.onLoad(result.items, result.paging, result.sorting, result.facets.values);
	            }
	        });
	    };
	
	    ProductBrowserStore.prototype.onLoad = function onLoad(items, paging, sorting, filters) {
	        this.items = items;
	        this.paging = paging;
	        this.sorting = sorting;
	        this.filters = typeof filters.length === "undefined" ? filters : {};
	        this.trigger("idle");
	    };
	
	    ProductBrowserStore.prototype.onItemsPerPage = function onItemsPerPage(itemsPerPage) {
	        this.paging.items.perPage = itemsPerPage;
	
	        this.onSwitchToPage(1);
	    };
	
	    ProductBrowserStore.prototype.onSwitchToPage = function onSwitchToPage(page) {
	        this.paging.pages.current = page;
	        this.loadData();
	    };
	
	    ProductBrowserStore.prototype.onSort = function onSort(sorting) {
	        this.sorting = sorting;
	        this.onSwitchToPage(1);
	    };
	
	    ProductBrowserStore.prototype.onFilter = function onFilter(property, values) {
	        if (Array.isArray(this.filters)) {
	            this.filters = {};
	        }
	        if (values === null) {
	            delete this.filters[property];
	        } else {
	            this.filters[property] = values;
	        }
	        this.onSwitchToPage(1);
	    };
	
	    ProductBrowserStore.prototype.trigger = function trigger(status) {
	        _AbstractStore.prototype.trigger.call(this, this.items, this.paging, this.sorting, this.filters, status);
	    };
	
	    return ProductBrowserStore;
	}(_AbstractStore3.default);
	
	exports.default = ProductBrowserStore;
	function createProductBrowserStore(initialState) {
	    var store = new ProductBrowserStore(initialState.url);
	    store.onLoad(initialState.items, initialState.paging, initialState.sorting, initialState.filters);
	
	    return store;
	}

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ListView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ListView(_ref) {
	  var title = _ref.title,
	      url = _ref.url,
	      thumb = _ref.thumb,
	      price = _ref.price,
	      properties = _ref.properties;
	
	  var Price = _ComponentRegistry2.default.get("Price");
	  var Image = _ComponentRegistry2.default.get("Image");
	
	  var incentives = Object.values(properties.incentives.value).map(function (incentive) {
	    return _react2.default.createElement(
	      "span",
	      { key: incentive.id },
	      incentive.title
	    );
	  });
	
	  return _react2.default.createElement(
	    "article",
	    { className: "item col col-12 bp-tablet-col-12 bp-phone-col-1", itemType: "http://schema.org/Product" },
	    _react2.default.createElement(
	      "a",
	      { href: url },
	      _react2.default.createElement(
	        "div",
	        { className: "image group col col-1" },
	        _react2.default.createElement(Image, { src: thumb, alt: title })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col col-6" },
	        _react2.default.createElement(
	          "h2",
	          { itemProp: "name" },
	          title
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "btn-group" },
	          incentives
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col col-2" },
	        _react2.default.createElement(Price, { value: price.excl })
	      )
	    )
	  );
	}
	
	ListView.propTypes = {
	  title: _react.PropTypes.string.isRequired,
	  url: _react.PropTypes.string.isRequired,
	  thumb: _react.PropTypes.string.isRequired,
	  price: _react.PropTypes.shape({
	    excl: _react.PropTypes.string.isRequired
	  }).isRequired,
	  properties: _react.PropTypes.shape({
	    incentives: _react.PropTypes.shape({}).isRequired
	  }).isRequired
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PresentationView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PresentationView(_ref) {
	    var choices = _ref.choices,
	        value = _ref.value,
	        onChange = _ref.onChange;
	
	    var Choice = _ComponentRegistry2.default.get("Choice");
	
	    return _react2.default.createElement(Choice, { choices: choices, value: value, onChange: onChange });
	}
	PresentationView.propTypes = {
	    choices: _react.PropTypes.shape({}).isRequired,
	    value: _react.PropTypes.string,
	    onChange: _react.PropTypes.func.isRequired
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _history = __webpack_require__(40);
	
	var _Utils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HistoryWidget = function (_React$Component) {
	    _inherits(HistoryWidget, _React$Component);
	
	    function HistoryWidget(props) {
	        _classCallCheck(this, HistoryWidget);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.facetStore = _ComponentRegistry2.default.getStore("ProductBrowserFacetStore");
	        _this.productStore = _ComponentRegistry2.default.getStore("ProductBrowserStore");
	
	        _this.history = (0, _history.createHistory)();
	        _this.unlisten = _this.history.listen(function (location) {
	            if (location.pathname === _this.url && location.action === "POP") {
	                _jquery2.default.ajax({
	                    url: _this.url,
	                    method: "GET",
	                    data: decodeURIComponent(location.search),
	                    dataType: "json",
	                    success: function success(result) {
	                        _this.facetStore.load(result.facets.config);
	                        _this.productStore.onLoad(result.items, result.paging, result.sorting, result.facets.values);
	                    }
	                });
	            }
	        });
	
	        _this.onStoreChange = _this.onStoreChange.bind(_this);
	
	        _this.productStore.listen(_this.onStoreChange);
	        return _this;
	    }
	
	    HistoryWidget.prototype.onStoreChange = function onStoreChange(products, paging, sorting, filters) {
	        this.history.push({
	            pathname: this.productStore.url,
	            search: (this.productStore.url.indexOf("?") > -1 ? "&" : "?") + (0, _Utils.objectToQueryString)({
	                filters: filters,
	                sorting: sorting,
	                page: paging.pages.current,
	                perPage: paging.items.perPage
	            })
	        });
	    };
	
	    HistoryWidget.prototype.render = function render() {
	        return null;
	    };
	
	    return HistoryWidget;
	}(_react2.default.Component);
	
	exports.default = HistoryWidget;

/***/ },
/* 177 */
[250, 171],
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MatrixController = function (_React$Component) {
	    _inherits(MatrixController, _React$Component);
	
	    function MatrixController(props) {
	        _classCallCheck(this, MatrixController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore("ProductCompareStore");
	        _this.store.listen(function (state) {
	            return _this.setState(state);
	        });
	        _this.state = _this.store.state;
	        return _this;
	    }
	
	    MatrixController.prototype.purchase = function purchase(product) {
	        _jquery2.default.ajax({
	            url: this.props.purchaseUrl,
	            method: "POST",
	            data: { productId: product.id, quantity: product.minimumPurchaseAmount },
	            success: function success(_ref) {
	                var basket = _ref.basket;
	
	                if (typeof basket !== "undefined") {
	                    _ComponentRegistry2.default.getStore("BasketStore").load(basket);
	                }
	            },
	            dataType: 'json'
	        });
	    };
	
	    MatrixController.prototype.render = function render() {
	        var _this2 = this;
	
	        var MatrixView = _ComponentRegistry2.default.get("ProductCompareViewsMatrixView");
	        var properties = this.state.products.map(function (product) {
	            return Object.keys(product.properties);
	        }).reduce(function (accumulator, currentValue) {
	            return accumulator.concat(currentValue.filter(function (value) {
	                return !accumulator.some(function (accumulatedValue) {
	                    return accumulatedValue === value;
	                });
	            }));
	        }, []).filter(function (value) {
	            return !_this2.props.blacklist.includes(value);
	        });
	
	        if (this.state.products.length === 0) {
	            return null;
	        }
	
	        return _react2.default.createElement(MatrixView, _extends({}, this.props, this.state, {
	            properties: properties,
	            onRemove: function onRemove(product) {
	                return _this2.store.remove(product);
	            },
	            onPurchase: function onPurchase(product) {
	                return _this2.purchase(product);
	            },
	            onDifferenceOnly: function onDifferenceOnly(differenceOnly) {
	                return _this2.setState({ differenceOnly: differenceOnly });
	            }
	        }));
	    };
	
	    return MatrixController;
	}(_react2.default.Component);
	
	exports.default = MatrixController;
	
	
	MatrixController.defaultProps = {
	    blacklist: []
	};
	MatrixController.propTypes = {
	    blacklist: _react.PropTypes.arrayOf("string"),
	    products: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        properties: _react.PropTypes.shape({}).isRequired
	    })).isRequired
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PanelController = function (_React$Component) {
	    _inherits(PanelController, _React$Component);
	
	    function PanelController(props) {
	        _classCallCheck(this, PanelController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            products: [],
	            matrix: []
	        };
	        _this.store = _ComponentRegistry2.default.getStore("ProductCompareStore");
	        _this.store.listen(function (state) {
	            return _this.setState(state);
	        });
	        return _this;
	    }
	
	    PanelController.prototype.render = function render() {
	        var _this2 = this;
	
	        var View = _ComponentRegistry2.default.get("ProductCompareViewsPanelView");
	
	        return _react2.default.createElement(View, _extends({}, this.props, this.state, { onRemove: function onRemove(product) {
	                return _this2.store.remove(product);
	            } }));
	    };
	
	    return PanelController;
	}(_react2.default.Component);
	
	exports.default = PanelController;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CompareStore = undefined;
	exports.default = create;
	
	var _AbstractStore2 = __webpack_require__(8);
	
	var _AbstractStore3 = _interopRequireDefault(_AbstractStore2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompareStore = exports.CompareStore = function (_AbstractStore) {
	    _inherits(CompareStore, _AbstractStore);
	
	    function CompareStore() {
	        _classCallCheck(this, CompareStore);
	
	        var _this = _possibleConstructorReturn(this, _AbstractStore.call(this, ['add', 'remove', 'load', 'error', 'clearError']));
	
	        _this.state = { products: [], matrix: [], error: null };
	        return _this;
	    }
	
	    CompareStore.prototype.load = function load(data) {
	        this.actions.load(data);
	    };
	
	    CompareStore.prototype.add = function add(product, matrix) {
	        this.actions.add(product, matrix);
	    };
	
	    CompareStore.prototype.remove = function remove(product) {
	        this.actions.remove(product);
	    };
	
	    CompareStore.prototype.error = function error(message) {
	        this.actions.error(message);
	    };
	
	    CompareStore.prototype.clearError = function clearError() {
	        this.actions.clearError();
	    };
	
	    CompareStore.prototype.onLoad = function onLoad(data) {
	        this.state = Object.assign({}, data, { error: null });
	
	        this.trigger(this.state);
	    };
	
	    CompareStore.prototype.onAdd = function onAdd(product, matrix) {
	        if (!this.state.products.some(function (currentValue) {
	            return currentValue.id === product.id;
	        })) {
	            this.state.products.push(product);
	        }
	        this.state.matrix = matrix;
	        this.state.error = null;
	
	        this.trigger(this.state);
	    };
	
	    CompareStore.prototype.onRemove = function onRemove(product) {
	        var _this2 = this;
	
	        this.state.products = this.state.products.filter(function (currentValue) {
	            return currentValue.id !== product.id;
	        });
	
	        delete this.state.matrix[product.id];
	        Object.keys(this.state.matrix).forEach(function (key) {
	            delete _this2.state.matrix[key][product.id];
	        });
	        this.state.error = null;
	
	        this.trigger(this.state);
	    };
	
	    CompareStore.prototype.onError = function onError(message) {
	        this.state.error = message;
	        this.trigger(this.state);
	    };
	
	    CompareStore.prototype.onClearError = function onClearError() {
	        this.onError(null);
	    };
	
	    return CompareStore;
	}(_AbstractStore3.default);
	
	function create(initialState) {
	    var store = new CompareStore();
	    store.onLoad(initialState);
	
	    return store;
	}

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _history = __webpack_require__(40);
	
	var _Utils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HistoryWidget = function (_React$Component) {
	    _inherits(HistoryWidget, _React$Component);
	
	    function HistoryWidget(props) {
	        _classCallCheck(this, HistoryWidget);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.url = _this.props.url;
	
	        _this.history = (0, _history.createHistory)();
	        _this.unlisten = _this.history.listen(function (location) {
	            if (location.pathname === _this.url && location.action === "POP") {
	                _jquery2.default.ajax({
	                    url: _this.url,
	                    method: "GET",
	                    data: decodeURIComponent(location.search.substring(1)),
	                    dataType: "json",
	                    success: function success(result) {
	                        _this.store.load({
	                            products: result.products,
	                            matrix: result.matrix
	                        });
	                    }
	                });
	            }
	        });
	
	        _this.store = _ComponentRegistry2.default.getStore("ProductCompareStore");
	
	        _this.onStoreChange = _this.onStoreChange.bind(_this);
	        _this.store.listen(_this.onStoreChange);
	        return _this;
	    }
	
	    HistoryWidget.prototype.onStoreChange = function onStoreChange(storeState) {
	        this.history.push({
	            pathname: this.url,
	            search: (this.url.indexOf("?") > -1 ? "&" : "?") + (0, _Utils.objectToQueryString)({
	                products: storeState.products.map(function (value) {
	                    return value.sku;
	                })
	            })
	        });
	    };
	
	    HistoryWidget.prototype.render = function render() {
	        return null;
	    };
	
	    return HistoryWidget;
	}(_react2.default.Component);
	
	exports.default = HistoryWidget;
	;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _sha = __webpack_require__(246);
	
	var _sha2 = _interopRequireDefault(_sha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocalStorageWidget = function (_React$Component) {
	    _inherits(LocalStorageWidget, _React$Component);
	
	    function LocalStorageWidget(props) {
	        _classCallCheck(this, LocalStorageWidget);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore(_this.props.store);
	        _this.initialProductsSha = _this.calculateProductSha(_this.store.state.products);
	        return _this;
	    }
	
	    LocalStorageWidget.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var storedState = localStorage.getItem(this.props.name);
	        var productsSha = null;
	        if (storedState !== null && storedState !== undefined) {
	            productsSha = this.calculateProductSha(JSON.parse(storedState).products);
	        }
	
	        if (this.initialProductsSha && (!productsSha || productsSha !== this.initialProductsSha)) {
	            // There is data, but no data saved OR there is data but does not match saved data
	            return;
	        }
	
	        this.store.listen(function (state) {
	            return localStorage.setItem(_this2.props.name, JSON.stringify(state));
	        });
	
	        if (productsSha) {
	            this.store.load(JSON.parse(storedState));
	        }
	    };
	
	    LocalStorageWidget.prototype.calculateProductSha = function calculateProductSha(products) {
	        if (products.length === 0) {
	            return null;
	        }
	
	        var skus = products.map(function (product) {
	            return product.sku;
	        });
	        return (0, _sha2.default)(JSON.stringify(skus));
	    };
	
	    LocalStorageWidget.prototype.render = function render() {
	        return null;
	    };
	
	    return LocalStorageWidget;
	}(_react2.default.Component);
	
	exports.default = LocalStorageWidget;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = MatrixWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MatrixController = __webpack_require__(178);
	
	var _MatrixController2 = _interopRequireDefault(_MatrixController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MatrixWidget(props) {
	    return _react2.default.createElement(_MatrixController2.default, props);
	}

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PanelWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelController = __webpack_require__(179);
	
	var _PanelController2 = _interopRequireDefault(_PanelController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PanelWidget(props) {
	    return _react2.default.createElement(_PanelController2.default, props);
	}

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ProductWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProductController = __webpack_require__(38);
	
	var _ProductController2 = _interopRequireDefault(_ProductController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProductWidget(props) {
	    return _react2.default.createElement(_ProductController2.default, props);
	}

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ProductsController;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProductsController(props) {
	    var ProductsView = _ComponentRegistry2.default.get(props.view);
	
	    return _react2.default.createElement(ProductsView, _extends({}, props, { view: props.productView
	    }));
	}
	
	ProductsController.propTypes = {
	    view: _react.PropTypes.string.isRequired
	};
	
	ProductsController.defaultProps = {
	    view: "ProductListViewsProductsView",
	    productView: "ProductBrowserViewsThumbView"
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Products;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Products(_ref) {
	    var view = _ref.view,
	        products = _ref.products;
	
	    var ProductView = _ComponentRegistry2.default.get(view);
	
	    return _react2.default.createElement(
	        "section",
	        { className: "widget widget-products group" },
	        Object.values(products).map(function (product, index) {
	            return _react2.default.createElement(ProductView, _extends({ key: index }, product));
	        })
	    );
	}
	
	Products.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    products: _react.PropTypes.arrayOf(_react.PropTypes.shape({})).isRequired
	};
	
	Products.propsTypes = {
	    view: "ProductBrowserViewsThumbView"
	};

/***/ },
/* 188 */
[250, 186],
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Price;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Price(_ref) {
	    var product = _ref.product,
	        priceInclVat = _ref.priceInclVat,
	        labels = _ref.labels;
	
	    var PriceAtom = _ComponentRegistry2.default.get("Price");
	
	    return _react2.default.createElement(PriceAtom, { value: product.pricing[priceInclVat ? "incl" : "excl"],
	        originalValue: product.originalPricing[priceInclVat ? "incl" : "excl"],
	        vat: labels[priceInclVat ? "incl" : "excl"]
	    });
	}
	
	Price.propTypes = {
	    product: _react.PropTypes.shape({
	        pricing: _react.PropTypes.shape({
	            incl: _react.PropTypes.string.isRequired,
	            excl: _react.PropTypes.string.isRequired
	        }).isRequired
	    }).isRequired,
	    labels: _react.PropTypes.shape({
	        incl: _react.PropTypes.string.isRequired,
	        excl: _react.PropTypes.string.isRequired
	    }).isRequired,
	    priceInclVat: _react.PropTypes.bool.isRequired
	};

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Property;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Property(props) {
	  var Choice = _ComponentRegistry2.default.get("Choice");
	
	  return _react2.default.createElement(
	    "div",
	    { className: "form-group clearfix" },
	    _react2.default.createElement(Choice, props)
	  );
	}

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PersonalisationController = function (_React$Component) {
	    _inherits(PersonalisationController, _React$Component);
	
	    function PersonalisationController() {
	        _classCallCheck(this, PersonalisationController);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    PersonalisationController.prototype.changeValue = function changeValue(property, value) {
	        var newValues = this.props.customizedProperties;
	        newValues[property] = value;
	        if (value === null || value === undefined || value === '') {
	            delete newValues[property];
	        }
	
	        this.props.onChange(newValues);
	    };
	
	    PersonalisationController.prototype.render = function render() {
	
	        if (!this.props.product.isPersonalisable) {
	            return null;
	        }
	
	        var PersonalisationFormView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(PersonalisationFormView, _extends({}, this.props, this.state, {
	            properties: this.props.product.personalisableProperties,
	            values: this.props.customizedProperties,
	            onValueChange: this.changeValue.bind(this)
	        }));
	    };
	
	    return PersonalisationController;
	}(_react2.default.Component);
	
	exports.default = PersonalisationController;
	
	
	PersonalisationController.propTypes = {
	    url: _react.PropTypes.string.isRequired,
	    view: _react.PropTypes.string.isRequired
	};
	PersonalisationController.defaultProps = {
	    view: "ProductPurchaseViewsPersonalisationFormView"
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PricingController = function (_React$Component) {
	    _inherits(PricingController, _React$Component);
	
	    function PricingController(props) {
	        _classCallCheck(this, PricingController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.customizedProperties = _jquery2.default.extend({}, _this.props.customizedProperties);
	        _this.xhr = null;
	
	        _this.state = { quantity: _this.props.quantity, price: null };
	        return _this;
	    }
	
	    PricingController.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
	        var quantity = parseInt(nextProps.quantity, 10);
	
	        if (quantity !== "NaN") {
	            var quantityChanged = quantity !== parseInt(nextState.quantity, 10);
	
	            var properties = nextProps.customizedProperties;
	            var propertiesChanged = JSON.stringify(properties) !== JSON.stringify(this.customizedProperties);
	            if (propertiesChanged) {
	                this.customizedProperties = _jquery2.default.extend({}, properties);
	            }
	
	            if (properties && propertiesChanged) {
	                this.updateInfo(quantity, properties);
	            } else if (quantityChanged) {
	                if (quantity > 1 || properties) {
	                    this.updateInfo(quantity, properties);
	                } else {
	                    this.setState({ quantity: 1, price: null });
	                }
	            }
	        }
	    };
	
	    PricingController.prototype.updateInfo = function updateInfo(quantity, properties) {
	        var _this2 = this;
	
	        if (this.xhr) {
	            this.xhr.abort();
	        }
	        this.xhr = _jquery2.default.ajax(this.props.url, {
	            method: "POST",
	            data: {
	                quantity: quantity,
	                properties: properties
	            },
	            success: function success(data) {
	                _this2.xhr = null;
	                _this2.setState(data);
	            }
	        });
	    };
	
	    PricingController.prototype.render = function render() {
	        if (this.state.price === null) {
	            return null;
	        }
	
	        var PricingView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(PricingView, _extends({}, this.props, this.state));
	    };
	
	    return PricingController;
	}(_react2.default.Component);
	
	exports.default = PricingController;
	
	PricingController.propTypes = {
	    quantity: _react.PropTypes.number.isRequired,
	    url: _react.PropTypes.string.isRequired,
	    view: _react.PropTypes.string.isRequired
	};
	PricingController.defaultProps = {
	    view: "ProductPurchaseViewsPricingView"
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseController = function (_React$Component) {
	    _inherits(PurchaseController, _React$Component);
	
	    function PurchaseController(props) {
	        _classCallCheck(this, PurchaseController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.productStore = _ComponentRegistry2.default.getStore("ProductStore");
	        _this.basketStore = _ComponentRegistry2.default.getStore("BasketStore");
	        _this.state = {
	            product: _this.productStore.product,
	            quantity: _this.productStore.product.minimumPurchaseAmount,
	            customizedProperties: {}
	        };
	
	        _this.unsubscribe = _this.productStore.listen(_this.onProductChange.bind(_this));
	        return _this;
	    }
	
	    PurchaseController.prototype.onProductChange = function onProductChange(product) {
	        if (product !== null && typeof product.url !== "undefined" && product.url !== null) {
	            window.location = product.url;
	        } else {
	            this.setState({ product: product === null ? this.state.product : product });
	        }
	    };
	
	    PurchaseController.prototype.onCustomizedPropertiesChange = function onCustomizedPropertiesChange(properties) {
	        this.setState({ customizedProperties: properties === null ? this.state.customizedProperties : properties });
	    };
	
	    PurchaseController.prototype.onPurchase = function onPurchase() {
	        var _this2 = this;
	
	        var data = _jquery2.default.extend(true, {}, this.state, { productId: this.state.product.id });
	        delete data.product;
	        delete data.feedback;
	        _jquery2.default.ajax(this.props.url, {
	            method: "POST",
	            data: data,
	            success: function success(result) {
	                if (typeof result.basket !== "undefined" && _this2.store !== null) {
	                    _this2.basketStore.load(result.basket);
	                }
	                _this2.setState({
	                    feedback: { type: result.type, message: result.message },
	                    quantity: result.type === "success" ? _this2.state.product.minimumPurchaseAmount : _this2.state.quantity
	                });
	            }
	        });
	    };
	
	    PurchaseController.prototype.render = function render() {
	        var _this3 = this;
	
	        var ProductPurchaseView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(ProductPurchaseView, _extends({}, this.props, this.state, {
	            onChange: function onChange(values) {
	                return _this3.setState((0, _extend2.default)(true, { feedback: null }, values));
	            },
	            onPurchase: function onPurchase() {
	                return _this3.onPurchase();
	            },
	            onUpdateProduct: function onUpdateProduct(product) {
	                return _this3.productStore.update(product);
	            },
	            onCustomizedPropertiesChange: function onCustomizedPropertiesChange(properties) {
	                _this3.onCustomizedPropertiesChange(properties);
	            }
	        }));
	    };
	
	    return PurchaseController;
	}(_react2.default.Component);
	
	exports.default = PurchaseController;
	
	PurchaseController.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    url: _react.PropTypes.string.isRequired
	};
	
	PurchaseController.defaultProps = {
	    view: "ProductPurchaseViewsPurchaseView"
	};

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VariationController = function (_React$Component) {
	    _inherits(VariationController, _React$Component);
	
	    function VariationController(props) {
	        _classCallCheck(this, VariationController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore("ProductStore");
	        return _this;
	    }
	
	    VariationController.prototype.render = function render() {
	        var _this2 = this;
	
	        if (Object.keys(this.props.properties).length === 0) {
	            return null;
	        }
	
	        var Property = _ComponentRegistry2.default.get("ProductPurchaseAtomsProperty");
	        var VariationView = _ComponentRegistry2.default.get(this.props.view);
	
	        var properties = [];
	        Object.keys(this.props.properties).forEach(function (property) {
	            if (_this2.props.properties[property].is_dropdown) {
	                var availableChoices = _this2.store.getFilteredValues(property);
	                var choices = _this2.props.onlyAvailable ? availableChoices : _this2.store.getValues(property);
	
	                properties.push(_react2.default.createElement(Property, _extends({}, _this2.props.properties[property], {
	                    key: property,
	                    choices: choices,
	                    availableChoices: availableChoices,
	                    onChange: function onChange(value) {
	                        return _this2.store.filter(property, value);
	                    }
	                })));
	            }
	        });
	        return _react2.default.createElement(
	            VariationView,
	            null,
	            properties
	        );
	    };
	
	    return VariationController;
	}(_react2.default.Component);
	
	exports.default = VariationController;
	
	VariationController.propTypes = {
	    view: _react.PropTypes.string.isRequired,
	    properties: _react.PropTypes.oneOfType([_react.PropTypes.objectOf(_react.PropTypes.shape({
	        is_dropdown: _react.PropTypes.bool.isRequired
	    })), _react.PropTypes.arrayOf(_react.PropTypes.shape({}))]),
	    onlyAvailable: _react.PropTypes.bool.isRequired
	};
	
	VariationController.defaultProps = {
	    view: "ProductPurchaseViewsVariationView",
	    onlyAvailable: false
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WishlistController = function (_React$Component) {
	    _inherits(WishlistController, _React$Component);
	
	    function WishlistController(props) {
	        _classCallCheck(this, WishlistController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = { feedback: null };
	
	        _this.addToWishlist = _this.addToWishlist.bind(_this);
	        _this.removeFromWishlist = _this.removeFromWishlist.bind(_this);
	        _this.clearFeedback = _this.clearFeedback.bind(_this);
	        return _this;
	    }
	
	    WishlistController.prototype.addToWishlist = function addToWishlist(event) {
	        var _this2 = this;
	
	        if (this.props.authenticated) {
	            event.preventDefault();
	            _jquery2.default.ajax(this.props.addUrl, {
	                method: "POST",
	                data: {
	                    productId: this.props.product.id
	                },
	                success: function success(data) {
	                    _this2.setState({ feedback: data });
	                    _this2.props.onChange((0, _extend2.default)(true, {}, _this2.props.product, { onWishlist: true }));
	                },
	                dataType: "json"
	            });
	        }
	    };
	
	    WishlistController.prototype.removeFromWishlist = function removeFromWishlist(event) {
	        var _this3 = this;
	
	        event.preventDefault();
	        _jquery2.default.ajax(this.props.removeUrl, {
	            method: "POST",
	            data: {
	                productId: this.props.product.id
	            },
	            success: function success(data) {
	                _this3.setState({ feedback: data });
	                _this3.props.onChange((0, _extend2.default)(true, {}, _this3.props.product, { onWishlist: false }));
	            },
	            dataType: "json"
	        });
	    };
	
	    WishlistController.prototype.clearFeedback = function clearFeedback(event) {
	        event.preventDefault();
	        this.setState({ feedback: null });
	    };
	
	    WishlistController.prototype.render = function render() {
	        var WishlistView = _ComponentRegistry2.default.get(this.props.view);
	
	        return _react2.default.createElement(WishlistView, _extends({}, this.props, this.state, {
	            onAdd: this.addToWishlist,
	            onRemove: this.removeFromWishlist,
	            onClearFeedback: this.clearFeedback
	        }));
	    };
	
	    return WishlistController;
	}(_react2.default.Component);
	
	exports.default = WishlistController;
	
	
	WishlistController.propTypes = {
	    product: _react.PropTypes.shape({
	        id: _react.PropTypes.string.isRequired
	    }).isRequired,
	    addUrl: _react.PropTypes.string.isRequired,
	    removeUrl: _react.PropTypes.string.isRequired,
	    authenticated: _react.PropTypes.bool.isRequired,
	    onChange: _react.PropTypes.func.isRequired,
	    view: _react.PropTypes.string.isRequired
	};
	
	WishlistController.defaultProps = {
	    view: "ProductPurchaseViewsWishlistView"
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	exports.createProductStore = createProductStore;
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _AbstractStore2 = __webpack_require__(8);
	
	var _AbstractStore3 = _interopRequireDefault(_AbstractStore2);
	
	var _Utils = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function sortBySequence(a, b) {
	    if (a.sequence < b.sequence) {
	        return -1;
	    }
	    if (a.sequence > b.sequence) {
	        return 1;
	    }
	    return 0;
	}
	
	var ProductStore = function (_AbstractStore) {
	    _inherits(ProductStore, _AbstractStore);
	
	    function ProductStore(filters) {
	        _classCallCheck(this, ProductStore);
	
	        var _this = _possibleConstructorReturn(this, _AbstractStore.call(this, ["load", "update"]));
	
	        _this.items = [];
	        _this.product = null;
	        _this.filters = {};
	        Object.keys(filters).forEach(function (filter) {
	            return _this.filters[filter] = null;
	        });
	        return _this;
	    }
	
	    ProductStore.prototype.load = function load(product, variants) {
	        this.actions.load(product, variants);
	    };
	
	    ProductStore.prototype.update = function update(product) {
	        this.actions.update(product);
	    };
	
	    ProductStore.prototype.onLoad = function onLoad(product, variants) {
	        var _this2 = this;
	
	        this.items = [];
	        this.items.push(product);
	        this.setProduct(product);
	        if (variants !== null) {
	            Object.values(variants).forEach(function (variant) {
	                return _this2.items.push(variant);
	            });
	        }
	        this.trigger(this.product, this.filters);
	    };
	
	    ProductStore.prototype.onUpdate = function onUpdate(product) {
	        this.product = product;
	        (0, _Utils.updateItem)(product, this.items);
	        this.trigger(this.product, this.filters);
	    };
	
	    ProductStore.prototype.setProduct = function setProduct(product) {
	        var _this3 = this;
	
	        this.product = product;
	        var properties = Object.keys(this.product.distinguishingProperties);
	        if (properties.length > 0) {
	            properties.forEach(function (property) {
	                return _this3.filters[property] = _this3.product.distinguishingProperties[property].value;
	            });
	        } else {
	            Object.keys(this.filters).forEach(function (property) {
	                _this3.product.distinguishingProperties[property] = { name: property, value: null };
	            });
	        }
	    };
	
	    ProductStore.prototype.getFilteredValues = function getFilteredValues(type) {
	        var options = {};
	        this.getFilteredResult(type).map(function (product) {
	            return product.distinguishingProperties[type];
	        }).sort(sortBySequence).map(function (property) {
	            return property.value;
	        }).filter(function (value, index, self) {
	            return value !== null && self.indexOf(value) === index;
	        }).forEach(function (value) {
	            options[value] = value;
	        });
	
	        return options;
	    };
	
	    ProductStore.prototype.getValues = function getValues(type) {
	        var options = {};
	        this.items.map(function (product) {
	            return product.distinguishingProperties[type];
	        }).sort(sortBySequence).map(function (property) {
	            return property.value;
	        }).filter(function (value, index, self) {
	            return value !== null && self.indexOf(value) === index;
	        }).forEach(function (value) {
	            options[value] = value;
	        });
	
	        return options;
	    };
	
	    ProductStore.prototype.filter = function filter(key, value) {
	        var _this4 = this;
	
	        this.filters[key] = value === "" ? null : value;
	
	        var products = this.getFilteredResult();
	        if (products.length === 0) {
	            var keys = Object.keys(this.filters);
	            keys.forEach(function (filterKey) {
	                if (keys.indexOf(filterKey) > keys.indexOf(key)) {
	                    _this4.filters[filterKey] = null;
	                }
	            });
	        }
	
	        var filters = (0, _extend2.default)(true, {}, this.filters);
	        while (products.length === 0 && Object.keys(this.filters).length > 0) {
	            var lastKey = Object.keys(this.filters).pop();
	            delete this.filters[lastKey];
	            products = this.getFilteredResult();
	        }
	        if (products.length === 1 && Object.keys(this.filters).length > 0) {
	            this.setProduct(products.pop());
	        } else {
	            this.product = null;
	            this.filters = filters;
	        }
	        this.trigger(this.product, this.filters);
	    };
	
	    ProductStore.prototype.getFilteredResult = function getFilteredResult(ignore) {
	        var filters = (0, _extend2.default)(true, {}, this.filters);
	        if (typeof ignore !== "undefined") {
	            var keys = Object.keys(filters);
	            keys.forEach(function (filterKey) {
	                if (keys.indexOf(filterKey) > keys.indexOf(ignore)) {
	                    delete filters[filterKey];
	                }
	            });
	        }
	
	        return this.items.filter(function (product) {
	            return Object.keys(filters).reduce(function (valid, key) {
	                return valid && product.distinguishingProperties[key].value === filters[key];
	            }, true);
	        });
	    };
	
	    return ProductStore;
	}(_AbstractStore3.default);
	
	exports.default = ProductStore;
	function createProductStore(initialState) {
	    var store = new ProductStore(initialState.filters);
	    store.onLoad(initialState.product, initialState.variants);
	
	    return store;
	}

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PersonalisationFormView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PersonalisationFormView(_ref) {
	    var properties = _ref.properties,
	        values = _ref.values,
	        labels = _ref.labels,
	        onValueChange = _ref.onValueChange;
	
	    var formFieldComponents = [];
	
	    properties.forEach(function (property) {
	        var label = property.title + (property.required ? ' *' : '');
	
	        switch (property.type) {
	            case 'choice':
	                var ChoiceComponent = _ComponentRegistry2.default.get('Choice');
	                formFieldComponents.push(_react2.default.createElement(
	                    "dl",
	                    { key: property.name, className: "clearfix" },
	                    _react2.default.createElement(
	                        "dt",
	                        null,
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            label
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "dd",
	                        null,
	                        _react2.default.createElement(ChoiceComponent, { choices: property.options,
	                            expanded: property.multiple,
	                            value: values[property.name],
	                            onChange: function onChange(value) {
	                                return onValueChange(property.name, value);
	                            },
	                            placeholder: labels.select
	                        })
	                    )
	                ));
	                break;
	
	            case 'text_field':
	                formFieldComponents.push(_react2.default.createElement(
	                    "dl",
	                    { key: property.name, className: "clearfix" },
	                    _react2.default.createElement(
	                        "dt",
	                        null,
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            label
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "dd",
	                        null,
	                        _react2.default.createElement("input", { type: "text", className: "form-control", value: values[property.name], onChange: function onChange(evt) {
	                                onValueChange(property.name, evt.target.value);
	                            } })
	                    )
	                ));
	                break;
	
	            case 'text_area':
	                formFieldComponents.push(_react2.default.createElement(
	                    "dl",
	                    { key: property.name, className: "clearfix" },
	                    _react2.default.createElement(
	                        "dt",
	                        null,
	                        _react2.default.createElement(
	                            "label",
	                            null,
	                            label
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "dd",
	                        null,
	                        _react2.default.createElement(
	                            "textarea",
	                            { className: "form-control", onChange: function onChange(evt) {
	                                    onValueChange(property.name, evt.target.value);
	                                } },
	                            values[property.name]
	                        )
	                    )
	                ));
	                break;
	
	            default:
	                throw new Error('Unknown personalisation property type: ' + property.type);
	        }
	    });
	
	    return _react2.default.createElement(
	        "div",
	        { className: "personalisation-view" },
	        formFieldComponents
	    );
	}
	
	PersonalisationFormView.propTypes = {
	    properties: _react.PropTypes.array.isRequired,
	    labels: _react.PropTypes.shape({}).isRequired,
	    onValueChange: _react.PropTypes.func.isRequired
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PricingView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PricingView(_ref) {
	  var quantity = _ref.quantity,
	      stockUnits = _ref.stockUnits,
	      price = _ref.price,
	      showPriceIncl = _ref.showPriceIncl;
	
	  return _react2.default.createElement(
	    "fieldset",
	    { className: "border-top" },
	    _react2.default.createElement(
	      "div",
	      { className: "box-text" },
	      quantity,
	      " ",
	      stockUnits[quantity !== 1 ? 1 : 0]
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "item-price" },
	      _react2.default.createElement(
	        "span",
	        { className: "price" },
	        price[showPriceIncl ? "incl" : "excl"]
	      )
	    )
	  );
	}
	
	PricingView.propTypes = {
	  price: _react.PropTypes.shape({
	    incl: _react.PropTypes.string.isRequired,
	    excl: _react.PropTypes.string.isRequired
	  }).isRequired,
	  quantity: _react.PropTypes.number.isRequired,
	  stockUnits: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
	  showPriceIncl: _react.PropTypes.bool.isRequired
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = VariationView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VariationView(_ref) {
	    var children = _ref.children;
	
	    return _react2.default.createElement(
	        "fieldset",
	        { className: "border-top no-padding-bottom" },
	        children
	    );
	}
	
	VariationView.propTypes = {
	    children: _react.PropTypes.arrayOf(_react.PropTypes.node)
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WishlistView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RemoveFromWishlistView(_ref) {
	    var labels = _ref.labels,
	        removeUrl = _ref.removeUrl,
	        viewUrl = _ref.viewUrl,
	        onRemove = _ref.onRemove;
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "span",
	            { className: "btn btn-link btn-sm active" },
	            _react2.default.createElement("span", { className: "icon icon-heart" }),
	            " ",
	            labels.onWishlist
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "border-dashed" },
	            removeUrl ? _react2.default.createElement(
	                "a",
	                { href: "", className: "btn btn-link btn-secondary btn-sm", onClick: onRemove },
	                _react2.default.createElement("span", { className: "icon icon-remove" }),
	                " ",
	                labels.removeFromWishlist
	            ) : _react2.default.createElement(
	                "a",
	                { href: viewUrl },
	                labels.gotoWishlist
	            )
	        )
	    );
	}
	RemoveFromWishlistView.propTypes = {
	    labels: _react.PropTypes.shape({
	        onWishlist: _react.PropTypes.string.isRequired,
	        removeFromWishlist: _react.PropTypes.string.isRequired
	    }).isRequired,
	    removeUrl: _react.PropTypes.string,
	    viewUrl: _react.PropTypes.string,
	    onRemove: _react.PropTypes.func.isRequired
	};
	
	function AddToWishlistView(_ref2) {
	    var labels = _ref2.labels,
	        addUrl = _ref2.addUrl,
	        onAdd = _ref2.onAdd;
	
	    return _react2.default.createElement(
	        "a",
	        { href: addUrl, className: "btn btn-link btn-secondary btn-sm", onClick: onAdd },
	        _react2.default.createElement("span", { className: "icon icon-heart" }),
	        " ",
	        labels.addToWishlist
	    );
	}
	AddToWishlistView.propTypes = {
	    labels: _react.PropTypes.shape({
	        addToWishlist: _react.PropTypes.string.isRequired
	    }).isRequired,
	    addUrl: _react.PropTypes.string,
	    onAdd: _react.PropTypes.func.isRequired
	};
	
	function Feedback(_ref3) {
	    var feedback = _ref3.feedback,
	        onClearFeedback = _ref3.onClearFeedback;
	
	    if (!feedback) {
	        return null;
	    }
	    return _react2.default.createElement(
	        "div",
	        { className: feedback.type + "-msg" },
	        _react2.default.createElement(
	            "a",
	            { href: "#remove-feedback", onClick: onClearFeedback, className: "pull-right" },
	            "X"
	        ),
	        feedback.message
	    );
	}
	Feedback.propTypes = {
	    feedback: _react.PropTypes.shape({
	        type: _react.PropTypes.string,
	        message: _react.PropTypes.string
	    }),
	    onClearFeedback: _react.PropTypes.func
	};
	
	function WishlistView(_ref4) {
	    var product = _ref4.product,
	        labels = _ref4.labels,
	        feedback = _ref4.feedback,
	        addUrl = _ref4.addUrl,
	        removeUrl = _ref4.removeUrl,
	        viewUrl = _ref4.viewUrl,
	        onAdd = _ref4.onAdd,
	        onRemove = _ref4.onRemove,
	        onClearFeedback = _ref4.onClearFeedback;
	
	    return _react2.default.createElement(
	        "fieldset",
	        { className: "box-footer box-wishlist" },
	        product.onWishlist ? _react2.default.createElement(RemoveFromWishlistView, {
	            labels: labels,
	            removeUrl: removeUrl,
	            viewUrl: viewUrl,
	            onRemove: onRemove
	        }) : _react2.default.createElement(AddToWishlistView, {
	            labels: labels,
	            addUrl: addUrl,
	            onAdd: onAdd
	        }),
	        _react2.default.createElement(Feedback, { feedback: feedback, onClearFeedback: onClearFeedback })
	    );
	}
	
	WishlistView.propTypes = {
	    product: _react.PropTypes.shape({
	        onWishlist: _react.PropTypes.bool.isRequired
	    }).isRequired,
	    labels: _react.PropTypes.shape({}).isRequired,
	    viewUrl: _react.PropTypes.string,
	    addUrl: _react.PropTypes.string,
	    removeUrl: _react.PropTypes.string,
	    feedback: _react.PropTypes.shape({}),
	    onAdd: _react.PropTypes.func,
	    onRemove: _react.PropTypes.func,
	    onClearFeedback: _react.PropTypes.func
	};

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ProductPurchaseWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PurchaseController = __webpack_require__(193);
	
	var _PurchaseController2 = _interopRequireDefault(_PurchaseController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProductPurchaseWidget(props) {
	    return _react2.default.createElement(_PurchaseController2.default, props);
	}
	
	ProductPurchaseWidget.propTypes = {
	    props: _react.PropTypes.objectOf(_react2.default.PropTypes.shape({
	        product: _react2.default.PropTypes.shape({}).isRequired,
	        quantity: _react.PropTypes.number.isRequired
	    })).isRequired
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _jquery = __webpack_require__(3);
	
	var _extend = __webpack_require__(4);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WishlistController = function (_React$Component) {
	    _inherits(WishlistController, _React$Component);
	
	    function WishlistController(props) {
	        _classCallCheck(this, WishlistController);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.store = _ComponentRegistry2.default.getStore("WishlistStore");
	        _this.basketStore = _ComponentRegistry2.default.getStore("BasketStore");
	
	        _this.state = { items: _this.store.items };
	        _this.store.listen(function (items) {
	            return _this.setState({ items: items });
	        });
	        return _this;
	    }
	
	    WishlistController.prototype.onSaveNote = function onSaveNote(item, note) {
	        var _this2 = this;
	
	        (0, _jquery.ajax)({
	            url: this.props.saveNoteToWishlistUrl,
	            data: {
	                productId: item.product.id,
	                note: note
	            },
	            success: function success(data) {
	                return _this2.store.update((0, _extend2.default)(true, {}, item, { note: note, feedback: data }));
	            }
	        });
	    };
	
	    WishlistController.prototype.onPurchase = function onPurchase(item) {
	        var _this3 = this;
	
	        (0, _jquery.ajax)({
	            url: this.props.addToBasketUrl,
	            data: {
	                productId: item.product.id,
	                quantity: item.quantity
	            },
	            success: function success(data) {
	                _this3.basketStore.load(data.basket);
	                _this3.store.update((0, _extend2.default)(true, {}, item, { feedback: { type: data.type, message: data.message } }));
	                _this3.onChangeQuantity(item, item.product.minimumPurchaseAmount);
	            }
	        });
	    };
	
	    WishlistController.prototype.onChangeQuantity = function onChangeQuantity(item, quantity) {
	        var _this4 = this;
	
	        (0, _jquery.ajax)({
	            url: item.url,
	            data: {
	                quantity: quantity
	            },
	            method: "POST",
	            success: function success(data) {
	                return _this4.store.update((0, _extend2.default)(true, {}, item, data));
	            }
	        });
	    };
	
	    WishlistController.prototype.onRemove = function onRemove(item) {
	        var _this5 = this;
	
	        (0, _jquery.ajax)({
	            url: this.props.removeUrl,
	            data: {
	                productId: item.product.id
	            },
	            success: function success() {
	                _this5.store.remove(item);
	            }
	        });
	    };
	
	    WishlistController.prototype.render = function render() {
	        var _this6 = this;
	
	        var WishlistView = _ComponentRegistry2.default.get("WishlistViewsWishlistView");
	        var WishlistItemView = _ComponentRegistry2.default.get("WishlistViewsItemView");
	
	        var items = this.state.items.map(function (item, index) {
	            return _react2.default.createElement(WishlistItemView, _extends({}, item, {
	                key: index,
	                labels: _this6.props.labels,
	                onSaveNote: function onSaveNote(note) {
	                    return _this6.onSaveNote(item, note);
	                },
	                onPurchase: function onPurchase() {
	                    return _this6.onPurchase(item);
	                },
	                onChangeQuantity: function onChangeQuantity(quantity) {
	                    return _this6.onChangeQuantity(item, quantity);
	                },
	                onRemove: function onRemove() {
	                    return _this6.onRemove(item);
	                }
	            }));
	        });
	
	        return _react2.default.createElement(
	            WishlistView,
	            null,
	            items
	        );
	    };
	
	    return WishlistController;
	}(_react2.default.Component);
	
	exports.default = WishlistController;
	
	
	WishlistController.propTypes = {
	    saveNoteToWishlistUrl: _react.PropTypes.string.isRequired,
	    removeUrl: _react.PropTypes.string.isRequired,
	    addToBasketUrl: _react.PropTypes.string.isRequired,
	    labels: _react.PropTypes.shape({}).isRequired
	};

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = createWishlistStore;
	
	var _ValueStore = __webpack_require__(159);
	
	var _ValueStore2 = _interopRequireDefault(_ValueStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createWishlistStore(initialState) {
	    var store = new _ValueStore2.default();
	    store.load(initialState);
	
	    return store;
	}

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentRegistry = __webpack_require__(2);
	
	var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);
	
	var _StepperController = __webpack_require__(24);
	
	var _StepperController2 = _interopRequireDefault(_StepperController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function Feedback(_ref) {
	  var feedback = _ref.feedback;
	
	  if (!feedback) {
	    return null;
	  }
	  return _react2.default.createElement(
	    "div",
	    { className: feedback.type + "-msg" },
	    feedback.message
	  );
	}
	Feedback.propTypes = {
	  feedback: _react.PropTypes.shape({
	    type: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })
	};
	
	var WishlistView = function (_React$Component) {
	  _inherits(WishlistView, _React$Component);
	
	  function WishlistView(props) {
	    _classCallCheck(this, WishlistView);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { open: false, originalNote: _this.props.note };
	    return _this;
	  }
	
	  WishlistView.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (this.state.open === true && nextProps.note !== this.state.originalNote) {
	      this.setState({ open: false, originalNote: nextProps.note });
	    }
	  };
	
	  WishlistView.prototype.onChangeNote = function onChangeNote(event, open) {
	    event.preventDefault();
	    this.setState({ open: open });
	  };
	
	  WishlistView.prototype.render = function render() {
	    var _this2 = this;
	
	    var Price = _ComponentRegistry2.default.get("Price");
	    var DeleteButton = _ComponentRegistry2.default.get("DeleteButton");
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      this.props.deletable ? _react2.default.createElement(
	        DeleteButton,
	        { onClick: this.props.onRemove, className: "icon remove pull-right" },
	        this.props.labels.removeFromWishlist
	      ) : null,
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "a",
	          { href: this.props.url },
	          _react2.default.createElement(
	            "h2",
	            null,
	            this.props.product.title
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col col-lg-3" },
	          this.props.labels.unitPrice,
	          _react2.default.createElement(Price, { value: this.props.product.pricing.excl, originalValue: this.props.product.originalPricing.excl })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col col-lg-3" },
	          this.props.labels.quantity,
	          _react2.default.createElement(_StepperController2.default, {
	            value: this.props.quantity,
	            min: this.props.product.minimumPurchaseAmount,
	            step: this.props.product.multipleFactor,
	            onChange: function onChange(quantity) {
	              return _this2.props.onChangeQuantity(quantity);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col col-lg-3" },
	          this.props.labels.totalPrice,
	          _react2.default.createElement(Price, { value: this.props.price ? this.props.price.excl : this.props.product.pricing.excl })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col col-lg-3" },
	          _react2.default.createElement(
	            "button",
	            {
	              className: "btn btn-primary", onClick: function onClick(event) {
	                event.preventDefault();
	                _this2.props.onPurchase();
	              }
	            },
	            this.props.labels.addToBasket
	          )
	        )
	      ),
	      _react2.default.createElement(Feedback, { feedback: this.props.feedback }),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        this.state.open ? _react2.default.createElement("textarea", {
	          className: "form-control rte",
	          defaultValue: this.props.note,
	          ref: function ref(textarea) {
	            _this2.textarea = textarea;
	          }
	        }) : _react2.default.createElement(
	          "p",
	          null,
	          this.props.note
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "actions group" },
	          this.state.open ? _react2.default.createElement(
	            "a",
	            {
	              href: "#save-note",
	              className: "primary button",
	              onClick: function onClick(event) {
	                event.preventDefault();
	                _this2.props.onSaveNote(_this2.textarea.value);
	              }
	            },
	            this.props.labels.saveNote
	          ) : _react2.default.createElement(
	            "a",
	            {
	              href: "#edit-note",
	              className: "primary button",
	              onClick: function onClick(event) {
	                return _this2.onChangeNote(event, true);
	              }
	            },
	            this.props.labels.changeNote
	          ),
	          this.state.open ? _react2.default.createElement(
	            "a",
	            {
	              href: "#cancel-note",
	              className: "primary button",
	              onClick: function onClick(event) {
	                return _this2.onChangeNote(event, false);
	              }
	            },
	            this.props.labels.cancel
	          ) : null
	        )
	      )
	    );
	  };
	
	  return WishlistView;
	}(_react2.default.Component);
	
	exports.default = WishlistView;
	
	
	WishlistView.propTypes = {
	  onSaveNote: _react.PropTypes.func.isRequired,
	  onPurchase: _react.PropTypes.func.isRequired,
	  onChangeQuantity: _react.PropTypes.func.isRequired,
	  onRemove: _react.PropTypes.func.isRequired,
	  labels: _react.PropTypes.shape({
	    changeNote: _react.PropTypes.string,
	    saveNote: _react.PropTypes.string,
	    cancel: _react.PropTypes.string,
	    removeFromWishlist: _react.PropTypes.string,
	    unitPrice: _react.PropTypes.string,
	    quantity: _react.PropTypes.string,
	    totalPrice: _react.PropTypes.string,
	    addToBasket: _react.PropTypes.string
	  }).isRequired,
	  note: _react.PropTypes.string,
	  feedback: _react.PropTypes.shape({}),
	  price: _react.PropTypes.shape({
	    excl: _react.PropTypes.string
	  }),
	  url: _react.PropTypes.string,
	  quantity: _react.PropTypes.number.isRequired,
	  product: _react.PropTypes.shape({
	    title: _react.PropTypes.string,
	    minimumPurchaseAmount: _react.PropTypes.number,
	    multipleFactor: _react.PropTypes.number,
	    pricing: _react.PropTypes.shape({
	      excl: _react.PropTypes.string
	    }).isRequired,
	    originalPricing: _react.PropTypes.shape({
	      excl: _react.PropTypes.string
	    })
	  }),
	  deletable: _react.PropTypes.bool.isRequired
	};
	
	WishlistView.defaultProps = {
	  deletable: true
	};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WishlistView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WishlistView(_ref) {
	    var children = _ref.children;
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        children
	    );
	}
	
	WishlistView.propTypes = {
	    children: _react.PropTypes.arrayOf(_react.PropTypes.node)
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = WishlistWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WishlistController = __webpack_require__(202);
	
	var _WishlistController2 = _interopRequireDefault(_WishlistController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WishlistWidget(props) {
	    return _react2.default.createElement(_WishlistController2.default, props);
	}

/***/ },
/* 207 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(25);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(7);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(9);
	
	var _DOMUtils = __webpack_require__(13);
	
	var _DOMStateStorage = __webpack_require__(39);
	
	var _PathUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(25);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(9);
	
	var _PathUtils = __webpack_require__(6);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(16);
	
	var _BrowserProtocol = __webpack_require__(25);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(209);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(13);
	
	var _createHistory = __webpack_require__(26);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(7);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(16);
	
	var _DOMUtils = __webpack_require__(13);
	
	var _HashProtocol = __webpack_require__(208);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(26);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(7);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(9);
	
	var _PathUtils = __webpack_require__(6);
	
	var _createHistory = __webpack_require__(26);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(27);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _DOMUtils = __webpack_require__(13);
	
	var _ExecutionEnvironment = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var startListener = function startListener(getPromptMessage) {
	  var handleBeforeUnload = function handleBeforeUnload(event) {
	    var message = getPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	
	    return undefined;
	  };
	
	  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
	  };
	};
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	var useBeforeUnload = function useBeforeUnload(createHistory) {
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;
	
	  return function (options) {
	    var history = createHistory(options);
	
	    var listeners = [];
	    var stopListener = void 0;
	
	    var getPromptMessage = function getPromptMessage() {
	      var message = void 0;
	      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
	        message = listeners[i].call();
	      }return message;
	    };
	
	    var listenBeforeUnload = function listenBeforeUnload(listener) {
	      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);
	
	      return function () {
	        listeners = listeners.filter(function (item) {
	          return item !== listener;
	        });
	
	        if (listeners.length === 0 && stopListener) {
	          stopListener();
	          stopListener = null;
	        }
	      };
	    };
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload
	    });
	  };
	};
	
	exports.default = useBeforeUnload;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(219);
	
	var _runTransitionHook = __webpack_require__(27);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(9);
	
	var _PathUtils = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 216 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 217 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 218 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClusterIcon = ClusterIcon;
	exports.Cluster = Cluster;
	exports.default = MarkerClusterer;
	/**
	 * @name MarkerClustererPlus for Google Maps V3
	 * @version 2.1.2 [May 28, 2014]
	 * @author Gary Little
	 * @fileoverview
	 * The library creates and manages per-zoom-level clusters for large amounts of markers.
	 * <p>
	 * This is an enhanced V3 implementation of the
	 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
	 * >V2 MarkerClusterer</a> by Xiaoxi Wu. It is based on the
	 * <a href="http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclusterer/"
	 * >V3 MarkerClusterer</a> port by Luke Mahe. MarkerClustererPlus was created by Gary Little.
	 * <p>
	 * v2.0 release: MarkerClustererPlus v2.0 is backward compatible with MarkerClusterer v1.0. It
	 *  adds support for the <code>ignoreHidden</code>, <code>title</code>, <code>batchSizeIE</code>,
	 *  and <code>calculator</code> properties as well as support for four more events. It also allows
	 *  greater control over the styling of the text that appears on the cluster marker. The
	 *  documentation has been significantly improved and the overall code has been simplified and
	 *  polished. Very large numbers of markers can now be managed without causing Javascript timeout
	 *  errors on Internet Explorer. Note that the name of the <code>clusterclick</code> event has been
	 *  deprecated. The new name is <code>click</code>, so please change your application code now.
	 */
	
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * @name ClusterIconStyle
	 * @class This class represents the object for values in the <code>styles</code> array passed
	 *  to the {@link MarkerClusterer} constructor. The element in this array that is used to
	 *  style the cluster icon is determined by calling the <code>calculator</code> function.
	 *
	 * @property {string} url The URL of the cluster icon image file. Required.
	 * @property {number} height The display height (in pixels) of the cluster icon. Required.
	 * @property {number} width The display width (in pixels) of the cluster icon. Required.
	 * @property {Array} [anchorText] The position (in pixels) from the center of the cluster icon to
	 *  where the text label is to be centered and drawn. The format is <code>[yoffset, xoffset]</code>
	 *  where <code>yoffset</code> increases as you go down from center and <code>xoffset</code>
	 *  increases to the right of center. The default is <code>[0, 0]</code>.
	 * @property {Array} [anchorIcon] The anchor position (in pixels) of the cluster icon. This is the
	 *  spot on the cluster icon that is to be aligned with the cluster position. The format is
	 *  <code>[yoffset, xoffset]</code> where <code>yoffset</code> increases as you go down and
	 *  <code>xoffset</code> increases to the right of the top-left corner of the icon. The default
	 *  anchor position is the center of the cluster icon.
	 * @property {string} [textColor="black"] The color of the label text shown on the
	 *  cluster icon.
	 * @property {number} [textSize=11] The size (in pixels) of the label text shown on the
	 *  cluster icon.
	 * @property {string} [textDecoration="none"] The value of the CSS <code>text-decoration</code>
	 *  property for the label text shown on the cluster icon.
	 * @property {string} [fontWeight="bold"] The value of the CSS <code>font-weight</code>
	 *  property for the label text shown on the cluster icon.
	 * @property {string} [fontStyle="normal"] The value of the CSS <code>font-style</code>
	 *  property for the label text shown on the cluster icon.
	 * @property {string} [fontFamily="Arial,sans-serif"] The value of the CSS <code>font-family</code>
	 *  property for the label text shown on the cluster icon.
	 * @property {string} [backgroundPosition="0 0"] The position of the cluster icon image
	 *  within the image defined by <code>url</code>. The format is <code>"xpos ypos"</code>
	 *  (the same format as for the CSS <code>background-position</code> property). You must set
	 *  this property appropriately when the image defined by <code>url</code> represents a sprite
	 *  containing multiple images. Note that the position <i>must</i> be specified in px units.
	 */
	/**
	 * @name ClusterIconInfo
	 * @class This class is an object containing general information about a cluster icon. This is
	 *  the object that a <code>calculator</code> function returns.
	 *
	 * @property {string} text The text of the label to be shown on the cluster icon.
	 * @property {number} index The index plus 1 of the element in the <code>styles</code>
	 *  array to be used to style the cluster icon.
	 * @property {string} title The tooltip to display when the mouse moves over the cluster icon.
	 *  If this value is <code>undefined</code> or <code>""</code>, <code>title</code> is set to the
	 *  value of the <code>title</code> property passed to the MarkerClusterer.
	 */
	/**
	 * A cluster icon.
	 *
	 * @constructor
	 * @extends google.maps.OverlayView
	 * @param {Cluster} cluster The cluster with which the icon is to be associated.
	 * @param {Array} [styles] An array of {@link ClusterIconStyle} defining the cluster icons
	 *  to use for various cluster sizes.
	 * @private
	 */
	function ClusterIcon(cluster, styles) {
	  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);
	
	  this.cluster_ = cluster;
	  this.className_ = cluster.getMarkerClusterer().getClusterClass();
	  this.styles_ = styles;
	  this.center_ = null;
	  this.div_ = null;
	  this.sums_ = null;
	  this.visible_ = false;
	
	  this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
	}
	
	/**
	 * Adds the icon to the DOM.
	 */
	ClusterIcon.prototype.onAdd = function () {
	  var cClusterIcon = this;
	  var cMouseDownInCluster;
	  var cDraggingMapByCluster;
	
	  this.div_ = document.createElement("div");
	  this.div_.className = this.className_;
	  if (this.visible_) {
	    this.show();
	  }
	
	  this.getPanes().overlayMouseTarget.appendChild(this.div_);
	
	  // Fix for Issue 157
	  this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
	    cDraggingMapByCluster = cMouseDownInCluster;
	  });
	
	  google.maps.event.addDomListener(this.div_, "mousedown", function () {
	    cMouseDownInCluster = true;
	    cDraggingMapByCluster = false;
	  });
	
	  google.maps.event.addDomListener(this.div_, "click", function (e) {
	    cMouseDownInCluster = false;
	    if (!cDraggingMapByCluster) {
	      var theBounds;
	      var mz;
	      var mc = cClusterIcon.cluster_.getMarkerClusterer();
	      /**
	       * This event is fired when a cluster marker is clicked.
	       * @name MarkerClusterer#click
	       * @param {Cluster} c The cluster that was clicked.
	       * @event
	       */
	      google.maps.event.trigger(mc, "click", cClusterIcon.cluster_);
	      google.maps.event.trigger(mc, "clusterclick", cClusterIcon.cluster_); // deprecated name
	
	      // The default click handler follows. Disable it by setting
	      // the zoomOnClick property to false.
	      if (mc.getZoomOnClick()) {
	        // Zoom into the cluster.
	        mz = mc.getMaxZoom();
	        theBounds = cClusterIcon.cluster_.getBounds();
	        mc.getMap().fitBounds(theBounds);
	        // There is a fix for Issue 170 here:
	        setTimeout(function () {
	          mc.getMap().fitBounds(theBounds);
	          // Don't zoom beyond the max zoom level
	          if (mz !== null && mc.getMap().getZoom() > mz) {
	            mc.getMap().setZoom(mz + 1);
	          }
	        }, 100);
	      }
	
	      // Prevent event propagation to the map:
	      e.cancelBubble = true;
	      if (e.stopPropagation) {
	        e.stopPropagation();
	      }
	    }
	  });
	
	  google.maps.event.addDomListener(this.div_, "mouseover", function () {
	    var mc = cClusterIcon.cluster_.getMarkerClusterer();
	    /**
	     * This event is fired when the mouse moves over a cluster marker.
	     * @name MarkerClusterer#mouseover
	     * @param {Cluster} c The cluster that the mouse moved over.
	     * @event
	     */
	    google.maps.event.trigger(mc, "mouseover", cClusterIcon.cluster_);
	  });
	
	  google.maps.event.addDomListener(this.div_, "mouseout", function () {
	    var mc = cClusterIcon.cluster_.getMarkerClusterer();
	    /**
	     * This event is fired when the mouse moves out of a cluster marker.
	     * @name MarkerClusterer#mouseout
	     * @param {Cluster} c The cluster that the mouse moved out of.
	     * @event
	     */
	    google.maps.event.trigger(mc, "mouseout", cClusterIcon.cluster_);
	  });
	};
	
	/**
	 * Removes the icon from the DOM.
	 */
	ClusterIcon.prototype.onRemove = function () {
	  if (this.div_ && this.div_.parentNode) {
	    this.hide();
	    google.maps.event.removeListener(this.boundsChangedListener_);
	    google.maps.event.clearInstanceListeners(this.div_);
	    this.div_.parentNode.removeChild(this.div_);
	    this.div_ = null;
	  }
	};
	
	/**
	 * Draws the icon.
	 */
	ClusterIcon.prototype.draw = function () {
	  if (this.visible_) {
	    var pos = this.getPosFromLatLng_(this.center_);
	    this.div_.style.top = pos.y + "px";
	    this.div_.style.left = pos.x + "px";
	  }
	};
	
	/**
	 * Hides the icon.
	 */
	ClusterIcon.prototype.hide = function () {
	  if (this.div_) {
	    this.div_.style.display = "none";
	  }
	  this.visible_ = false;
	};
	
	/**
	 * Positions and shows the icon.
	 */
	ClusterIcon.prototype.show = function () {
	  if (this.div_) {
	    var img = "";
	    // NOTE: values must be specified in px units
	    var bp = this.backgroundPosition_.split(" ");
	    var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ""), 10);
	    var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ""), 10);
	    var pos = this.getPosFromLatLng_(this.center_);
	    this.div_.style.cssText = this.createCss(pos);
	    img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
	    if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
	      img += "clip: rect(" + -1 * spriteV + "px, " + (-1 * spriteH + this.width_) + "px, " + (-1 * spriteV + this.height_) + "px, " + -1 * spriteH + "px);";
	    }
	    img += "'>";
	    this.div_.innerHTML = img + "<div style='" + "position: absolute;" + "top: " + this.anchorText_[0] + "px;" + "left: " + this.anchorText_[1] + "px;" + "color: " + this.textColor_ + ";" + "font-size: " + this.textSize_ + "px;" + "font-family: " + this.fontFamily_ + ";" + "font-weight: " + this.fontWeight_ + ";" + "font-style: " + this.fontStyle_ + ";" + "text-decoration: " + this.textDecoration_ + ";" + "text-align: center;" + "width: " + this.width_ + "px;" + "line-height:" + this.height_ + "px;" + "'>" + this.sums_.text + "</div>";
	    if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
	      this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
	    } else {
	      this.div_.title = this.sums_.title;
	    }
	    this.div_.style.display = "";
	  }
	  this.visible_ = true;
	};
	
	/**
	 * Sets the icon styles to the appropriate element in the styles array.
	 *
	 * @param {ClusterIconInfo} sums The icon label text and styles index.
	 */
	ClusterIcon.prototype.useStyle = function (sums) {
	  this.sums_ = sums;
	  var index = Math.max(0, sums.index - 1);
	  index = Math.min(this.styles_.length - 1, index);
	  var style = this.styles_[index];
	  this.url_ = style.url;
	  this.height_ = style.height;
	  this.width_ = style.width;
	  this.anchorText_ = style.anchorText || [0, 0];
	  this.anchorIcon_ = style.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];
	  this.textColor_ = style.textColor || "black";
	  this.textSize_ = style.textSize || 11;
	  this.textDecoration_ = style.textDecoration || "none";
	  this.fontWeight_ = style.fontWeight || "bold";
	  this.fontStyle_ = style.fontStyle || "normal";
	  this.fontFamily_ = style.fontFamily || "Arial,sans-serif";
	  this.backgroundPosition_ = style.backgroundPosition || "0 0";
	};
	
	/**
	 * Sets the position at which to center the icon.
	 *
	 * @param {google.maps.LatLng} center The latlng to set as the center.
	 */
	ClusterIcon.prototype.setCenter = function (center) {
	  this.center_ = center;
	};
	
	/**
	 * Creates the cssText style parameter based on the position of the icon.
	 *
	 * @param {google.maps.Point} pos The position of the icon.
	 * @return {string} The CSS style text.
	 */
	ClusterIcon.prototype.createCss = function (pos) {
	  var style = [];
	  style.push("cursor: pointer;");
	  style.push("position: absolute; top: " + pos.y + "px; left: " + pos.x + "px;");
	  style.push("width: " + this.width_ + "px; height: " + this.height_ + "px;");
	  return style.join("");
	};
	
	/**
	 * Returns the position at which to place the DIV depending on the latlng.
	 *
	 * @param {google.maps.LatLng} latlng The position in latlng.
	 * @return {google.maps.Point} The position in pixels.
	 */
	ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
	  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
	  pos.x -= this.anchorIcon_[1];
	  pos.y -= this.anchorIcon_[0];
	  pos.x = parseInt(pos.x, 10);
	  pos.y = parseInt(pos.y, 10);
	  return pos;
	};
	
	/**
	 * Creates a single cluster that manages a group of proximate markers.
	 *  Used internally, do not call this constructor directly.
	 * @constructor
	 * @param {MarkerClusterer} mc The <code>MarkerClusterer</code> object with which this
	 *  cluster is associated.
	 */
	function Cluster(mc) {
	  this.markerClusterer_ = mc;
	  this.map_ = mc.getMap();
	  this.gridSize_ = mc.getGridSize();
	  this.minClusterSize_ = mc.getMinimumClusterSize();
	  this.averageCenter_ = mc.getAverageCenter();
	  this.markers_ = [];
	  this.center_ = null;
	  this.bounds_ = null;
	  this.clusterIcon_ = new ClusterIcon(this, mc.getStyles());
	}
	
	/**
	 * Returns the number of markers managed by the cluster. You can call this from
	 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
	 * for the <code>MarkerClusterer</code> object.
	 *
	 * @return {number} The number of markers in the cluster.
	 */
	Cluster.prototype.getSize = function () {
	  return this.markers_.length;
	};
	
	/**
	 * Returns the array of markers managed by the cluster. You can call this from
	 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
	 * for the <code>MarkerClusterer</code> object.
	 *
	 * @return {Array} The array of markers in the cluster.
	 */
	Cluster.prototype.getMarkers = function () {
	  return this.markers_;
	};
	
	/**
	 * Returns the center of the cluster. You can call this from
	 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
	 * for the <code>MarkerClusterer</code> object.
	 *
	 * @return {google.maps.LatLng} The center of the cluster.
	 */
	Cluster.prototype.getCenter = function () {
	  return this.center_;
	};
	
	/**
	 * Returns the map with which the cluster is associated.
	 *
	 * @return {google.maps.Map} The map.
	 * @ignore
	 */
	Cluster.prototype.getMap = function () {
	  return this.map_;
	};
	
	/**
	 * Returns the <code>MarkerClusterer</code> object with which the cluster is associated.
	 *
	 * @return {MarkerClusterer} The associated marker clusterer.
	 * @ignore
	 */
	Cluster.prototype.getMarkerClusterer = function () {
	  return this.markerClusterer_;
	};
	
	/**
	 * Returns the bounds of the cluster.
	 *
	 * @return {google.maps.LatLngBounds} the cluster bounds.
	 * @ignore
	 */
	Cluster.prototype.getBounds = function () {
	  var i;
	  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
	  var markers = this.getMarkers();
	  for (i = 0; i < markers.length; i++) {
	    bounds.extend(markers[i].getPosition());
	  }
	  return bounds;
	};
	
	/**
	 * Removes the cluster from the map.
	 *
	 * @ignore
	 */
	Cluster.prototype.remove = function () {
	  this.clusterIcon_.setMap(null);
	  this.markers_ = [];
	  delete this.markers_;
	};
	
	/**
	 * Adds a marker to the cluster.
	 *
	 * @param {google.maps.Marker} marker The marker to be added.
	 * @return {boolean} True if the marker was added.
	 * @ignore
	 */
	Cluster.prototype.addMarker = function (marker) {
	  var i;
	  var mCount;
	  var mz;
	
	  if (this.isMarkerAlreadyAdded_(marker)) {
	    return false;
	  }
	
	  if (!this.center_) {
	    this.center_ = marker.getPosition();
	    this.calculateBounds_();
	  } else {
	    if (this.averageCenter_) {
	      var l = this.markers_.length + 1;
	      var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
	      var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
	      this.center_ = new google.maps.LatLng(lat, lng);
	      this.calculateBounds_();
	    }
	  }
	
	  marker.isAdded = true;
	  this.markers_.push(marker);
	
	  mCount = this.markers_.length;
	  mz = this.markerClusterer_.getMaxZoom();
	  if (mz !== null && this.map_.getZoom() > mz) {
	    // Zoomed in past max zoom, so show the marker.
	    if (marker.getMap() !== this.map_) {
	      marker.setMap(this.map_);
	    }
	  } else if (mCount < this.minClusterSize_) {
	    // Min cluster size not reached so show the marker.
	    if (marker.getMap() !== this.map_) {
	      marker.setMap(this.map_);
	    }
	  } else if (mCount === this.minClusterSize_) {
	    // Hide the markers that were showing.
	    for (i = 0; i < mCount; i++) {
	      this.markers_[i].setMap(null);
	    }
	  } else {
	    marker.setMap(null);
	  }
	
	  this.updateIcon_();
	  return true;
	};
	
	/**
	 * Determines if a marker lies within the cluster's bounds.
	 *
	 * @param {google.maps.Marker} marker The marker to check.
	 * @return {boolean} True if the marker lies in the bounds.
	 * @ignore
	 */
	Cluster.prototype.isMarkerInClusterBounds = function (marker) {
	  return this.bounds_.contains(marker.getPosition());
	};
	
	/**
	 * Calculates the extended bounds of the cluster with the grid.
	 */
	Cluster.prototype.calculateBounds_ = function () {
	  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
	  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
	};
	
	/**
	 * Updates the cluster icon.
	 */
	Cluster.prototype.updateIcon_ = function () {
	  var mCount = this.markers_.length;
	  var mz = this.markerClusterer_.getMaxZoom();
	
	  if (mz !== null && this.map_.getZoom() > mz) {
	    this.clusterIcon_.hide();
	    return;
	  }
	
	  if (mCount < this.minClusterSize_) {
	    // Min cluster size not yet reached.
	    this.clusterIcon_.hide();
	    return;
	  }
	
	  var numStyles = this.markerClusterer_.getStyles().length;
	  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
	  this.clusterIcon_.setCenter(this.center_);
	  this.clusterIcon_.useStyle(sums);
	  this.clusterIcon_.show();
	};
	
	/**
	 * Determines if a marker has already been added to the cluster.
	 *
	 * @param {google.maps.Marker} marker The marker to check.
	 * @return {boolean} True if the marker has already been added.
	 */
	Cluster.prototype.isMarkerAlreadyAdded_ = function (marker) {
	  var i;
	  if (this.markers_.indexOf) {
	    return this.markers_.indexOf(marker) !== -1;
	  } else {
	    for (i = 0; i < this.markers_.length; i++) {
	      if (marker === this.markers_[i]) {
	        return true;
	      }
	    }
	  }
	  return false;
	};
	
	/**
	 * @name MarkerClustererOptions
	 * @class This class represents the optional parameter passed to
	 *  the {@link MarkerClusterer} constructor.
	 * @property {number} [gridSize=60] The grid size of a cluster in pixels. The grid is a square.
	 * @property {number} [maxZoom=null] The maximum zoom level at which clustering is enabled or
	 *  <code>null</code> if clustering is to be enabled at all zoom levels.
	 * @property {boolean} [zoomOnClick=true] Whether to zoom the map when a cluster marker is
	 *  clicked. You may want to set this to <code>false</code> if you have installed a handler
	 *  for the <code>click</code> event and it deals with zooming on its own.
	 * @property {boolean} [averageCenter=false] Whether the position of a cluster marker should be
	 *  the average position of all markers in the cluster. If set to <code>false</code>, the
	 *  cluster marker is positioned at the location of the first marker added to the cluster.
	 * @property {number} [minimumClusterSize=2] The minimum number of markers needed in a cluster
	 *  before the markers are hidden and a cluster marker appears.
	 * @property {boolean} [ignoreHidden=false] Whether to ignore hidden markers in clusters. You
	 *  may want to set this to <code>true</code> to ensure that hidden markers are not included
	 *  in the marker count that appears on a cluster marker (this count is the value of the
	 *  <code>text</code> property of the result returned by the default <code>calculator</code>).
	 *  If set to <code>true</code> and you change the visibility of a marker being clustered, be
	 *  sure to also call <code>MarkerClusterer.repaint()</code>.
	 * @property {string} [title=""] The tooltip to display when the mouse moves over a cluster
	 *  marker. (Alternatively, you can use a custom <code>calculator</code> function to specify a
	 *  different tooltip for each cluster marker.)
	 * @property {function} [calculator=MarkerClusterer.CALCULATOR] The function used to determine
	 *  the text to be displayed on a cluster marker and the index indicating which style to use
	 *  for the cluster marker. The input parameters for the function are (1) the array of markers
	 *  represented by a cluster marker and (2) the number of cluster icon styles. It returns a
	 *  {@link ClusterIconInfo} object. The default <code>calculator</code> returns a
	 *  <code>text</code> property which is the number of markers in the cluster and an
	 *  <code>index</code> property which is one higher than the lowest integer such that
	 *  <code>10^i</code> exceeds the number of markers in the cluster, or the size of the styles
	 *  array, whichever is less. The <code>styles</code> array element used has an index of
	 *  <code>index</code> minus 1. For example, the default <code>calculator</code> returns a
	 *  <code>text</code> value of <code>"125"</code> and an <code>index</code> of <code>3</code>
	 *  for a cluster icon representing 125 markers so the element used in the <code>styles</code>
	 *  array is <code>2</code>. A <code>calculator</code> may also return a <code>title</code>
	 *  property that contains the text of the tooltip to be used for the cluster marker. If
	 *   <code>title</code> is not defined, the tooltip is set to the value of the <code>title</code>
	 *   property for the MarkerClusterer.
	 * @property {string} [clusterClass="cluster"] The name of the CSS class defining general styles
	 *  for the cluster markers. Use this class to define CSS styles that are not set up by the code
	 *  that processes the <code>styles</code> array.
	 * @property {Array} [styles] An array of {@link ClusterIconStyle} elements defining the styles
	 *  of the cluster markers to be used. The element to be used to style a given cluster marker
	 *  is determined by the function defined by the <code>calculator</code> property.
	 *  The default is an array of {@link ClusterIconStyle} elements whose properties are derived
	 *  from the values for <code>imagePath</code>, <code>imageExtension</code>, and
	 *  <code>imageSizes</code>.
	 * @property {boolean} [enableRetinaIcons=false] Whether to allow the use of cluster icons that
	 * have sizes that are some multiple (typically double) of their actual display size. Icons such
	 * as these look better when viewed on high-resolution monitors such as Apple's Retina displays.
	 * Note: if this property is <code>true</code>, sprites cannot be used as cluster icons.
	 * @property {number} [batchSize=MarkerClusterer.BATCH_SIZE] Set this property to the
	 *  number of markers to be processed in a single batch when using a browser other than
	 *  Internet Explorer (for Internet Explorer, use the batchSizeIE property instead).
	 * @property {number} [batchSizeIE=MarkerClusterer.BATCH_SIZE_IE] When Internet Explorer is
	 *  being used, markers are processed in several batches with a small delay inserted between
	 *  each batch in an attempt to avoid Javascript timeout errors. Set this property to the
	 *  number of markers to be processed in a single batch; select as high a number as you can
	 *  without causing a timeout error in the browser. This number might need to be as low as 100
	 *  if 15,000 markers are being managed, for example.
	 * @property {string} [imagePath=MarkerClusterer.IMAGE_PATH]
	 *  The full URL of the root name of the group of image files to use for cluster icons.
	 *  The complete file name is of the form <code>imagePath</code>n.<code>imageExtension</code>
	 *  where n is the image file number (1, 2, etc.).
	 * @property {string} [imageExtension=MarkerClusterer.IMAGE_EXTENSION]
	 *  The extension name for the cluster icon image files (e.g., <code>"png"</code> or
	 *  <code>"jpg"</code>).
	 * @property {Array} [imageSizes=MarkerClusterer.IMAGE_SIZES]
	 *  An array of numbers containing the widths of the group of
	 *  <code>imagePath</code>n.<code>imageExtension</code> image files.
	 *  (The images are assumed to be square.)
	 */
	/**
	 * Creates a MarkerClusterer object with the options specified in {@link MarkerClustererOptions}.
	 * @constructor
	 * @extends google.maps.OverlayView
	 * @param {google.maps.Map} map The Google map to attach to.
	 * @param {Array.<google.maps.Marker>} [opt_markers] The markers to be added to the cluster.
	 * @param {MarkerClustererOptions} [opt_options] The optional parameters.
	 */
	function MarkerClusterer(map, opt_markers, opt_options) {
	  // MarkerClusterer implements google.maps.OverlayView interface. We use the
	  // extend function to extend MarkerClusterer with google.maps.OverlayView
	  // because it might not always be available when the code is defined so we
	  // look for it at the last possible moment. If it doesn't exist now then
	  // there is no point going ahead :)
	  this.extend(MarkerClusterer, google.maps.OverlayView);
	
	  opt_markers = opt_markers || [];
	  opt_options = opt_options || {};
	
	  this.markers_ = [];
	  this.clusters_ = [];
	  this.listeners_ = [];
	  this.activeMap_ = null;
	  this.ready_ = false;
	
	  this.gridSize_ = opt_options.gridSize || 60;
	  this.minClusterSize_ = opt_options.minimumClusterSize || 2;
	  this.maxZoom_ = opt_options.maxZoom || null;
	  this.styles_ = opt_options.styles || [];
	  this.title_ = opt_options.title || "";
	  this.zoomOnClick_ = true;
	  if (opt_options.zoomOnClick !== undefined) {
	    this.zoomOnClick_ = opt_options.zoomOnClick;
	  }
	  this.averageCenter_ = false;
	  if (opt_options.averageCenter !== undefined) {
	    this.averageCenter_ = opt_options.averageCenter;
	  }
	  this.ignoreHidden_ = false;
	  if (opt_options.ignoreHidden !== undefined) {
	    this.ignoreHidden_ = opt_options.ignoreHidden;
	  }
	  this.enableRetinaIcons_ = false;
	  if (opt_options.enableRetinaIcons !== undefined) {
	    this.enableRetinaIcons_ = opt_options.enableRetinaIcons;
	  }
	  this.imagePath_ = opt_options.imagePath || MarkerClusterer.IMAGE_PATH;
	  this.imageExtension_ = opt_options.imageExtension || MarkerClusterer.IMAGE_EXTENSION;
	  this.imageSizes_ = opt_options.imageSizes || MarkerClusterer.IMAGE_SIZES;
	  this.calculator_ = opt_options.calculator || MarkerClusterer.CALCULATOR;
	  this.batchSize_ = opt_options.batchSize || MarkerClusterer.BATCH_SIZE;
	  this.batchSizeIE_ = opt_options.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;
	  this.clusterClass_ = opt_options.clusterClass || "cluster";
	
	  if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
	    // Try to avoid IE timeout when processing a huge number of markers:
	    this.batchSize_ = this.batchSizeIE_;
	  }
	
	  this.setupStyles_();
	
	  this.addMarkers(opt_markers, true);
	  this.setMap(map); // Note: this causes onAdd to be called
	}
	
	/**
	 * Implementation of the onAdd interface method.
	 * @ignore
	 */
	MarkerClusterer.prototype.onAdd = function () {
	  var cMarkerClusterer = this;
	
	  this.activeMap_ = this.getMap();
	  this.ready_ = true;
	
	  this.repaint();
	
	  // Add the map event listeners
	  this.listeners_ = [google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
	    cMarkerClusterer.resetViewport_(false);
	    // Workaround for this Google bug: when map is at level 0 and "-" of
	    // zoom slider is clicked, a "zoom_changed" event is fired even though
	    // the map doesn't zoom out any further. In this situation, no "idle"
	    // event is triggered so the cluster markers that have been removed
	    // do not get redrawn. Same goes for a zoom in at maxZoom.
	    if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
	      google.maps.event.trigger(this, "idle");
	    }
	  }), google.maps.event.addListener(this.getMap(), "idle", function () {
	    cMarkerClusterer.redraw_();
	  })];
	};
	
	/**
	 * Implementation of the onRemove interface method.
	 * Removes map event listeners and all cluster icons from the DOM.
	 * All managed markers are also put back on the map.
	 * @ignore
	 */
	MarkerClusterer.prototype.onRemove = function () {
	  var i;
	
	  // Put all the managed markers back on the map:
	  for (i = 0; i < this.markers_.length; i++) {
	    if (this.markers_[i].getMap() !== this.activeMap_) {
	      this.markers_[i].setMap(this.activeMap_);
	    }
	  }
	
	  // Remove all clusters:
	  for (i = 0; i < this.clusters_.length; i++) {
	    this.clusters_[i].remove();
	  }
	  this.clusters_ = [];
	
	  // Remove map event listeners:
	  for (i = 0; i < this.listeners_.length; i++) {
	    google.maps.event.removeListener(this.listeners_[i]);
	  }
	  this.listeners_ = [];
	
	  this.activeMap_ = null;
	  this.ready_ = false;
	};
	
	/**
	 * Implementation of the draw interface method.
	 * @ignore
	 */
	MarkerClusterer.prototype.draw = function () {};
	
	/**
	 * Sets up the styles object.
	 */
	MarkerClusterer.prototype.setupStyles_ = function () {
	  var i, size;
	  if (this.styles_.length > 0) {
	    return;
	  }
	
	  for (i = 0; i < this.imageSizes_.length; i++) {
	    size = this.imageSizes_[i];
	    this.styles_.push({
	      url: this.imagePath_ + (i + 1) + "." + this.imageExtension_,
	      height: size,
	      width: size
	    });
	  }
	};
	
	/**
	 *  Fits the map to the bounds of the markers managed by the clusterer.
	 */
	MarkerClusterer.prototype.fitMapToMarkers = function () {
	  var i;
	  var markers = this.getMarkers();
	  var bounds = new google.maps.LatLngBounds();
	  for (i = 0; i < markers.length; i++) {
	    bounds.extend(markers[i].getPosition());
	  }
	
	  this.getMap().fitBounds(bounds);
	};
	
	/**
	 * Returns the value of the <code>gridSize</code> property.
	 *
	 * @return {number} The grid size.
	 */
	MarkerClusterer.prototype.getGridSize = function () {
	  return this.gridSize_;
	};
	
	/**
	 * Sets the value of the <code>gridSize</code> property.
	 *
	 * @param {number} gridSize The grid size.
	 */
	MarkerClusterer.prototype.setGridSize = function (gridSize) {
	  this.gridSize_ = gridSize;
	};
	
	/**
	 * Returns the value of the <code>minimumClusterSize</code> property.
	 *
	 * @return {number} The minimum cluster size.
	 */
	MarkerClusterer.prototype.getMinimumClusterSize = function () {
	  return this.minClusterSize_;
	};
	
	/**
	 * Sets the value of the <code>minimumClusterSize</code> property.
	 *
	 * @param {number} minimumClusterSize The minimum cluster size.
	 */
	MarkerClusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
	  this.minClusterSize_ = minimumClusterSize;
	};
	
	/**
	 *  Returns the value of the <code>maxZoom</code> property.
	 *
	 *  @return {number} The maximum zoom level.
	 */
	MarkerClusterer.prototype.getMaxZoom = function () {
	  return this.maxZoom_;
	};
	
	/**
	 *  Sets the value of the <code>maxZoom</code> property.
	 *
	 *  @param {number} maxZoom The maximum zoom level.
	 */
	MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
	  this.maxZoom_ = maxZoom;
	};
	
	/**
	 *  Returns the value of the <code>styles</code> property.
	 *
	 *  @return {Array} The array of styles defining the cluster markers to be used.
	 */
	MarkerClusterer.prototype.getStyles = function () {
	  return this.styles_;
	};
	
	/**
	 *  Sets the value of the <code>styles</code> property.
	 *
	 *  @param {Array.<ClusterIconStyle>} styles The array of styles to use.
	 */
	MarkerClusterer.prototype.setStyles = function (styles) {
	  this.styles_ = styles;
	};
	
	/**
	 * Returns the value of the <code>title</code> property.
	 *
	 * @return {string} The content of the title text.
	 */
	MarkerClusterer.prototype.getTitle = function () {
	  return this.title_;
	};
	
	/**
	 *  Sets the value of the <code>title</code> property.
	 *
	 *  @param {string} title The value of the title property.
	 */
	MarkerClusterer.prototype.setTitle = function (title) {
	  this.title_ = title;
	};
	
	/**
	 * Returns the value of the <code>zoomOnClick</code> property.
	 *
	 * @return {boolean} True if zoomOnClick property is set.
	 */
	MarkerClusterer.prototype.getZoomOnClick = function () {
	  return this.zoomOnClick_;
	};
	
	/**
	 *  Sets the value of the <code>zoomOnClick</code> property.
	 *
	 *  @param {boolean} zoomOnClick The value of the zoomOnClick property.
	 */
	MarkerClusterer.prototype.setZoomOnClick = function (zoomOnClick) {
	  this.zoomOnClick_ = zoomOnClick;
	};
	
	/**
	 * Returns the value of the <code>averageCenter</code> property.
	 *
	 * @return {boolean} True if averageCenter property is set.
	 */
	MarkerClusterer.prototype.getAverageCenter = function () {
	  return this.averageCenter_;
	};
	
	/**
	 *  Sets the value of the <code>averageCenter</code> property.
	 *
	 *  @param {boolean} averageCenter The value of the averageCenter property.
	 */
	MarkerClusterer.prototype.setAverageCenter = function (averageCenter) {
	  this.averageCenter_ = averageCenter;
	};
	
	/**
	 * Returns the value of the <code>ignoreHidden</code> property.
	 *
	 * @return {boolean} True if ignoreHidden property is set.
	 */
	MarkerClusterer.prototype.getIgnoreHidden = function () {
	  return this.ignoreHidden_;
	};
	
	/**
	 *  Sets the value of the <code>ignoreHidden</code> property.
	 *
	 *  @param {boolean} ignoreHidden The value of the ignoreHidden property.
	 */
	MarkerClusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
	  this.ignoreHidden_ = ignoreHidden;
	};
	
	/**
	 * Returns the value of the <code>enableRetinaIcons</code> property.
	 *
	 * @return {boolean} True if enableRetinaIcons property is set.
	 */
	MarkerClusterer.prototype.getEnableRetinaIcons = function () {
	  return this.enableRetinaIcons_;
	};
	
	/**
	 *  Sets the value of the <code>enableRetinaIcons</code> property.
	 *
	 *  @param {boolean} enableRetinaIcons The value of the enableRetinaIcons property.
	 */
	MarkerClusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
	  this.enableRetinaIcons_ = enableRetinaIcons;
	};
	
	/**
	 * Returns the value of the <code>imageExtension</code> property.
	 *
	 * @return {string} The value of the imageExtension property.
	 */
	MarkerClusterer.prototype.getImageExtension = function () {
	  return this.imageExtension_;
	};
	
	/**
	 *  Sets the value of the <code>imageExtension</code> property.
	 *
	 *  @param {string} imageExtension The value of the imageExtension property.
	 */
	MarkerClusterer.prototype.setImageExtension = function (imageExtension) {
	  this.imageExtension_ = imageExtension;
	};
	
	/**
	 * Returns the value of the <code>imagePath</code> property.
	 *
	 * @return {string} The value of the imagePath property.
	 */
	MarkerClusterer.prototype.getImagePath = function () {
	  return this.imagePath_;
	};
	
	/**
	 *  Sets the value of the <code>imagePath</code> property.
	 *
	 *  @param {string} imagePath The value of the imagePath property.
	 */
	MarkerClusterer.prototype.setImagePath = function (imagePath) {
	  this.imagePath_ = imagePath;
	};
	
	/**
	 * Returns the value of the <code>imageSizes</code> property.
	 *
	 * @return {Array} The value of the imageSizes property.
	 */
	MarkerClusterer.prototype.getImageSizes = function () {
	  return this.imageSizes_;
	};
	
	/**
	 *  Sets the value of the <code>imageSizes</code> property.
	 *
	 *  @param {Array} imageSizes The value of the imageSizes property.
	 */
	MarkerClusterer.prototype.setImageSizes = function (imageSizes) {
	  this.imageSizes_ = imageSizes;
	};
	
	/**
	 * Returns the value of the <code>calculator</code> property.
	 *
	 * @return {function} the value of the calculator property.
	 */
	MarkerClusterer.prototype.getCalculator = function () {
	  return this.calculator_;
	};
	
	/**
	 * Sets the value of the <code>calculator</code> property.
	 *
	 * @param {function(Array.<google.maps.Marker>, number)} calculator The value
	 *  of the calculator property.
	 */
	MarkerClusterer.prototype.setCalculator = function (calculator) {
	  this.calculator_ = calculator;
	};
	
	/**
	 * Returns the value of the <code>batchSizeIE</code> property.
	 *
	 * @return {number} the value of the batchSizeIE property.
	 */
	MarkerClusterer.prototype.getBatchSizeIE = function () {
	  return this.batchSizeIE_;
	};
	
	/**
	 * Sets the value of the <code>batchSizeIE</code> property.
	 *
	 *  @param {number} batchSizeIE The value of the batchSizeIE property.
	 */
	MarkerClusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
	  this.batchSizeIE_ = batchSizeIE;
	};
	
	/**
	 * Returns the value of the <code>clusterClass</code> property.
	 *
	 * @return {string} the value of the clusterClass property.
	 */
	MarkerClusterer.prototype.getClusterClass = function () {
	  return this.clusterClass_;
	};
	
	/**
	 * Sets the value of the <code>clusterClass</code> property.
	 *
	 *  @param {string} clusterClass The value of the clusterClass property.
	 */
	MarkerClusterer.prototype.setClusterClass = function (clusterClass) {
	  this.clusterClass_ = clusterClass;
	};
	
	/**
	 *  Returns the array of markers managed by the clusterer.
	 *
	 *  @return {Array} The array of markers managed by the clusterer.
	 */
	MarkerClusterer.prototype.getMarkers = function () {
	  return this.markers_;
	};
	
	/**
	 *  Returns the number of markers managed by the clusterer.
	 *
	 *  @return {number} The number of markers.
	 */
	MarkerClusterer.prototype.getTotalMarkers = function () {
	  return this.markers_.length;
	};
	
	/**
	 * Returns the current array of clusters formed by the clusterer.
	 *
	 * @return {Array} The array of clusters formed by the clusterer.
	 */
	MarkerClusterer.prototype.getClusters = function () {
	  return this.clusters_;
	};
	
	/**
	 * Returns the number of clusters formed by the clusterer.
	 *
	 * @return {number} The number of clusters formed by the clusterer.
	 */
	MarkerClusterer.prototype.getTotalClusters = function () {
	  return this.clusters_.length;
	};
	
	/**
	 * Adds a marker to the clusterer. The clusters are redrawn unless
	 *  <code>opt_nodraw</code> is set to <code>true</code>.
	 *
	 * @param {google.maps.Marker} marker The marker to add.
	 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
	 */
	MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
	  this.pushMarkerTo_(marker);
	  if (!opt_nodraw) {
	    this.redraw_();
	  }
	};
	
	/**
	 * Adds an array of markers to the clusterer. The clusters are redrawn unless
	 *  <code>opt_nodraw</code> is set to <code>true</code>.
	 *
	 * @param {Array.<google.maps.Marker>} markers The markers to add.
	 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
	 */
	MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
	  var key;
	  for (key in markers) {
	    if (markers.hasOwnProperty(key)) {
	      this.pushMarkerTo_(markers[key]);
	    }
	  }
	  if (!opt_nodraw) {
	    this.redraw_();
	  }
	};
	
	/**
	 * Pushes a marker to the clusterer.
	 *
	 * @param {google.maps.Marker} marker The marker to add.
	 */
	MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
	  // If the marker is draggable add a listener so we can update the clusters on the dragend:
	  if (marker.getDraggable()) {
	    var cMarkerClusterer = this;
	    google.maps.event.addListener(marker, "dragend", function () {
	      if (cMarkerClusterer.ready_) {
	        this.isAdded = false;
	        cMarkerClusterer.repaint();
	      }
	    });
	  }
	  marker.isAdded = false;
	  this.markers_.push(marker);
	};
	
	/**
	 * Removes a marker from the cluster.  The clusters are redrawn unless
	 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if the
	 *  marker was removed from the clusterer.
	 *
	 * @param {google.maps.Marker} marker The marker to remove.
	 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
	 * @return {boolean} True if the marker was removed from the clusterer.
	 */
	MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
	  var removed = this.removeMarker_(marker);
	
	  if (!opt_nodraw && removed) {
	    this.repaint();
	  }
	
	  return removed;
	};
	
	/**
	 * Removes an array of markers from the cluster. The clusters are redrawn unless
	 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if markers
	 *  were removed from the clusterer.
	 *
	 * @param {Array.<google.maps.Marker>} markers The markers to remove.
	 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
	 * @return {boolean} True if markers were removed from the clusterer.
	 */
	MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
	  var i, r;
	  var removed = false;
	
	  for (i = 0; i < markers.length; i++) {
	    r = this.removeMarker_(markers[i]);
	    removed = removed || r;
	  }
	
	  if (!opt_nodraw && removed) {
	    this.repaint();
	  }
	
	  return removed;
	};
	
	/**
	 * Removes a marker and returns true if removed, false if not.
	 *
	 * @param {google.maps.Marker} marker The marker to remove
	 * @return {boolean} Whether the marker was removed or not
	 */
	MarkerClusterer.prototype.removeMarker_ = function (marker) {
	  var i;
	  var index = -1;
	  if (this.markers_.indexOf) {
	    index = this.markers_.indexOf(marker);
	  } else {
	    for (i = 0; i < this.markers_.length; i++) {
	      if (marker === this.markers_[i]) {
	        index = i;
	        break;
	      }
	    }
	  }
	
	  if (index === -1) {
	    // Marker is not in our list of markers, so do nothing:
	    return false;
	  }
	
	  marker.setMap(null);
	  this.markers_.splice(index, 1); // Remove the marker from the list of managed markers
	  return true;
	};
	
	/**
	 * Removes all clusters and markers from the map and also removes all markers
	 *  managed by the clusterer.
	 */
	MarkerClusterer.prototype.clearMarkers = function () {
	  this.resetViewport_(true);
	  this.markers_ = [];
	};
	
	/**
	 * Recalculates and redraws all the marker clusters from scratch.
	 *  Call this after changing any properties.
	 */
	MarkerClusterer.prototype.repaint = function () {
	  var oldClusters = this.clusters_.slice();
	  this.clusters_ = [];
	  this.resetViewport_(false);
	  this.redraw_();
	
	  // Remove the old clusters.
	  // Do it in a timeout to prevent blinking effect.
	  setTimeout(function () {
	    var i;
	    for (i = 0; i < oldClusters.length; i++) {
	      oldClusters[i].remove();
	    }
	  }, 0);
	};
	
	/**
	 * Returns the current bounds extended by the grid size.
	 *
	 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
	 * @return {google.maps.LatLngBounds} The extended bounds.
	 * @ignore
	 */
	MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
	  var projection = this.getProjection();
	
	  // Turn the bounds into latlng.
	  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
	  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng());
	
	  // Convert the points to pixels and the extend out by the grid size.
	  var trPix = projection.fromLatLngToDivPixel(tr);
	  trPix.x += this.gridSize_;
	  trPix.y -= this.gridSize_;
	
	  var blPix = projection.fromLatLngToDivPixel(bl);
	  blPix.x -= this.gridSize_;
	  blPix.y += this.gridSize_;
	
	  // Convert the pixel points back to LatLng
	  var ne = projection.fromDivPixelToLatLng(trPix);
	  var sw = projection.fromDivPixelToLatLng(blPix);
	
	  // Extend the bounds to contain the new bounds.
	  bounds.extend(ne);
	  bounds.extend(sw);
	
	  return bounds;
	};
	
	/**
	 * Redraws all the clusters.
	 */
	MarkerClusterer.prototype.redraw_ = function () {
	  this.createClusters_(0);
	};
	
	/**
	 * Removes all clusters from the map. The markers are also removed from the map
	 *  if <code>opt_hide</code> is set to <code>true</code>.
	 *
	 * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
	 *  from the map.
	 */
	MarkerClusterer.prototype.resetViewport_ = function (opt_hide) {
	  var i, marker;
	  // Remove all the clusters
	  for (i = 0; i < this.clusters_.length; i++) {
	    this.clusters_[i].remove();
	  }
	  this.clusters_ = [];
	
	  // Reset the markers to not be added and to be removed from the map.
	  for (i = 0; i < this.markers_.length; i++) {
	    marker = this.markers_[i];
	    marker.isAdded = false;
	    if (opt_hide) {
	      marker.setMap(null);
	    }
	  }
	};
	
	/**
	 * Calculates the distance between two latlng locations in km.
	 *
	 * @param {google.maps.LatLng} p1 The first lat lng point.
	 * @param {google.maps.LatLng} p2 The second lat lng point.
	 * @return {number} The distance between the two points in km.
	 * @see http://www.movable-type.co.uk/scripts/latlong.html
	*/
	MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
	  var R = 6371; // Radius of the Earth in km
	  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
	  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
	  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
	  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  var d = R * c;
	  return d;
	};
	
	/**
	 * Determines if a marker is contained in a bounds.
	 *
	 * @param {google.maps.Marker} marker The marker to check.
	 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
	 * @return {boolean} True if the marker is in the bounds.
	 */
	MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
	  return bounds.contains(marker.getPosition());
	};
	
	/**
	 * Adds a marker to a cluster, or creates a new cluster.
	 *
	 * @param {google.maps.Marker} marker The marker to add.
	 */
	MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
	  var i, d, cluster, center;
	  var distance = 40000; // Some large number
	  var clusterToAddTo = null;
	  for (i = 0; i < this.clusters_.length; i++) {
	    cluster = this.clusters_[i];
	    center = cluster.getCenter();
	    if (center) {
	      d = this.distanceBetweenPoints_(center, marker.getPosition());
	      if (d < distance) {
	        distance = d;
	        clusterToAddTo = cluster;
	      }
	    }
	  }
	
	  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
	    clusterToAddTo.addMarker(marker);
	  } else {
	    cluster = new Cluster(this);
	    cluster.addMarker(marker);
	    this.clusters_.push(cluster);
	  }
	};
	
	/**
	 * Creates the clusters. This is done in batches to avoid timeout errors
	 *  in some browsers when there is a huge number of markers.
	 *
	 * @param {number} iFirst The index of the first marker in the batch of
	 *  markers to be added to clusters.
	 */
	MarkerClusterer.prototype.createClusters_ = function (iFirst) {
	  var i, marker;
	  var mapBounds;
	  var cMarkerClusterer = this;
	  if (!this.ready_) {
	    return;
	  }
	
	  // Cancel previous batch processing if we're working on the first batch:
	  if (iFirst === 0) {
	    /**
	     * This event is fired when the <code>MarkerClusterer</code> begins
	     *  clustering markers.
	     * @name MarkerClusterer#clusteringbegin
	     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
	     * @event
	     */
	    google.maps.event.trigger(this, "clusteringbegin", this);
	
	    if (typeof this.timerRefStatic !== "undefined") {
	      clearTimeout(this.timerRefStatic);
	      delete this.timerRefStatic;
	    }
	  }
	
	  // Get our current map view bounds.
	  // Create a new bounds object so we don't affect the map.
	  //
	  // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
	  if (this.getMap().getZoom() > 3) {
	    mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(), this.getMap().getBounds().getNorthEast());
	  } else {
	    mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
	  }
	  var bounds = this.getExtendedBounds(mapBounds);
	
	  var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);
	
	  for (i = iFirst; i < iLast; i++) {
	    marker = this.markers_[i];
	    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
	      if (!this.ignoreHidden_ || this.ignoreHidden_ && marker.getVisible()) {
	        this.addToClosestCluster_(marker);
	      }
	    }
	  }
	
	  if (iLast < this.markers_.length) {
	    this.timerRefStatic = setTimeout(function () {
	      cMarkerClusterer.createClusters_(iLast);
	    }, 0);
	  } else {
	    delete this.timerRefStatic;
	
	    /**
	     * This event is fired when the <code>MarkerClusterer</code> stops
	     *  clustering markers.
	     * @name MarkerClusterer#clusteringend
	     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
	     * @event
	     */
	    google.maps.event.trigger(this, "clusteringend", this);
	  }
	};
	
	/**
	 * Extends an object's prototype by another's.
	 *
	 * @param {Object} obj1 The object to be extended.
	 * @param {Object} obj2 The object to extend with.
	 * @return {Object} The new extended object.
	 * @ignore
	 */
	MarkerClusterer.prototype.extend = function (obj1, obj2) {
	  return function (object) {
	    var property;
	    for (property in object.prototype) {
	      this.prototype[property] = object.prototype[property];
	    }
	    return this;
	  }.apply(obj1, [obj2]);
	};
	
	/**
	 * The default function for determining the label text and style
	 * for a cluster icon.
	 *
	 * @param {Array.<google.maps.Marker>} markers The array of markers represented by the cluster.
	 * @param {number} numStyles The number of marker styles available.
	 * @return {ClusterIconInfo} The information resource for the cluster.
	 * @constant
	 * @ignore
	 */
	MarkerClusterer.CALCULATOR = function (markers, numStyles) {
	  var index = 0;
	  var title = "";
	  var count = markers.length.toString();
	
	  var dv = count;
	  while (dv !== 0) {
	    dv = parseInt(dv / 10, 10);
	    index++;
	  }
	
	  index = Math.min(index, numStyles);
	  return {
	    text: count,
	    index: index,
	    title: title
	  };
	};
	
	/**
	 * The number of markers to process in one batch.
	 *
	 * @type {number}
	 * @constant
	 */
	MarkerClusterer.BATCH_SIZE = 2000;
	
	/**
	 * The number of markers to process in one batch (IE only).
	 *
	 * @type {number}
	 * @constant
	 */
	MarkerClusterer.BATCH_SIZE_IE = 500;
	
	/**
	 * The default root name for the marker cluster images.
	 *
	 * @type {string}
	 * @constant
	 */
	MarkerClusterer.IMAGE_PATH = "http://google-maps-utility-library-v3.googlecode.com/svn/trunk/markerclustererplus/images/m";
	
	/**
	 * The default extension name for the marker cluster images.
	 *
	 * @type {string}
	 * @constant
	 */
	MarkerClusterer.IMAGE_EXTENSION = "png";
	
	/**
	 * The default array of sizes for the marker cluster images.
	 *
	 * @type {Array.<number>}
	 * @constant
	 */
	MarkerClusterer.IMAGE_SIZES = [53, 56, 66, 78, 90];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(247);
	var objectAssign = __webpack_require__(43);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
	
					key = key.replace(/\[\]$/, '');
	
					if (!result || accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(5);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(87);
	
	var _domAlign2 = _interopRequireDefault(_domAlign);
	
	var _addEventListener = __webpack_require__(223);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _isWindow = __webpack_require__(222);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	var Align = _react2["default"].createClass({
	  displayName: 'Align',
	
	  propTypes: {
	    childrenProps: _react.PropTypes.object,
	    align: _react.PropTypes.object.isRequired,
	    target: _react.PropTypes.func,
	    onAlign: _react.PropTypes.func,
	    monitorBufferTime: _react.PropTypes.number,
	    monitorWindowResize: _react.PropTypes.bool,
	    disabled: _react.PropTypes.bool,
	    children: _react.PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      target: function target() {
	        return window;
	      },
	      onAlign: function onAlign() {},
	
	      monitorBufferTime: 50,
	      monitorWindowResize: false,
	      disabled: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var props = this.props;
	    // if parent ref not attached .... use document.getElementById
	    this.forceAlign();
	    if (!props.disabled && props.monitorWindowResize) {
	      this.startMonitorWindowResize();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var reAlign = false;
	    var props = this.props;
	
	    if (!props.disabled) {
	      if (prevProps.disabled || prevProps.align !== props.align) {
	        reAlign = true;
	      } else {
	        var lastTarget = prevProps.target();
	        var currentTarget = props.target();
	        if ((0, _isWindow2["default"])(lastTarget) && (0, _isWindow2["default"])(currentTarget)) {
	          reAlign = false;
	        } else if (lastTarget !== currentTarget) {
	          reAlign = true;
	        }
	      }
	    }
	
	    if (reAlign) {
	      this.forceAlign();
	    }
	
	    if (props.monitorWindowResize && !props.disabled) {
	      this.startMonitorWindowResize();
	    } else {
	      this.stopMonitorWindowResize();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.stopMonitorWindowResize();
	  },
	  startMonitorWindowResize: function startMonitorWindowResize() {
	    if (!this.resizeHandler) {
	      this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
	      this.resizeHandler = (0, _addEventListener2["default"])(window, 'resize', this.bufferMonitor);
	    }
	  },
	  stopMonitorWindowResize: function stopMonitorWindowResize() {
	    if (this.resizeHandler) {
	      this.bufferMonitor.clear();
	      this.resizeHandler.remove();
	      this.resizeHandler = null;
	    }
	  },
	  forceAlign: function forceAlign() {
	    var props = this.props;
	    if (!props.disabled) {
	      var source = _reactDom2["default"].findDOMNode(this);
	      props.onAlign(source, (0, _domAlign2["default"])(source, props.target(), props.align));
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        childrenProps = _props.childrenProps,
	        children = _props.children;
	
	    var child = _react2["default"].Children.only(children);
	    if (childrenProps) {
	      var newProps = {};
	      for (var prop in childrenProps) {
	        if (childrenProps.hasOwnProperty(prop)) {
	          newProps[prop] = this.props[childrenProps[prop]];
	        }
	      }
	      return _react2["default"].cloneElement(child, newProps);
	    }
	    return child;
	  }
	});
	
	exports["default"] = Align;
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Align = __webpack_require__(220);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _Align2["default"]; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isWindow;
	function isWindow(obj) {
	  /* eslint no-eq-null: 0 */
	  /* eslint eqeqeq: 0 */
	  return obj != null && obj == obj.window;
	}
	module.exports = exports['default'];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = addEventListenerWrap;
	
	var _addDomEventListener = __webpack_require__(17);
	
	var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);
	
	var _reactDom = __webpack_require__(5);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function addEventListenerWrap(target, eventType, cb) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom2["default"].unstable_batchedUpdates ? function run(e) {
	    _reactDom2["default"].unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener2["default"])(target, eventType, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildrenUtils = __webpack_require__(226);
	
	var _AnimateChild = __webpack_require__(225);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _util = __webpack_require__(41);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2["default"].isValidElement(children)) {
	    if (!children.key) {
	      return _react2["default"].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = _react2["default"].createClass({
	  displayName: 'Animate',
	
	  propTypes: {
	    component: _react2["default"].PropTypes.any,
	    componentProps: _react2["default"].PropTypes.object,
	    animation: _react2["default"].PropTypes.object,
	    transitionName: _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.string, _react2["default"].PropTypes.object]),
	    transitionEnter: _react2["default"].PropTypes.bool,
	    transitionAppear: _react2["default"].PropTypes.bool,
	    exclusive: _react2["default"].PropTypes.bool,
	    transitionLeave: _react2["default"].PropTypes.bool,
	    onEnd: _react2["default"].PropTypes.func,
	    onEnter: _react2["default"].PropTypes.func,
	    onLeave: _react2["default"].PropTypes.func,
	    onAppear: _react2["default"].PropTypes.func,
	    showProp: _react2["default"].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      animation: {},
	      component: 'span',
	      componentProps: {},
	      transitionEnter: true,
	      transitionLeave: true,
	      transitionAppear: false,
	      onEnd: noop,
	      onEnter: noop,
	      onLeave: noop,
	      onAppear: noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.currentlyAnimatingKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	    return {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(this.props))
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var showProp = this.props.showProp;
	    var children = this.state.children;
	    if (showProp) {
	      children = children.filter(function (child) {
	        return !!child.props[showProp];
	      });
	    }
	    children.forEach(function (child) {
	      if (child) {
	        _this.performAppear(child.key);
	      }
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    this.nextProps = nextProps;
	    var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	    var props = this.props;
	    // exclusive needs immediate response
	    if (props.exclusive) {
	      Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	        _this2.stop(key);
	      });
	    }
	    var showProp = props.showProp;
	    var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	    // last props children if exclusive
	    var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	    // in case destroy in showProp mode
	    var newChildren = [];
	    if (showProp) {
	      currentChildren.forEach(function (currentChild) {
	        var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	        var newChild = void 0;
	        if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	          newChild = _react2["default"].cloneElement(nextChild || currentChild, _defineProperty({}, showProp, true));
	        } else {
	          newChild = nextChild;
	        }
	        if (newChild) {
	          newChildren.push(newChild);
	        }
	      });
	      nextChildren.forEach(function (nextChild) {
	        if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	          newChildren.push(nextChild);
	        }
	      });
	    } else {
	      newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	    }
	
	    // need render to avoid update
	    this.setState({
	      children: newChildren
	    });
	
	    nextChildren.forEach(function (child) {
	      var key = child && child.key;
	      if (child && currentlyAnimatingKeys[key]) {
	        return;
	      }
	      var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	      if (showProp) {
	        var showInNext = child.props[showProp];
	        if (hasPrev) {
	          var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	          if (!showInNow && showInNext) {
	            _this2.keysToEnter.push(key);
	          }
	        } else if (showInNext) {
	          _this2.keysToEnter.push(key);
	        }
	      } else if (!hasPrev) {
	        _this2.keysToEnter.push(key);
	      }
	    });
	
	    currentChildren.forEach(function (child) {
	      var key = child && child.key;
	      if (child && currentlyAnimatingKeys[key]) {
	        return;
	      }
	      var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	      if (showProp) {
	        var showInNow = child.props[showProp];
	        if (hasNext) {
	          var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	          if (!showInNext && showInNow) {
	            _this2.keysToLeave.push(key);
	          }
	        } else if (showInNow) {
	          _this2.keysToLeave.push(key);
	        }
	      } else if (!hasNext) {
	        _this2.keysToLeave.push(key);
	      }
	    });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	  performEnter: function performEnter(key) {
	    // may already remove by exclusive
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillEnter(this.handleDoneAdding.bind(this, key, 'enter'));
	    }
	  },
	  performAppear: function performAppear(key) {
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillAppear(this.handleDoneAdding.bind(this, key, 'appear'));
	    }
	  },
	  handleDoneAdding: function handleDoneAdding(key, type) {
	    var props = this.props;
	    delete this.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== this.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!this.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      this.performLeave(key);
	    } else {
	      if (type === 'appear') {
	        if (_util2["default"].allowAppearCallback(props)) {
	          props.onAppear(key);
	          props.onEnd(key, true);
	        }
	      } else {
	        if (_util2["default"].allowEnterCallback(props)) {
	          props.onEnter(key);
	          props.onEnd(key, true);
	        }
	      }
	    }
	  },
	  performLeave: function performLeave(key) {
	    // may already remove by exclusive
	    if (this.refs[key]) {
	      this.currentlyAnimatingKeys[key] = true;
	      this.refs[key].componentWillLeave(this.handleDoneLeaving.bind(this, key));
	    }
	  },
	  handleDoneLeaving: function handleDoneLeaving(key) {
	    var props = this.props;
	    delete this.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== this.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (this.isValidChildByKey(currentChildren, key)) {
	      this.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_util2["default"].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      /* eslint react/no-is-mounted:0 */
	      if (this.isMounted() && !(0, _ChildrenUtils.isSameChildren)(this.state.children, currentChildren, props.showProp)) {
	        this.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  },
	  isValidChildByKey: function isValidChildByKey(currentChildren, key) {
	    var showProp = this.props.showProp;
	    if (showProp) {
	      return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	    }
	    return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	  },
	  stop: function stop(key) {
	    delete this.currentlyAnimatingKeys[key];
	    var component = this.refs[key];
	    if (component) {
	      component.stop();
	    }
	  },
	  render: function render() {
	    var props = this.props;
	    this.nextProps = props;
	    var stateChildren = this.state.children;
	    var children = null;
	    if (stateChildren) {
	      children = stateChildren.map(function (child) {
	        if (child === null || child === undefined) {
	          return child;
	        }
	        if (!child.key) {
	          throw new Error('must set key for <rc-animate> children');
	        }
	        return _react2["default"].createElement(
	          _AnimateChild2["default"],
	          {
	            key: child.key,
	            ref: child.key,
	            animation: props.animation,
	            transitionName: props.transitionName,
	            transitionEnter: props.transitionEnter,
	            transitionAppear: props.transitionAppear,
	            transitionLeave: props.transitionLeave
	          },
	          child
	        );
	      });
	    }
	    var Component = props.component;
	    if (Component) {
	      var passedProps = props;
	      if (typeof Component === 'string') {
	        passedProps = _extends({
	          className: props.className,
	          style: props.style
	        }, props.componentProps);
	      }
	      return _react2["default"].createElement(
	        Component,
	        passedProps,
	        children
	      );
	    }
	    return children[0] || null;
	  }
	});
	
	exports["default"] = Animate;
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(5);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _cssAnimation = __webpack_require__(81);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _util = __webpack_require__(41);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = _react2["default"].createClass({
	  displayName: 'AnimateChild',
	
	  propTypes: {
	    children: _react2["default"].PropTypes.any
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.stop();
	  },
	  componentWillEnter: function componentWillEnter(done) {
	    if (_util2["default"].isEnterSupported(this.props)) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },
	  componentWillAppear: function componentWillAppear(done) {
	    if (_util2["default"].isAppearSupported(this.props)) {
	      this.transition('appear', done);
	    } else {
	      done();
	    }
	  },
	  componentWillLeave: function componentWillLeave(done) {
	    if (_util2["default"].isLeaveSupported(this.props)) {
	      this.transition('leave', done);
	    } else {
	      // always sync, do not interupt with react component life cycle
	      // update hidden -> animate hidden ->
	      // didUpdate -> animate leave -> unmount (if animate is none)
	      done();
	    }
	  },
	  transition: function transition(animationType, finishCallback) {
	    var _this = this;
	
	    var node = _reactDom2["default"].findDOMNode(this);
	    var props = this.props;
	    var transitionName = props.transitionName;
	    var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object';
	    this.stop();
	    var end = function end() {
	      _this.stopper = null;
	      finishCallback();
	    };
	    if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	      var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	      var activeName = name + '-active';
	      if (nameIsObj && transitionName[animationType + 'Active']) {
	        activeName = transitionName[animationType + 'Active'];
	      }
	      this.stopper = (0, _cssAnimation2["default"])(node, {
	        name: name,
	        active: activeName
	      }, end);
	    } else {
	      this.stopper = props.animation[animationType](node, end);
	    }
	  },
	  stop: function stop() {
	    var stopper = this.stopper;
	    if (stopper) {
	      this.stopper = null;
	      stopper.stop();
	    }
	  },
	  render: function render() {
	    return this.props.children;
	  }
	});
	
	exports["default"] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2["default"].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// export this package's api
	module.exports = __webpack_require__(224);

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rcTooltip = __webpack_require__(235);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var Handle = (function (_React$Component) {
	  _inherits(Handle, _React$Component);
	
	  function Handle(props) {
	    _classCallCheck(this, Handle);
	
	    _get(Object.getPrototypeOf(Handle.prototype), 'constructor', this).call(this, props);
	
	    this.state = {
	      isTooltipVisible: false
	    };
	  }
	
	  _createClass(Handle, [{
	    key: 'showTooltip',
	    value: function showTooltip() {
	      this.setState({
	        isTooltipVisible: true
	      });
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      this.setState({
	        isTooltipVisible: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var prefixCls = _props.prefixCls;
	      var className = _props.className;
	      var tipTransitionName = _props.tipTransitionName;
	      var tipFormatter = _props.tipFormatter;
	      var vertical = _props.vertical;
	      var offset = _props.offset;
	      var value = _props.value;
	      var dragging = _props.dragging;
	      var noTip = _props.noTip;
	
	      var style = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
	      var handle = _react2['default'].createElement('div', { className: className, style: style,
	        onMouseUp: this.showTooltip.bind(this),
	        onMouseEnter: this.showTooltip.bind(this),
	        onMouseLeave: this.hideTooltip.bind(this)
	      });
	
	      if (noTip) {
	        return handle;
	      }
	
	      var isTooltipVisible = dragging || this.state.isTooltipVisible;
	      return _react2['default'].createElement(
	        _rcTooltip2['default'],
	        {
	          prefixCls: prefixCls.replace('slider', 'tooltip'),
	          placement: 'top',
	          visible: isTooltipVisible,
	          overlay: _react2['default'].createElement(
	            'span',
	            null,
	            tipFormatter(value)
	          ),
	          delay: 0,
	          transitionName: tipTransitionName
	        },
	        handle
	      );
	    }
	  }]);
	
	  return Handle;
	})(_react2['default'].Component);
	
	exports['default'] = Handle;
	
	Handle.propTypes = {
	  prefixCls: _react2['default'].PropTypes.string,
	  className: _react2['default'].PropTypes.string,
	  vertical: _react2['default'].PropTypes.bool,
	  offset: _react2['default'].PropTypes.number,
	  tipTransitionName: _react2['default'].PropTypes.string,
	  tipFormatter: _react2['default'].PropTypes.func,
	  value: _react2['default'].PropTypes.number,
	  dragging: _react2['default'].PropTypes.bool,
	  noTip: _react2['default'].PropTypes.bool
	};
	module.exports = exports['default'];

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Marks = function Marks(_ref) {
	  var className = _ref.className;
	  var vertical = _ref.vertical;
	  var marks = _ref.marks;
	  var included = _ref.included;
	  var upperBound = _ref.upperBound;
	  var lowerBound = _ref.lowerBound;
	  var max = _ref.max;
	  var min = _ref.min;
	
	  var marksKeys = Object.keys(marks);
	  var marksCount = marksKeys.length;
	  var unit = 100 / (marksCount - 1);
	  var markWidth = unit * 0.9;
	
	  var range = max - min;
	  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
	    return a - b;
	  }).map(function (point) {
	    var _classNames;
	
	    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var markClassName = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, className + '-text', true), _defineProperty(_classNames, className + '-text-active', isActived), _classNames));
	
	    var bottomStyle = {
	      // height: markWidth + '%',
	      marginBottom: '-200' + '%',
	      bottom: (point - min) / range * 100 + '%'
	    };
	
	    var leftStyle = {
	      width: markWidth + '%',
	      marginLeft: -markWidth / 2 + '%',
	      left: (point - min) / range * 100 + '%'
	    };
	
	    var style = vertical ? bottomStyle : leftStyle;
	
	    var markPoint = marks[point];
	    var markPointIsObject = typeof markPoint === 'object' && !_react2['default'].isValidElement(markPoint);
	    var markLabel = markPointIsObject ? markPoint.label : markPoint;
	    var markStyle = markPointIsObject ? _extends({}, style, markPoint.style) : style;
	    return _react2['default'].createElement(
	      'span',
	      { className: markClassName, style: markStyle, key: point },
	      markLabel
	    );
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: className },
	    elements
	  );
	};
	
	exports['default'] = Marks;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rcUtilLibDomAddEventListener = __webpack_require__(245);
	
	var _rcUtilLibDomAddEventListener2 = _interopRequireDefault(_rcUtilLibDomAddEventListener);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Track = __webpack_require__(232);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _Handle = __webpack_require__(228);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _Steps = __webpack_require__(231);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Marks = __webpack_require__(229);
	
	var _Marks2 = _interopRequireDefault(_Marks);
	
	function noop() {}
	
	function isNotTouchEvent(e) {
	  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
	}
	
	function getTouchPosition(vertical, e) {
	  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
	}
	
	function getMousePosition(vertical, e) {
	  return vertical ? e.clientY : e.pageX;
	}
	
	function pauseEvent(e) {
	  e.stopPropagation();
	  e.preventDefault();
	}
	
	var Slider = (function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    _get(Object.getPrototypeOf(Slider.prototype), 'constructor', this).call(this, props);
	
	    var range = props.range;
	    var min = props.min;
	    var max = props.max;
	
	    var initialValue = range ? [min, min] : min;
	    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
	    var value = props.value !== undefined ? props.value : defaultValue;
	
	    var upperBound = undefined;
	    var lowerBound = undefined;
	    if (props.range) {
	      lowerBound = this.trimAlignValue(value[0]);
	      upperBound = this.trimAlignValue(value[1]);
	    } else {
	      upperBound = this.trimAlignValue(value);
	    }
	
	    var recent = undefined;
	    if (props.range && upperBound === lowerBound) {
	      recent = lowerBound === max ? 'lowerBound' : 'upperBound';
	    } else {
	      recent = 'upperBound';
	    }
	
	    this.state = {
	      handle: null,
	      recent: recent,
	      upperBound: upperBound,
	      // If Slider is not range, set `lowerBound` equal to `min`.
	      lowerBound: lowerBound || min
	    };
	  }
	
	  _createClass(Slider, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
	
	      var _state = this.state;
	      var lowerBound = _state.lowerBound;
	      var upperBound = _state.upperBound;
	
	      if (nextProps.range) {
	        var value = nextProps.value || [lowerBound, upperBound];
	        var nextUpperBound = this.trimAlignValue(value[1], nextProps);
	        var nextLowerBound = this.trimAlignValue(value[0], nextProps);
	        if (nextLowerBound === lowerBound && nextUpperBound === upperBound) return;
	
	        this.setState({
	          upperBound: nextUpperBound,
	          lowerBound: nextLowerBound
	        });
	        if (this.isValueOutOfBounds(upperBound, nextProps) || this.isValueOutOfBounds(lowerBound, nextProps)) {
	          this.props.onChange([nextLowerBound, nextUpperBound]);
	        }
	      } else {
	        var value = nextProps.value !== undefined ? nextProps.value : upperBound;
	        var nextValue = this.trimAlignValue(value, nextProps);
	        if (nextValue === upperBound && lowerBound === nextProps.min) return;
	
	        this.setState({
	          upperBound: nextValue,
	          lowerBound: nextProps.min
	        });
	        if (this.isValueOutOfBounds(upperBound, nextProps)) {
	          this.props.onChange(nextValue);
	        }
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(state) {
	      var props = this.props;
	      var isNotControlled = !('value' in props);
	      if (isNotControlled) {
	        this.setState(state);
	      } else if (state.handle) {
	        this.setState({ handle: state.handle });
	      }
	
	      var data = _extends({}, this.state, state);
	      var changedValue = props.range ? [data.lowerBound, data.upperBound] : data.upperBound;
	      props.onChange(changedValue);
	    }
	  }, {
	    key: 'onMouseMove',
	    value: function onMouseMove(e) {
	      var position = getMousePosition(this.props.vertical, e);
	      this.onMove(e, position);
	    }
	  }, {
	    key: 'onTouchMove',
	    value: function onTouchMove(e) {
	      if (isNotTouchEvent(e)) {
	        this.end('touch');
	        return;
	      }
	
	      var position = getTouchPosition(this.props.vertical, e);
	      this.onMove(e, position);
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(e, position) {
	      pauseEvent(e);
	      var props = this.props;
	      var state = this.state;
	
	      var diffPosition = position - this.startPosition;
	      diffPosition = this.props.vertical ? -diffPosition : diffPosition;
	      var diffValue = diffPosition / this.getSliderLength() * (props.max - props.min);
	
	      var value = this.trimAlignValue(this.startValue + diffValue);
	      var oldValue = state[state.handle];
	      if (value === oldValue) return;
	
	      if (props.allowCross && value < state.lowerBound && state.handle === 'upperBound') {
	        this.onChange({
	          handle: 'lowerBound',
	          lowerBound: value,
	          upperBound: this.state.lowerBound
	        });
	        return;
	      }
	      if (props.allowCross && value > state.upperBound && state.handle === 'lowerBound') {
	        this.onChange({
	          handle: 'upperBound',
	          upperBound: value,
	          lowerBound: this.state.upperBound
	        });
	        return;
	      }
	
	      this.onChange(_defineProperty({}, state.handle, value));
	    }
	  }, {
	    key: 'onTouchStart',
	    value: function onTouchStart(e) {
	      if (isNotTouchEvent(e)) return;
	
	      var position = getTouchPosition(this.props.vertical, e);
	      this.onStart(position);
	      this.addDocumentEvents('touch');
	      pauseEvent(e);
	    }
	  }, {
	    key: 'onMouseDown',
	    value: function onMouseDown(e) {
	      if (e.button !== 0) {
	        return;
	      }
	      var position = getMousePosition(this.props.vertical, e);
	      this.onStart(position);
	      this.addDocumentEvents('mouse');
	      pauseEvent(e);
	    }
	  }, {
	    key: 'onStart',
	    value: function onStart(position) {
	      var props = this.props;
	      props.onBeforeChange(this.getValue());
	
	      var value = this.calcValueByPos(position);
	      this.startValue = value;
	      this.startPosition = position;
	
	      var state = this.state;
	      var upperBound = state.upperBound;
	      var lowerBound = state.lowerBound;
	
	      var valueNeedChanging = 'upperBound';
	      if (this.props.range) {
	        var isLowerBoundCloser = Math.abs(upperBound - value) > Math.abs(lowerBound - value);
	        if (isLowerBoundCloser) {
	          valueNeedChanging = 'lowerBound';
	        }
	
	        var isAtTheSamePoint = upperBound === lowerBound;
	        if (isAtTheSamePoint) {
	          valueNeedChanging = state.recent;
	        }
	
	        if (isAtTheSamePoint && value !== upperBound) {
	          valueNeedChanging = value < upperBound ? 'lowerBound' : 'upperBound';
	        }
	      }
	
	      this.setState({
	        handle: valueNeedChanging,
	        recent: valueNeedChanging
	      });
	
	      var oldValue = state[valueNeedChanging];
	      if (value === oldValue) return;
	
	      this.onChange(_defineProperty({}, valueNeedChanging, value));
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      var _state2 = this.state;
	      var lowerBound = _state2.lowerBound;
	      var upperBound = _state2.upperBound;
	
	      return this.props.range ? [lowerBound, upperBound] : upperBound;
	    }
	  }, {
	    key: 'getSliderLength',
	    value: function getSliderLength() {
	      var slider = this.refs.slider;
	      if (!slider) {
	        return 0;
	      }
	
	      return this.props.vertical ? slider.clientHeight : slider.clientWidth;
	    }
	  }, {
	    key: 'getSliderStart',
	    value: function getSliderStart() {
	      var slider = this.refs.slider;
	      var rect = slider.getBoundingClientRect();
	
	      return this.props.vertical ? rect.top : rect.left;
	    }
	  }, {
	    key: 'getPrecision',
	    value: function getPrecision(step) {
	      var stepString = step.toString();
	      var precision = 0;
	      if (stepString.indexOf('.') >= 0) {
	        precision = stepString.length - stepString.indexOf('.') - 1;
	      }
	      return precision;
	    }
	  }, {
	    key: 'isValueOutOfBounds',
	    value: function isValueOutOfBounds(value, props) {
	      return value < props.min || value > props.max;
	    }
	  }, {
	    key: 'trimAlignValue',
	    value: function trimAlignValue(v, nextProps) {
	      var state = this.state || {};
	      var handle = state.handle;
	      var lowerBound = state.lowerBound;
	      var upperBound = state.upperBound;
	
	      var _extends2 = _extends({}, this.props, nextProps || {});
	
	      var marks = _extends2.marks;
	      var step = _extends2.step;
	      var min = _extends2.min;
	      var max = _extends2.max;
	      var allowCross = _extends2.allowCross;
	
	      var val = v;
	      if (val <= min) {
	        val = min;
	      }
	      if (val >= max) {
	        val = max;
	      }
	      if (!allowCross && handle === 'upperBound' && val <= lowerBound) {
	        val = lowerBound;
	      }
	      if (!allowCross && handle === 'lowerBound' && val >= upperBound) {
	        val = upperBound;
	      }
	
	      var points = Object.keys(marks).map(parseFloat);
	      if (step !== null) {
	        var closestStep = Math.round((val - min) / step) * step + min;
	        points.push(closestStep);
	      }
	
	      var diffs = points.map(function (point) {
	        return Math.abs(val - point);
	      });
	      var closestPoint = points[diffs.indexOf(Math.min.apply(Math, diffs))];
	
	      return step !== null ? parseFloat(closestPoint.toFixed(this.getPrecision(step))) : closestPoint;
	    }
	  }, {
	    key: 'calcOffset',
	    value: function calcOffset(value) {
	      var _props = this.props;
	      var min = _props.min;
	      var max = _props.max;
	
	      var ratio = (value - min) / (max - min);
	      return ratio * 100;
	    }
	  }, {
	    key: 'calcValue',
	    value: function calcValue(offset) {
	      var _props2 = this.props;
	      var vertical = _props2.vertical;
	      var min = _props2.min;
	      var max = _props2.max;
	
	      var ratio = Math.abs(offset / this.getSliderLength());
	      var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
	      return value;
	    }
	  }, {
	    key: 'calcValueByPos',
	    value: function calcValueByPos(position) {
	      var pixelOffset = position - this.getSliderStart();
	      var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
	      return nextValue;
	    }
	  }, {
	    key: 'addDocumentEvents',
	    value: function addDocumentEvents(type) {
	      if (type === 'touch') {
	        // just work for chrome iOS Safari and Android Browser
	        this.onTouchMoveListener = (0, _rcUtilLibDomAddEventListener2['default'])(document, 'touchmove', this.onTouchMove.bind(this));
	        this.onTouchUpListener = (0, _rcUtilLibDomAddEventListener2['default'])(document, 'touchend', this.end.bind(this, 'touch'));
	      } else if (type === 'mouse') {
	        this.onMouseMoveListener = (0, _rcUtilLibDomAddEventListener2['default'])(document, 'mousemove', this.onMouseMove.bind(this));
	        this.onMouseUpListener = (0, _rcUtilLibDomAddEventListener2['default'])(document, 'mouseup', this.end.bind(this, 'mouse'));
	      }
	    }
	  }, {
	    key: 'removeEvents',
	    value: function removeEvents(type) {
	      if (type === 'touch') {
	        this.onTouchMoveListener.remove();
	        this.onTouchUpListener.remove();
	      } else if (type === 'mouse') {
	        this.onMouseMoveListener.remove();
	        this.onMouseUpListener.remove();
	      }
	    }
	  }, {
	    key: 'end',
	    value: function end(type) {
	      this.removeEvents(type);
	      this.props.onAfterChange(this.getValue());
	      this.setState({ handle: null });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames, _classNames2, _classNames3;
	
	      var _state3 = this.state;
	      var handle = _state3.handle;
	      var upperBound = _state3.upperBound;
	      var lowerBound = _state3.lowerBound;
	      var _props3 = this.props;
	      var className = _props3.className;
	      var prefixCls = _props3.prefixCls;
	      var disabled = _props3.disabled;
	      var vertical = _props3.vertical;
	      var dots = _props3.dots;
	      var included = _props3.included;
	      var range = _props3.range;
	      var step = _props3.step;
	      var marks = _props3.marks;
	      var max = _props3.max;
	      var min = _props3.min;
	      var tipTransitionName = _props3.tipTransitionName;
	      var tipFormatter = _props3.tipFormatter;
	      var children = _props3.children;
	
	      var customHandle = this.props.handle;
	
	      var upperOffset = this.calcOffset(upperBound);
	      var lowerOffset = this.calcOffset(lowerBound);
	
	      var handleClassName = prefixCls + '-handle';
	
	      var upperClassName = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, handleClassName, true), _defineProperty(_classNames, handleClassName + '-upper', true), _classNames));
	
	      var lowerClassName = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, handleClassName, true), _defineProperty(_classNames2, handleClassName + '-lower', true), _classNames2));
	
	      var isNoTip = step === null || tipFormatter === null;
	
	      var commonHandleProps = {
	        prefixCls: prefixCls,
	        noTip: isNoTip,
	        tipTransitionName: tipTransitionName,
	        tipFormatter: tipFormatter,
	        vertical: vertical
	      };
	
	      var upper = (0, _react.cloneElement)(customHandle, _extends({}, commonHandleProps, {
	        className: upperClassName,
	        value: upperBound,
	        offset: upperOffset,
	        dragging: handle === 'upperBound'
	      }));
	
	      var lower = null;
	      if (range) {
	        lower = (0, _react.cloneElement)(customHandle, _extends({}, commonHandleProps, {
	          className: lowerClassName,
	          value: lowerBound,
	          offset: lowerOffset,
	          dragging: handle === 'lowerBound'
	        }));
	      }
	
	      var sliderClassName = (0, _classnames2['default'])((_classNames3 = {}, _defineProperty(_classNames3, prefixCls, true), _defineProperty(_classNames3, prefixCls + '-disabled', disabled), _defineProperty(_classNames3, className, !!className), _defineProperty(_classNames3, prefixCls + '-vertical', this.props.vertical), _classNames3));
	      var isIncluded = included || range;
	      return _react2['default'].createElement(
	        'div',
	        { ref: 'slider', className: sliderClassName,
	          onTouchStart: disabled ? noop : this.onTouchStart.bind(this),
	          onMouseDown: disabled ? noop : this.onMouseDown.bind(this)
	        },
	        upper,
	        lower,
	        _react2['default'].createElement(_Track2['default'], { className: prefixCls + '-track', vertical: vertical, included: isIncluded,
	          offset: lowerOffset, length: upperOffset - lowerOffset }),
	        _react2['default'].createElement(_Steps2['default'], { prefixCls: prefixCls, vertical: vertical, marks: marks, dots: dots, step: step,
	          included: isIncluded, lowerBound: lowerBound,
	          upperBound: upperBound, max: max, min: min }),
	        _react2['default'].createElement(_Marks2['default'], { className: prefixCls + '-mark', vertical: vertical, marks: marks,
	          included: isIncluded, lowerBound: lowerBound,
	          upperBound: upperBound, max: max, min: min }),
	        children
	      );
	    }
	  }]);
	
	  return Slider;
	})(_react2['default'].Component);
	
	Slider.propTypes = {
	  min: _react2['default'].PropTypes.number,
	  max: _react2['default'].PropTypes.number,
	  step: _react2['default'].PropTypes.number,
	  defaultValue: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.number)]),
	  value: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.number)]),
	  marks: _react2['default'].PropTypes.object,
	  included: _react2['default'].PropTypes.bool,
	  className: _react2['default'].PropTypes.string,
	  prefixCls: _react2['default'].PropTypes.string,
	  disabled: _react2['default'].PropTypes.bool,
	  children: _react2['default'].PropTypes.any,
	  onBeforeChange: _react2['default'].PropTypes.func,
	  onChange: _react2['default'].PropTypes.func,
	  onAfterChange: _react2['default'].PropTypes.func,
	  handle: _react2['default'].PropTypes.element,
	  tipTransitionName: _react2['default'].PropTypes.string,
	  tipFormatter: _react2['default'].PropTypes.func,
	  dots: _react2['default'].PropTypes.bool,
	  range: _react2['default'].PropTypes.bool,
	  vertical: _react2['default'].PropTypes.bool,
	  allowCross: _react2['default'].PropTypes.bool
	};
	
	Slider.defaultProps = {
	  prefixCls: 'rc-slider',
	  className: '',
	  tipTransitionName: '',
	  min: 0,
	  max: 100,
	  step: 1,
	  marks: {},
	  handle: _react2['default'].createElement(_Handle2['default'], null),
	  onBeforeChange: noop,
	  onChange: noop,
	  onAfterChange: noop,
	  tipFormatter: function tipFormatter(value) {
	    return value;
	  },
	  included: true,
	  disabled: false,
	  dots: false,
	  range: false,
	  vertical: false,
	  allowCross: true
	};
	
	exports['default'] = Slider;
	module.exports = exports['default'];

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(7);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function calcPoints(vertical, marks, dots, step, min, max) {
	  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
	  var points = Object.keys(marks).map(parseFloat);
	  if (dots) {
	    for (var i = min; i <= max; i = i + step) {
	      if (points.indexOf(i) >= 0) continue;
	      points.push(i);
	    }
	  }
	  return points;
	}
	
	var Steps = function Steps(_ref) {
	  var prefixCls = _ref.prefixCls;
	  var vertical = _ref.vertical;
	  var marks = _ref.marks;
	  var dots = _ref.dots;
	  var step = _ref.step;
	  var included = _ref.included;
	  var lowerBound = _ref.lowerBound;
	  var upperBound = _ref.upperBound;
	  var max = _ref.max;
	  var min = _ref.min;
	
	  var range = max - min;
	  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
	    var _classNames;
	
	    var offset = Math.abs(point - min) / range * 100 + '%';
	    var style = vertical ? { bottom: offset } : { left: offset };
	
	    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var pointClassName = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefixCls + '-dot', true), _defineProperty(_classNames, prefixCls + '-dot-active', isActived), _classNames));
	
	    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: prefixCls + '-step' },
	    elements
	  );
	};
	
	exports['default'] = Steps;
	module.exports = exports['default'];

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Track = function Track(_ref) {
	  var className = _ref.className;
	  var included = _ref.included;
	  var vertical = _ref.vertical;
	  var offset = _ref.offset;
	  var length = _ref.length;
	
	  var style = {
	    visibility: included ? 'visible' : 'hidden'
	  };
	  if (vertical) {
	    style.bottom = offset + '%';
	    style.height = length + '%';
	  } else {
	    style.left = offset + '%';
	    style.width = length + '%';
	  }
	  return _react2['default'].createElement('div', { className: className, style: style });
	};
	
	exports['default'] = Track;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(230);

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _placements = __webpack_require__(236);
	
	var _rcTrigger = __webpack_require__(240);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tooltip = _react2["default"].createClass({
	  displayName: 'Tooltip',
	
	  propTypes: {
	    trigger: _react.PropTypes.any,
	    children: _react.PropTypes.any,
	    defaultVisible: _react.PropTypes.bool,
	    visible: _react.PropTypes.bool,
	    placement: _react.PropTypes.string,
	    transitionName: _react.PropTypes.string,
	    animation: _react.PropTypes.any,
	    onVisibleChange: _react.PropTypes.func,
	    afterVisibleChange: _react.PropTypes.func,
	    overlay: _react.PropTypes.oneOfType([_react2["default"].PropTypes.node, _react2["default"].PropTypes.func]).isRequired,
	    overlayStyle: _react.PropTypes.object,
	    overlayClassName: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    mouseEnterDelay: _react.PropTypes.number,
	    mouseLeaveDelay: _react.PropTypes.number,
	    getTooltipContainer: _react.PropTypes.func,
	    destroyTooltipOnHide: _react.PropTypes.bool,
	    align: _react.PropTypes.object,
	    arrowContent: _react.PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-tooltip',
	      mouseEnterDelay: 0,
	      destroyTooltipOnHide: false,
	      mouseLeaveDelay: 0.1,
	      align: {},
	      placement: 'right',
	      trigger: ['hover'],
	      arrowContent: null
	    };
	  },
	  getPopupElement: function getPopupElement() {
	    var _props = this.props;
	    var arrowContent = _props.arrowContent;
	    var overlay = _props.overlay;
	    var prefixCls = _props.prefixCls;
	
	    return [_react2["default"].createElement(
	      'div',
	      { className: prefixCls + '-arrow', key: 'arrow' },
	      arrowContent
	    ), _react2["default"].createElement(
	      'div',
	      { className: prefixCls + '-inner', key: 'content' },
	      typeof overlay === 'function' ? overlay() : overlay
	    )];
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    return this.refs.trigger.getPopupDomNode();
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var overlayClassName = _props2.overlayClassName;
	    var trigger = _props2.trigger;
	    var mouseEnterDelay = _props2.mouseEnterDelay;
	    var mouseLeaveDelay = _props2.mouseLeaveDelay;
	    var overlayStyle = _props2.overlayStyle;
	    var prefixCls = _props2.prefixCls;
	    var children = _props2.children;
	    var onVisibleChange = _props2.onVisibleChange;
	    var transitionName = _props2.transitionName;
	    var animation = _props2.animation;
	    var placement = _props2.placement;
	    var align = _props2.align;
	    var destroyTooltipOnHide = _props2.destroyTooltipOnHide;
	    var defaultVisible = _props2.defaultVisible;
	    var getTooltipContainer = _props2.getTooltipContainer;
	
	    var restProps = _objectWithoutProperties(_props2, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = _extends({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2["default"].createElement(
	      _rcTrigger2["default"],
	      _extends({
	        popupClassName: overlayClassName,
	        ref: 'trigger',
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  }
	});
	
	exports["default"] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(234);

/***/ },
/* 236 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports["default"] = placements;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(5);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(221);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(227);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(238);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(42);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Popup = _react2["default"].createClass({
	  displayName: 'Popup',
	
	  propTypes: {
	    visible: _react.PropTypes.bool,
	    style: _react.PropTypes.object,
	    getClassNameFromAlign: _react.PropTypes.func,
	    onAlign: _react.PropTypes.func,
	    getRootDomNode: _react.PropTypes.func,
	    onMouseEnter: _react.PropTypes.func,
	    align: _react.PropTypes.any,
	    destroyPopupOnHide: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    onMouseLeave: _react.PropTypes.func
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	  },
	  onAlign: function onAlign(popupDomNode, align) {
	    var props = this.props;
	    var alignClassName = props.getClassNameFromAlign(props.align);
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    if (alignClassName !== currentAlignClassName) {
	      this.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = this.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    return _reactDom2["default"].findDOMNode(this.refs.popup);
	  },
	  getTarget: function getTarget() {
	    return this.props.getRootDomNode();
	  },
	  getMaskTransitionName: function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  },
	  getTransitionName: function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  },
	  getClassName: function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  },
	  getPopupElement: function getPopupElement() {
	    var props = this.props;
	    var align = props.align,
	        style = props.style,
	        visible = props.visible,
	        prefixCls = props.prefixCls,
	        destroyPopupOnHide = props.destroyPopupOnHide;
	
	    var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	    var newStyle = (0, _extends3["default"])({}, style, this.getZIndexStyle());
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: 'popup',
	      onMouseEnter: props.onMouseEnter,
	      onMouseLeave: props.onMouseLeave,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2["default"].createElement(
	        _rcAnimate2["default"],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2["default"].createElement(
	          _rcAlign2["default"],
	          {
	            target: this.getTarget,
	            key: 'popup',
	            ref: this.saveAlign,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2["default"].createElement(
	            _PopupInner2["default"],
	            (0, _extends3["default"])({
	              visible: true
	            }, popupInnerProps),
	            props.children
	          )
	        ) : null
	      );
	    }
	    return _react2["default"].createElement(
	      _rcAnimate2["default"],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2["default"].createElement(
	        _rcAlign2["default"],
	        {
	          target: this.getTarget,
	          key: 'popup',
	          ref: this.saveAlign,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2["default"].createElement(
	          _PopupInner2["default"],
	          (0, _extends3["default"])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          props.children
	        )
	      )
	    );
	  },
	  getZIndexStyle: function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  },
	  getMaskElement: function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2["default"].createElement(_LazyRenderBox2["default"], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2["default"].createElement(
	          _rcAnimate2["default"],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  },
	  saveAlign: function saveAlign(align) {
	    this.alignInstance = align;
	  },
	  render: function render() {
	    return _react2["default"].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  }
	});
	
	exports["default"] = Popup;
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LazyRenderBox = __webpack_require__(42);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var PopupInner = _react2["default"].createClass({
	  displayName: 'PopupInner',
	
	  propTypes: {
	    hiddenClassName: _react.PropTypes.string,
	    className: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    onMouseEnter: _react.PropTypes.func,
	    onMouseLeave: _react.PropTypes.func,
	    children: _react.PropTypes.any
	  },
	  render: function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2["default"].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        style: props.style
	      },
	      _react2["default"].createElement(
	        _LazyRenderBox2["default"],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  }
	});
	
	exports["default"] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(5);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _contains = __webpack_require__(243);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(242);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _Popup = __webpack_require__(237);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _utils = __webpack_require__(241);
	
	var _getContainerRenderMixin = __webpack_require__(244);
	
	var _getContainerRenderMixin2 = _interopRequireDefault(_getContainerRenderMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];
	
	var Trigger = _react2["default"].createClass({
	  displayName: 'Trigger',
	
	  propTypes: {
	    children: _react.PropTypes.any,
	    action: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
	    showAction: _react.PropTypes.any,
	    hideAction: _react.PropTypes.any,
	    getPopupClassNameFromAlign: _react.PropTypes.any,
	    onPopupVisibleChange: _react.PropTypes.func,
	    afterPopupVisibleChange: _react.PropTypes.func,
	    popup: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]).isRequired,
	    popupStyle: _react.PropTypes.object,
	    prefixCls: _react.PropTypes.string,
	    popupClassName: _react.PropTypes.string,
	    popupPlacement: _react.PropTypes.string,
	    builtinPlacements: _react.PropTypes.object,
	    popupTransitionName: _react.PropTypes.string,
	    popupAnimation: _react.PropTypes.any,
	    mouseEnterDelay: _react.PropTypes.number,
	    mouseLeaveDelay: _react.PropTypes.number,
	    zIndex: _react.PropTypes.number,
	    focusDelay: _react.PropTypes.number,
	    blurDelay: _react.PropTypes.number,
	    getPopupContainer: _react.PropTypes.func,
	    getDocument: _react.PropTypes.func,
	    destroyPopupOnHide: _react.PropTypes.bool,
	    mask: _react.PropTypes.bool,
	    maskClosable: _react.PropTypes.bool,
	    onPopupAlign: _react.PropTypes.func,
	    popupAlign: _react.PropTypes.object,
	    popupVisible: _react.PropTypes.bool,
	    maskTransitionName: _react.PropTypes.string,
	    maskAnimation: _react.PropTypes.string
	  },
	
	  mixins: [(0, _getContainerRenderMixin2["default"])({
	    autoMount: false,
	
	    isVisible: function isVisible(instance) {
	      return instance.state.popupVisible;
	    },
	    getContainer: function getContainer(instance) {
	      var props = instance.props;
	
	      var popupContainer = document.createElement('div');
	      // Make sure default popup container will never cause scrollbar appearing
	      // https://github.com/react-component/trigger/issues/41
	      popupContainer.style.position = 'absolute';
	      popupContainer.style.top = '0';
	      popupContainer.style.left = '0';
	      popupContainer.style.width = '100%';
	      var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(instance)) : props.getDocument().body;
	      mountNode.appendChild(popupContainer);
	      return popupContainer;
	    }
	  })],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-trigger-popup',
	      getPopupClassNameFromAlign: returnEmptyString,
	      getDocument: returnDocument,
	      onPopupVisibleChange: noop,
	      afterPopupVisibleChange: noop,
	      onPopupAlign: noop,
	      popupClassName: '',
	      mouseEnterDelay: 0,
	      mouseLeaveDelay: 0.1,
	      focusDelay: 0,
	      blurDelay: 0.15,
	      popupStyle: {},
	      destroyPopupOnHide: false,
	      popupAlign: {},
	      defaultPopupVisible: false,
	      mask: false,
	      maskClosable: true,
	      action: [],
	      showAction: [],
	      hideAction: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	    return {
	      popupVisible: popupVisible
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var popupVisible = _ref.popupVisible;
	
	    if (popupVisible !== undefined) {
	      this.setState({
	        popupVisible: popupVisible
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    this.renderComponent(null, function () {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    });
	
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && this.isClickToHide()) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2["default"])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2["default"])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    this.fireEvents('onMouseEnter', e);
	    this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    this.fireEvents('onMouseLeave', e);
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onPopupMouseEnter: function onPopupMouseEnter() {
	    this.clearDelayTimer();
	  },
	  onPopupMouseLeave: function onPopupMouseLeave(e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && this._component && (0, _contains2["default"])(this._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onFocus: function onFocus(e) {
	    this.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    this.clearDelayTimer();
	    if (this.isFocusToShow()) {
	      this.focusTime = Date.now();
	      this.delaySetPopupVisible(true, this.props.focusDelay);
	    }
	  },
	  onMouseDown: function onMouseDown(e) {
	    this.fireEvents('onMouseDown', e);
	    this.preClickTime = Date.now();
	  },
	  onTouchStart: function onTouchStart(e) {
	    this.fireEvents('onTouchStart', e);
	    this.preTouchTime = Date.now();
	  },
	  onBlur: function onBlur(e) {
	    this.fireEvents('onBlur', e);
	    this.clearDelayTimer();
	    if (this.isBlurToHide()) {
	      this.delaySetPopupVisible(false, this.props.blurDelay);
	    }
	  },
	  onClick: function onClick(event) {
	    this.fireEvents('onClick', event);
	    // focus will trigger click
	    if (this.focusTime) {
	      var preTime = void 0;
	      if (this.preClickTime && this.preTouchTime) {
	        preTime = Math.min(this.preClickTime, this.preTouchTime);
	      } else if (this.preClickTime) {
	        preTime = this.preClickTime;
	      } else if (this.preTouchTime) {
	        preTime = this.preTouchTime;
	      }
	      if (Math.abs(preTime - this.focusTime) < 20) {
	        return;
	      }
	      this.focusTime = 0;
	    }
	    this.preClickTime = 0;
	    this.preTouchTime = 0;
	    event.preventDefault();
	    var nextVisible = !this.state.popupVisible;
	    if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
	      this.setPopupVisible(!this.state.popupVisible);
	    }
	  },
	  onDocumentClick: function onDocumentClick(event) {
	    if (this.props.mask && !this.props.maskClosable) {
	      return;
	    }
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(this);
	    var popupNode = this.getPopupDomNode();
	    if (!(0, _contains2["default"])(root, target) && !(0, _contains2["default"])(popupNode, target)) {
	      this.close();
	    }
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    // for test
	    if (this._component) {
	      return this._component.isMounted() ? this._component.getPopupDomNode() : null;
	    }
	    return null;
	  },
	  getRootDomNode: function getRootDomNode() {
	    return _reactDom2["default"].findDOMNode(this);
	  },
	  getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
	    var className = [];
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        builtinPlacements = props.builtinPlacements,
	        prefixCls = props.prefixCls;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getPopupClassNameFromAlign)(builtinPlacements, prefixCls, align));
	    }
	    if (props.getPopupClassNameFromAlign) {
	      className.push(props.getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  },
	  getPopupAlign: function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  },
	  getComponent: function getComponent() {
	    var props = this.props,
	        state = this.state;
	
	    var mouseProps = {};
	    if (this.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = this.onPopupMouseEnter;
	    }
	    if (this.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = this.onPopupMouseLeave;
	    }
	    return _react2["default"].createElement(
	      _Popup2["default"],
	      (0, _extends3["default"])({
	        prefixCls: props.prefixCls,
	        destroyPopupOnHide: props.destroyPopupOnHide,
	        visible: state.popupVisible,
	        className: props.popupClassName,
	        action: props.action,
	        align: this.getPopupAlign(),
	        onAlign: props.onPopupAlign,
	        animation: props.popupAnimation,
	        getClassNameFromAlign: this.getPopupClassNameFromAlign
	      }, mouseProps, {
	        getRootDomNode: this.getRootDomNode,
	        style: props.popupStyle,
	        mask: props.mask,
	        zIndex: props.zIndex,
	        transitionName: props.popupTransitionName,
	        maskAnimation: props.maskAnimation,
	        maskTransitionName: props.maskTransitionName
	      }),
	      typeof props.popup === 'function' ? props.popup() : props.popup
	    );
	  },
	  setPopupVisible: function setPopupVisible(popupVisible) {
	    this.clearDelayTimer();
	    if (this.state.popupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({
	          popupVisible: popupVisible
	        });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	  },
	  delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible);
	    }
	  },
	  clearDelayTimer: function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  },
	  clearOutsideHandler: function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  },
	  createTwoChains: function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  },
	  isClickToShow: function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  },
	  isClickToHide: function isClickToHide() {
	    var _props2 = this.props,
	        action = _props2.action,
	        hideAction = _props2.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  },
	  isMouseEnterToShow: function isMouseEnterToShow() {
	    var _props3 = this.props,
	        action = _props3.action,
	        showAction = _props3.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  },
	  isMouseLeaveToHide: function isMouseLeaveToHide() {
	    var _props4 = this.props,
	        action = _props4.action,
	        hideAction = _props4.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  },
	  isFocusToShow: function isFocusToShow() {
	    var _props5 = this.props,
	        action = _props5.action,
	        showAction = _props5.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  },
	  isBlurToHide: function isBlurToHide() {
	    var _props6 = this.props,
	        action = _props6.action,
	        hideAction = _props6.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  },
	  forcePopupAlign: function forcePopupAlign() {
	    if (this.state.popupVisible && this.popupInstance && this.popupInstance.alignInstance) {
	      this.popupInstance.alignInstance.forceAlign();
	    }
	  },
	  fireEvents: function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  },
	  close: function close() {
	    this.setPopupVisible(false);
	  },
	  render: function render() {
	    var props = this.props;
	    var children = props.children;
	    var child = _react2["default"].Children.only(children);
	    var newChildProps = {};
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    return _react2["default"].cloneElement(child, newChildProps);
	  }
	});
	
	exports["default"] = Trigger;
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(239);

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(18);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getPopupClassNameFromAlign = getPopupClassNameFromAlign;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isPointsEq(a1, a2) {
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3["default"])({}, baseAlign, align);
	}
	
	function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}

/***/ },
/* 242 */
223,
/* 243 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = contains;
	function contains(root, n) {
	  var node = n;
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = getContainerRenderMixin;
	
	var _reactDom = __webpack_require__(5);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function defaultGetContainer() {
	  var container = document.createElement('div');
	  document.body.appendChild(container);
	  return container;
	}
	
	function getContainerRenderMixin(config) {
	  var _config$autoMount = config.autoMount,
	      autoMount = _config$autoMount === undefined ? true : _config$autoMount,
	      _config$autoDestroy = config.autoDestroy,
	      autoDestroy = _config$autoDestroy === undefined ? true : _config$autoDestroy,
	      isVisible = config.isVisible,
	      getComponent = config.getComponent,
	      _config$getContainer = config.getContainer,
	      getContainer = _config$getContainer === undefined ? defaultGetContainer : _config$getContainer;
	
	
	  var mixin = void 0;
	
	  function _renderComponent(instance, componentArg, ready) {
	    if (!isVisible || instance._component || isVisible(instance)) {
	      if (!instance._container) {
	        instance._container = getContainer(instance);
	      }
	      var component = void 0;
	      if (instance.getComponent) {
	        component = instance.getComponent(componentArg);
	      } else {
	        component = getComponent(instance, componentArg);
	      }
	      _reactDom2["default"].unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
	        instance._component = this;
	        if (ready) {
	          ready.call(this);
	        }
	      });
	    }
	  }
	
	  if (autoMount) {
	    mixin = _extends({}, mixin, {
	      componentDidMount: function componentDidMount() {
	        _renderComponent(this);
	      },
	      componentDidUpdate: function componentDidUpdate() {
	        _renderComponent(this);
	      }
	    });
	  }
	
	  if (!autoMount || !autoDestroy) {
	    mixin = _extends({}, mixin, {
	      renderComponent: function renderComponent(componentArg, ready) {
	        _renderComponent(this, componentArg, ready);
	      }
	    });
	  }
	
	  function _removeContainer(instance) {
	    if (instance._container) {
	      var container = instance._container;
	      _reactDom2["default"].unmountComponentAtNode(container);
	      container.parentNode.removeChild(container);
	      instance._container = null;
	    }
	  }
	
	  if (autoDestroy) {
	    mixin = _extends({}, mixin, {
	      componentWillUnmount: function componentWillUnmount() {
	        _removeContainer(this);
	      }
	    });
	  } else {
	    mixin = _extends({}, mixin, {
	      removeContainer: function removeContainer() {
	        _removeContainer(this);
	      }
	    });
	  }
	
	  return mixin;
	}
	module.exports = exports['default'];

/***/ },
/* 245 */
223,
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {(function() {
	  var crypt = __webpack_require__(79),
	      utf8 = __webpack_require__(28).utf8,
	      bin = __webpack_require__(28).bin,
	
	  // The core
	  sha1 = function (message) {
	    // Convert to byte array
	    if (message.constructor == String)
	      message = utf8.stringToBytes(message);
	    else if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer == 'function' && Buffer.isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message))
	      message = message.toString();
	
	    // otherwise assume byte array
	
	    var m  = crypt.bytesToWords(message),
	        l  = message.length * 8,
	        w  = [],
	        H0 =  1732584193,
	        H1 = -271733879,
	        H2 = -1732584194,
	        H3 =  271733878,
	        H4 = -1009589776;
	
	    // Padding
	    m[l >> 5] |= 0x80 << (24 - l % 32);
	    m[((l + 64 >>> 9) << 4) + 15] = l;
	
	    for (var i = 0; i < m.length; i += 16) {
	      var a = H0,
	          b = H1,
	          c = H2,
	          d = H3,
	          e = H4;
	
	      for (var j = 0; j < 80; j++) {
	
	        if (j < 16)
	          w[j] = m[i + j];
	        else {
	          var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
	          w[j] = (n << 1) | (n >>> 31);
	        }
	
	        var t = ((H0 << 5) | (H0 >>> 27)) + H4 + (w[j] >>> 0) + (
	                j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 :
	                j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 :
	                j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 :
	                         (H1 ^ H2 ^ H3) - 899497514);
	
	        H4 = H3;
	        H3 = H2;
	        H2 = (H1 << 30) | (H1 >>> 2);
	        H1 = H0;
	        H0 = t;
	      }
	
	      H0 += a;
	      H1 += b;
	      H2 += c;
	      H3 += d;
	      H4 += e;
	    }
	
	    return [H0, H1, H2, H3, H4];
	  },
	
	  // Public API
	  api = function (message, options) {
	    var digestbytes = crypt.wordsToBytes(sha1(message));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	  api._blocksize = 16;
	  api._digestsize = 20;
	
	  module.exports = api;
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50).Buffer))

/***/ },
/* 247 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(10))(418);

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(10))(491);

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ProductsWidget;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProductsController = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _ProductsController2 = _interopRequireDefault(_ProductsController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProductsWidget(props) {
	    return _react2.default.createElement(_ProductsController2.default, props);
	}

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// website.js